// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
  urlSearchParamsBodySerializer,
} from "./client";
import { client } from "./client.gen";
import type {
  DeleteApiConfluenceV1TenantsByTenantIdData,
  DeleteApiConfluenceV1TenantsByTenantIdErrors,
  DeleteApiConfluenceV1TenantsByTenantIdResponses,
  DeleteApiEntraV1TenantsByTenantIdData,
  DeleteApiEntraV1TenantsByTenantIdErrors,
  DeleteApiEntraV1TenantsByTenantIdResponses,
  DeleteApiFreshserviceV1TenantsByTenantIdData,
  DeleteApiFreshserviceV1TenantsByTenantIdErrors,
  DeleteApiFreshserviceV1TenantsByTenantIdResponses,
  DeleteApiJiraV1TenantsByTenantIdData,
  DeleteApiJiraV1TenantsByTenantIdErrors,
  DeleteApiJiraV1TenantsByTenantIdResponses,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
  DeleteApiNotionV1TenantsByTenantIdData,
  DeleteApiNotionV1TenantsByTenantIdErrors,
  DeleteApiNotionV1TenantsByTenantIdResponses,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdData,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
  DeleteApiPlainV1TenantsByTenantIdData,
  DeleteApiPlainV1TenantsByTenantIdErrors,
  DeleteApiPlainV1TenantsByTenantIdResponses,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses,
  DeleteApiSalesforceV1TenantsByTenantIdData,
  DeleteApiSalesforceV1TenantsByTenantIdErrors,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientData,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses,
  DeleteApiSalesforceV1TenantsByTenantIdResponses,
  DeleteApiSecretsVaultV1SecretsBySecretIdData,
  DeleteApiSecretsVaultV1SecretsBySecretIdErrors,
  DeleteApiSecretsVaultV1SecretsBySecretIdResponses,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdData,
  DeleteApiSharepointV1TenantsByTenantIdErrors,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses,
  DeleteApiSlackV1TenantsByTenantIdData,
  DeleteApiSlackV1TenantsByTenantIdErrors,
  DeleteApiSlackV1TenantsByTenantIdResponses,
  DeleteApiTeamsV1TenantsByTenantIdData,
  DeleteApiTeamsV1TenantsByTenantIdErrors,
  DeleteApiTeamsV1TenantsByTenantIdResponses,
  DeleteApiV1AgentSessionsByAgentSessionIdData,
  DeleteApiV1AgentSessionsByAgentSessionIdErrors,
  DeleteApiV1AgentSessionsByAgentSessionIdResponses,
  DeleteApiV1ApiKeysByApiKeyIdData,
  DeleteApiV1ApiKeysByApiKeyIdErrors,
  DeleteApiV1ApiKeysByApiKeyIdResponses,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  DeleteApiV1ChangeRequestsByChangeRequestIdData,
  DeleteApiV1ChangeRequestsByChangeRequestIdErrors,
  DeleteApiV1ChangeRequestsByChangeRequestIdResponses,
  DeleteApiV1CommentsByCommentIdData,
  DeleteApiV1CommentsByCommentIdErrors,
  DeleteApiV1CommentsByCommentIdResponses,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdData,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses,
  DeleteApiV1ExternalInferencesByInferenceIdData,
  DeleteApiV1ExternalInferencesByInferenceIdErrors,
  DeleteApiV1ExternalInferencesByInferenceIdResponses,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdData,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses,
  DeleteApiV1HubspotTenantsByTenantIdData,
  DeleteApiV1HubspotTenantsByTenantIdErrors,
  DeleteApiV1HubspotTenantsByTenantIdResponses,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdData,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses,
  DeleteApiV1JudgesByJudgeIdData,
  DeleteApiV1JudgesByJudgeIdErrors,
  DeleteApiV1JudgesByJudgeIdResponses,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  DeleteApiV1KbSimulationResultsBySimulationResultIdData,
  DeleteApiV1KbSimulationResultsBySimulationResultIdErrors,
  DeleteApiV1KbSimulationResultsBySimulationResultIdResponses,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses,
  DeleteApiV1MachineUsersByMachineUserIdData,
  DeleteApiV1MachineUsersByMachineUserIdErrors,
  DeleteApiV1MachineUsersByMachineUserIdResponses,
  DeleteApiV1OauthApplicationsByOauthApplicationIdData,
  DeleteApiV1OauthApplicationsByOauthApplicationIdErrors,
  DeleteApiV1OauthApplicationsByOauthApplicationIdResponses,
  DeleteApiV1ReposByRepositoryIdBranchesByNameData,
  DeleteApiV1ReposByRepositoryIdBranchesByNameErrors,
  DeleteApiV1ReposByRepositoryIdBranchesByNameResponses,
  DeleteApiV1ServiceNowTenantsByTenantIdData,
  DeleteApiV1ServiceNowTenantsByTenantIdErrors,
  DeleteApiV1ServiceNowTenantsByTenantIdResponses,
  DeleteApiV1SesameEdraAccessData,
  DeleteApiV1SesameEdraAccessErrors,
  DeleteApiV1SesameEdraAccessResponses,
  DeleteApiV1UsersByUserIdData,
  DeleteApiV1UsersByUserIdErrors,
  DeleteApiV1UsersByUserIdResponses,
  DeleteApiV1WorkClaimsByClaimIdData,
  DeleteApiV1WorkClaimsByClaimIdErrors,
  DeleteApiV1WorkClaimsByClaimIdResponses,
  DeleteApiV1WorkspacesByWorkspaceIdData,
  DeleteApiV1WorkspacesByWorkspaceIdErrors,
  DeleteApiV1WorkspacesByWorkspaceIdResponses,
  DeleteApiV1ZendeskTenantsByTenantIdData,
  DeleteApiV1ZendeskTenantsByTenantIdErrors,
  DeleteApiV1ZendeskTenantsByTenantIdResponses,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
  DeleteApiV2DatapointsByDatapointIdData,
  DeleteApiV2DatapointsByDatapointIdErrors,
  DeleteApiV2DatapointsByDatapointIdResponses,
  DeleteApiV2InferenceConversationsByExternalIdData,
  DeleteApiV2InferenceConversationsByExternalIdErrors,
  DeleteApiV2InferenceConversationsByExternalIdResponses,
  DeleteApiV2JudgementsByJudgementIdData,
  DeleteApiV2JudgementsByJudgementIdErrors,
  DeleteApiV2JudgementsByJudgementIdResponses,
  DeleteApiV2JudgesByJudgeIdData,
  DeleteApiV2JudgesByJudgeIdErrors,
  DeleteApiV2JudgesByJudgeIdResponses,
  DeleteApiV2TasksByTaskIdData,
  DeleteApiV2TasksByTaskIdErrors,
  DeleteApiV2TasksByTaskIdResponses,
  DeleteApiV3JudgementsByJudgementIdData,
  DeleteApiV3JudgementsByJudgementIdErrors,
  DeleteApiV3JudgementsByJudgementIdResponses,
  DeleteApiV3KbsByKbIdData,
  DeleteApiV3KbsByKbIdErrors,
  DeleteApiV3KbsByKbIdResponses,
  GetApiConfluenceV1OauthScopesData,
  GetApiConfluenceV1OauthScopesResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesData,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesData,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionData,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses,
  GetApiConfluenceV1TenantsByTenantIdData,
  GetApiConfluenceV1TenantsByTenantIdErrors,
  GetApiConfluenceV1TenantsByTenantIdResponses,
  GetApiConfluenceV1TenantsData,
  GetApiConfluenceV1TenantsErrors,
  GetApiConfluenceV1TenantsResponses,
  GetApiDebugV1GetPoolStatsData,
  GetApiDebugV1GetPoolStatsResponses,
  GetApiDebugV1KeyErrorData,
  GetApiDebugV1KeyErrorResponses,
  GetApiDebugV1LogErrorData,
  GetApiDebugV1LogErrorResponses,
  GetApiDebugV1LogSentryAlertData,
  GetApiDebugV1LogSentryAlertResponses,
  GetApiDebugV1PrintLogsData,
  GetApiDebugV1PrintLogsResponses,
  GetApiDebugV1ReaderPoolCheckData,
  GetApiDebugV1ReaderPoolCheckResponses,
  GetApiDebugV1Return500Data,
  GetApiDebugV1Return500Responses,
  GetApiDebugV1UnwrapErrorData,
  GetApiDebugV1UnwrapErrorResponses,
  GetApiDebugV1ValkeyPingData,
  GetApiDebugV1ValkeyPingResponses,
  GetApiDebugV1ValkeyValuesByKeyData,
  GetApiDebugV1ValkeyValuesByKeyErrors,
  GetApiDebugV1ValkeyValuesByKeyResponses,
  GetApiEntraV1FullTenantsData,
  GetApiEntraV1FullTenantsErrors,
  GetApiEntraV1FullTenantsResponses,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses,
  GetApiEntraV1TenantsByTenantIdActionsGroupsData,
  GetApiEntraV1TenantsByTenantIdActionsGroupsErrors,
  GetApiEntraV1TenantsByTenantIdActionsGroupsResponses,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersData,
  GetApiEntraV1TenantsByTenantIdActionsUsersErrors,
  GetApiEntraV1TenantsByTenantIdActionsUsersResponses,
  GetApiEntraV1TenantsByTenantIdCheckConnectionData,
  GetApiEntraV1TenantsByTenantIdCheckConnectionErrors,
  GetApiEntraV1TenantsByTenantIdCheckConnectionResponses,
  GetApiEntraV1TenantsByTenantIdData,
  GetApiEntraV1TenantsByTenantIdErrors,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightData,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses,
  GetApiEntraV1TenantsByTenantIdProposedActionsData,
  GetApiEntraV1TenantsByTenantIdProposedActionsErrors,
  GetApiEntraV1TenantsByTenantIdProposedActionsResponses,
  GetApiEntraV1TenantsByTenantIdResponses,
  GetApiEntraV1TenantsData,
  GetApiEntraV1TenantsErrors,
  GetApiEntraV1TenantsResponses,
  GetApiFreshserviceV1FullTenantsData,
  GetApiFreshserviceV1FullTenantsErrors,
  GetApiFreshserviceV1FullTenantsResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses,
  GetApiFreshserviceV1TenantsByTenantIdData,
  GetApiFreshserviceV1TenantsByTenantIdErrors,
  GetApiFreshserviceV1TenantsByTenantIdResponses,
  GetApiFreshserviceV1TenantsData,
  GetApiFreshserviceV1TenantsErrors,
  GetApiFreshserviceV1TenantsResponses,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses,
  GetApiJiraV1FullTenantsData,
  GetApiJiraV1FullTenantsErrors,
  GetApiJiraV1FullTenantsResponses,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueData,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesData,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses,
  GetApiJiraV1TenantsByTenantIdCheckConnectionData,
  GetApiJiraV1TenantsByTenantIdCheckConnectionErrors,
  GetApiJiraV1TenantsByTenantIdCheckConnectionResponses,
  GetApiJiraV1TenantsByTenantIdData,
  GetApiJiraV1TenantsByTenantIdErrors,
  GetApiJiraV1TenantsByTenantIdResponses,
  GetApiJiraV1TenantsData,
  GetApiJiraV1TenantsErrors,
  GetApiJiraV1TenantsResponses,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesData,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
  GetApiNotionV1TenantsByTenantIdActionsPagesData,
  GetApiNotionV1TenantsByTenantIdActionsPagesErrors,
  GetApiNotionV1TenantsByTenantIdActionsPagesResponses,
  GetApiNotionV1TenantsByTenantIdCheckConnectionData,
  GetApiNotionV1TenantsByTenantIdCheckConnectionErrors,
  GetApiNotionV1TenantsByTenantIdCheckConnectionResponses,
  GetApiNotionV1TenantsByTenantIdData,
  GetApiNotionV1TenantsByTenantIdErrors,
  GetApiNotionV1TenantsByTenantIdResponses,
  GetApiNotionV1TenantsData,
  GetApiNotionV1TenantsErrors,
  GetApiNotionV1TenantsResponses,
  GetApiOutlookV2SubscriptionsData,
  GetApiOutlookV2SubscriptionsErrors,
  GetApiOutlookV2SubscriptionsResponses,
  GetApiPlainV1FullTenantsData,
  GetApiPlainV1FullTenantsErrors,
  GetApiPlainV1FullTenantsResponses,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesData,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
  GetApiPlainV1TenantsByTenantIdActionsCustomersData,
  GetApiPlainV1TenantsByTenantIdActionsCustomersErrors,
  GetApiPlainV1TenantsByTenantIdActionsCustomersResponses,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses,
  GetApiPlainV1TenantsByTenantIdActionsThreadsData,
  GetApiPlainV1TenantsByTenantIdActionsThreadsErrors,
  GetApiPlainV1TenantsByTenantIdActionsThreadsResponses,
  GetApiPlainV1TenantsByTenantIdCheckConnectionData,
  GetApiPlainV1TenantsByTenantIdCheckConnectionErrors,
  GetApiPlainV1TenantsByTenantIdCheckConnectionResponses,
  GetApiPlainV1TenantsByTenantIdData,
  GetApiPlainV1TenantsByTenantIdErrors,
  GetApiPlainV1TenantsByTenantIdResponses,
  GetApiPlainV1TenantsData,
  GetApiPlainV1TenantsErrors,
  GetApiPlainV1TenantsResponses,
  GetApiPublicOauthV1AuthorizeData,
  GetApiPublicOauthV1AuthorizeErrors,
  GetApiPublicOauthV1AuthorizeResponses,
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData,
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors,
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeResponses,
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoData,
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors,
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoResponses,
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData,
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors,
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationResponses,
  GetApiPublicOauthV1WellKnownOauthAuthorizationServerData,
  GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses,
  GetApiPublicOauthV1WellKnownOpenidConfigurationData,
  GetApiPublicOauthV1WellKnownOpenidConfigurationResponses,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses,
  GetApiPublicV1AgentA2aByAgentKeyAgentData,
  GetApiPublicV1AgentA2aByAgentKeyAgentErrors,
  GetApiPublicV1AgentA2aByAgentKeyAgentResponses,
  GetApiSalesforceV1FullTenantsData,
  GetApiSalesforceV1FullTenantsErrors,
  GetApiSalesforceV1FullTenantsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsData,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesData,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesData,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsData,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesData,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersData,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionData,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyData,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses,
  GetApiSalesforceV1TenantsByTenantIdData,
  GetApiSalesforceV1TenantsByTenantIdErrors,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses,
  GetApiSalesforceV1TenantsByTenantIdResponses,
  GetApiSalesforceV1TenantsData,
  GetApiSalesforceV1TenantsErrors,
  GetApiSalesforceV1TenantsResponses,
  GetApiSecretsVaultV1FullSecretsData,
  GetApiSecretsVaultV1FullSecretsErrors,
  GetApiSecretsVaultV1FullSecretsResponses,
  GetApiSecretsVaultV1SecretsBySecretIdData,
  GetApiSecretsVaultV1SecretsBySecretIdErrors,
  GetApiSecretsVaultV1SecretsBySecretIdResponses,
  GetApiSecretsVaultV1SecretsData,
  GetApiSecretsVaultV1SecretsErrors,
  GetApiSecretsVaultV1SecretsResponses,
  GetApiSecretsVaultV1SecretsValueData,
  GetApiSecretsVaultV1SecretsValueErrors,
  GetApiSecretsVaultV1SecretsValueResponses,
  GetApiSecretsVaultV2SecretsValueData,
  GetApiSecretsVaultV2SecretsValueErrors,
  GetApiSecretsVaultV2SecretsValueResponses,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses,
  GetApiSharepointV1FullTenantsData,
  GetApiSharepointV1FullTenantsErrors,
  GetApiSharepointV1FullTenantsResponses,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses,
  GetApiSharepointV1TenantsByTenantIdAdminAccessData,
  GetApiSharepointV1TenantsByTenantIdAdminAccessErrors,
  GetApiSharepointV1TenantsByTenantIdAdminAccessResponses,
  GetApiSharepointV1TenantsByTenantIdCheckAccessData,
  GetApiSharepointV1TenantsByTenantIdCheckAccessErrors,
  GetApiSharepointV1TenantsByTenantIdCheckAccessResponses,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionData,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses,
  GetApiSharepointV1TenantsByTenantIdData,
  GetApiSharepointV1TenantsByTenantIdErrors,
  GetApiSharepointV1TenantsByTenantIdFolderScopesData,
  GetApiSharepointV1TenantsByTenantIdFolderScopesErrors,
  GetApiSharepointV1TenantsByTenantIdFolderScopesResponses,
  GetApiSharepointV1TenantsByTenantIdResponses,
  GetApiSharepointV1TenantsByTenantIdSitesData,
  GetApiSharepointV1TenantsByTenantIdSitesErrors,
  GetApiSharepointV1TenantsByTenantIdSitesResponses,
  GetApiSharepointV1TenantsData,
  GetApiSharepointV1TenantsErrors,
  GetApiSharepointV1TenantsResponses,
  GetApiSlackV1FullTenantsData,
  GetApiSlackV1FullTenantsErrors,
  GetApiSlackV1FullTenantsResponses,
  GetApiSlackV1OauthScopesData,
  GetApiSlackV1OauthScopesResponses,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsData,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses,
  GetApiSlackV1TenantsByTenantIdCheckConnectionData,
  GetApiSlackV1TenantsByTenantIdCheckConnectionErrors,
  GetApiSlackV1TenantsByTenantIdCheckConnectionResponses,
  GetApiSlackV1TenantsByTenantIdData,
  GetApiSlackV1TenantsByTenantIdErrors,
  GetApiSlackV1TenantsByTenantIdManifestData,
  GetApiSlackV1TenantsByTenantIdManifestErrors,
  GetApiSlackV1TenantsByTenantIdManifestResponses,
  GetApiSlackV1TenantsByTenantIdResponses,
  GetApiSlackV1TenantsData,
  GetApiSlackV1TenantsErrors,
  GetApiSlackV1TenantsResponses,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses,
  GetApiSlackV2TenantsByTenantIdActionsUsersData,
  GetApiSlackV2TenantsByTenantIdActionsUsersErrors,
  GetApiSlackV2TenantsByTenantIdActionsUsersResponses,
  GetApiTeamsV1FullTenantsData,
  GetApiTeamsV1FullTenantsErrors,
  GetApiTeamsV1FullTenantsResponses,
  GetApiTeamsV1TenantsByTenantIdData,
  GetApiTeamsV1TenantsByTenantIdErrors,
  GetApiTeamsV1TenantsByTenantIdIconsData,
  GetApiTeamsV1TenantsByTenantIdIconsErrors,
  GetApiTeamsV1TenantsByTenantIdIconsResponses,
  GetApiTeamsV1TenantsByTenantIdInstallsData,
  GetApiTeamsV1TenantsByTenantIdInstallsErrors,
  GetApiTeamsV1TenantsByTenantIdInstallsResponses,
  GetApiTeamsV1TenantsByTenantIdManifestData,
  GetApiTeamsV1TenantsByTenantIdManifestErrors,
  GetApiTeamsV1TenantsByTenantIdManifestResponses,
  GetApiTeamsV1TenantsByTenantIdResponses,
  GetApiTeamsV1TenantsData,
  GetApiTeamsV1TenantsErrors,
  GetApiTeamsV1TenantsResponses,
  GetApiV1A2aAgentsData,
  GetApiV1A2aAgentsResponses,
  GetApiV1AgentsByAgentKeyData,
  GetApiV1AgentsByAgentKeyErrors,
  GetApiV1AgentsByAgentKeyResponses,
  GetApiV1AgentsData,
  GetApiV1AgentSessionInferenceByAgentSessionIdData,
  GetApiV1AgentSessionInferenceByAgentSessionIdErrors,
  GetApiV1AgentSessionInferenceByAgentSessionIdResponses,
  GetApiV1AgentSessionsByAgentSessionIdData,
  GetApiV1AgentSessionsByAgentSessionIdErrors,
  GetApiV1AgentSessionsByAgentSessionIdResponses,
  GetApiV1AgentSessionsData,
  GetApiV1AgentSessionsErrors,
  GetApiV1AgentSessionsResponses,
  GetApiV1AgentsResponses,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsOverviewsChartsData,
  GetApiV1AnalyticsOverviewsChartsResponses,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsSectionsChartsData,
  GetApiV1AnalyticsSectionsChartsErrors,
  GetApiV1AnalyticsSectionsChartsResponses,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsWorkflowsChartsData,
  GetApiV1AnalyticsWorkflowsChartsErrors,
  GetApiV1AnalyticsWorkflowsChartsResponses,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  GetApiV1ArticleTagsData,
  GetApiV1ArticleTagsErrors,
  GetApiV1ArticleTagsResponses,
  GetApiV1AttachmentsDataByFilePathData,
  GetApiV1AttachmentsDataByFilePathErrors,
  GetApiV1AttachmentsDataByFilePathResponses,
  GetApiV1AuthzOrganizationsByOrgIdData,
  GetApiV1AuthzOrganizationsByOrgIdErrors,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsData,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses,
  GetApiV1AuthzOrganizationsByOrgIdMembersData,
  GetApiV1AuthzOrganizationsByOrgIdMembersErrors,
  GetApiV1AuthzOrganizationsByOrgIdMembersResponses,
  GetApiV1AuthzOrganizationsByOrgIdResponses,
  GetApiV1AuthzOrganizationsByOrgIdRolesData,
  GetApiV1AuthzOrganizationsByOrgIdRolesErrors,
  GetApiV1AuthzOrganizationsByOrgIdRolesResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsData,
  GetApiV1AuthzOrganizationsByOrgIdTeamsErrors,
  GetApiV1AuthzOrganizationsByOrgIdTeamsResponses,
  GetApiV1AuthzOrganizationsData,
  GetApiV1AuthzOrganizationsErrors,
  GetApiV1AuthzOrganizationsResponses,
  GetApiV1BrandingData,
  GetApiV1BrandingResponses,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdData,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
  GetApiV1CalibrationFeedbackDimensionsData,
  GetApiV1CalibrationFeedbackDimensionsErrors,
  GetApiV1CalibrationFeedbackDimensionsResponses,
  GetApiV1CalibrationFeedbackFullDimensionsData,
  GetApiV1CalibrationFeedbackFullDimensionsErrors,
  GetApiV1CalibrationFeedbackFullDimensionsResponses,
  GetApiV1CalibrationFeedbackFullQueueItemsData,
  GetApiV1CalibrationFeedbackFullQueueItemsErrors,
  GetApiV1CalibrationFeedbackFullQueueItemsResponses,
  GetApiV1CalibrationFeedbackFullVerdictsData,
  GetApiV1CalibrationFeedbackFullVerdictsErrors,
  GetApiV1CalibrationFeedbackFullVerdictsResponses,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
  GetApiV1CalibrationFeedbackInferenceDatapointsData,
  GetApiV1CalibrationFeedbackInferenceDatapointsErrors,
  GetApiV1CalibrationFeedbackInferenceDatapointsResponses,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsData,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
  GetApiV1CalibrationFeedbackQueueItemsData,
  GetApiV1CalibrationFeedbackQueueItemsErrors,
  GetApiV1CalibrationFeedbackQueueItemsResponses,
  GetApiV1CalibrationFeedbackQueueItemsTagsData,
  GetApiV1CalibrationFeedbackQueueItemsTagsErrors,
  GetApiV1CalibrationFeedbackQueueItemsTagsResponses,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  GetApiV1CalibrationFeedbackVerdictsData,
  GetApiV1CalibrationFeedbackVerdictsErrors,
  GetApiV1CalibrationFeedbackVerdictsResponses,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  GetApiV1ChangeRequestsByChangeRequestIdData,
  GetApiV1ChangeRequestsByChangeRequestIdErrors,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses,
  GetApiV1ChangeRequestsByChangeRequestIdResponses,
  GetApiV1ChangeRequestsData,
  GetApiV1ChangeRequestsErrors,
  GetApiV1ChangeRequestsResponses,
  GetApiV1ChangeRequestTagsData,
  GetApiV1ChangeRequestTagsErrors,
  GetApiV1ChangeRequestTagsResponses,
  GetApiV1CommentsByCommentIdData,
  GetApiV1CommentsByCommentIdErrors,
  GetApiV1CommentsByCommentIdResponses,
  GetApiV1ConversationsData,
  GetApiV1ConversationsErrors,
  GetApiV1ConversationsGroupByExternalIdData,
  GetApiV1ConversationsGroupByExternalIdErrors,
  GetApiV1ConversationsGroupByExternalIdResponses,
  GetApiV1ConversationsResponses,
  GetApiV1DataDumpConversationsData,
  GetApiV1DataDumpConversationsErrors,
  GetApiV1DataDumpConversationsResponses,
  GetApiV1DatapointEvidenceData,
  GetApiV1DatapointEvidenceErrors,
  GetApiV1DatapointEvidenceResponses,
  GetApiV1EvaluatedInferenceDatapointsData,
  GetApiV1EvaluatedInferenceDatapointsErrors,
  GetApiV1EvaluatedInferenceDatapointsResponses,
  GetApiV1ExternalInferencesByInferenceIdData,
  GetApiV1ExternalInferencesByInferenceIdErrors,
  GetApiV1ExternalInferencesByInferenceIdResponses,
  GetApiV1ExternalInferencesData,
  GetApiV1ExternalInferencesErrors,
  GetApiV1ExternalInferencesResponses,
  GetApiV1FrontendConfigData,
  GetApiV1FrontendConfigResponses,
  GetApiV1FullAgentSessionsData,
  GetApiV1FullAgentSessionsErrors,
  GetApiV1FullAgentSessionsResponses,
  GetApiV1FullApiKeysData,
  GetApiV1FullApiKeysErrors,
  GetApiV1FullApiKeysResponses,
  GetApiV1FullArticleLineRangeCommentThreadsData,
  GetApiV1FullArticleLineRangeCommentThreadsErrors,
  GetApiV1FullArticleLineRangeCommentThreadsResponses,
  GetApiV1FullChangeRequestLineRangeCommentThreadsData,
  GetApiV1FullChangeRequestLineRangeCommentThreadsErrors,
  GetApiV1FullChangeRequestLineRangeCommentThreadsResponses,
  GetApiV1FullChangeRequestsData,
  GetApiV1FullChangeRequestsErrors,
  GetApiV1FullChangeRequestsResponses,
  GetApiV1FullCommentsData,
  GetApiV1FullCommentsErrors,
  GetApiV1FullCommentsResponses,
  GetApiV1FullDataDumpConversationsData,
  GetApiV1FullDataDumpConversationsErrors,
  GetApiV1FullDataDumpConversationsResponses,
  GetApiV1FullDatapointsData,
  GetApiV1FullDatapointsErrors,
  GetApiV1FullDatapointsResponses,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdData,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses,
  GetApiV1FullInferenceDatapointsData,
  GetApiV1FullInferenceDatapointsErrors,
  GetApiV1FullInferenceDatapointsResponses,
  GetApiV1FullKbSimulationCompareData,
  GetApiV1FullKbSimulationCompareErrors,
  GetApiV1FullKbSimulationCompareResponses,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses,
  GetApiV1FullKbSimulationDatapointsData,
  GetApiV1FullKbSimulationDatapointsErrors,
  GetApiV1FullKbSimulationDatapointsResponses,
  GetApiV1FullKbSimulationResultJudgementsData,
  GetApiV1FullKbSimulationResultJudgementsErrors,
  GetApiV1FullKbSimulationResultJudgementsResponses,
  GetApiV1FullKbSimulationResultsBySimulationResultIdData,
  GetApiV1FullKbSimulationResultsBySimulationResultIdErrors,
  GetApiV1FullKbSimulationResultsBySimulationResultIdResponses,
  GetApiV1FullKbSimulationResultsData,
  GetApiV1FullKbSimulationResultsErrors,
  GetApiV1FullKbSimulationResultsResponses,
  GetApiV1FullKbSimulationRunData,
  GetApiV1FullKbSimulationRunErrors,
  GetApiV1FullKbSimulationRunResponses,
  GetApiV1FullOauthApplicationsData,
  GetApiV1FullOauthApplicationsErrors,
  GetApiV1FullOauthApplicationsResponses,
  GetApiV1FullUserAgentSessionsData,
  GetApiV1FullUserAgentSessionsErrors,
  GetApiV1FullUserAgentSessionsResponses,
  GetApiV1FullWorkEventsData,
  GetApiV1FullWorkEventsErrors,
  GetApiV1FullWorkEventsResponses,
  GetApiV1FullWorkflowRunsData,
  GetApiV1FullWorkflowRunsErrors,
  GetApiV1FullWorkflowRunsResponses,
  GetApiV1HubspotFullTenantsData,
  GetApiV1HubspotFullTenantsErrors,
  GetApiV1HubspotFullTenantsResponses,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionData,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses,
  GetApiV1HubspotTenantsByTenantIdData,
  GetApiV1HubspotTenantsByTenantIdErrors,
  GetApiV1HubspotTenantsByTenantIdManifestData,
  GetApiV1HubspotTenantsByTenantIdManifestErrors,
  GetApiV1HubspotTenantsByTenantIdManifestResponses,
  GetApiV1HubspotTenantsByTenantIdResponses,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses,
  GetApiV1HubspotTenantsByTenantIdTicketsData,
  GetApiV1HubspotTenantsByTenantIdTicketsErrors,
  GetApiV1HubspotTenantsByTenantIdTicketsResponses,
  GetApiV1HubspotTenantsData,
  GetApiV1HubspotTenantsErrors,
  GetApiV1HubspotTenantsResponses,
  GetApiV1ImageAttachmentsDownloadByFilePathData,
  GetApiV1ImageAttachmentsDownloadByFilePathErrors,
  GetApiV1ImageAttachmentsDownloadByFilePathResponses,
  GetApiV1InferenceFeedbackData,
  GetApiV1InferenceFeedbackErrors,
  GetApiV1InferenceFeedbackResponses,
  GetApiV1JudgesByJudgeIdData,
  GetApiV1JudgesByJudgeIdErrors,
  GetApiV1JudgesByJudgeIdResponses,
  GetApiV1JudgesData,
  GetApiV1JudgesErrors,
  GetApiV1JudgesResponses,
  GetApiV1KbAttachmentsDownloadByFilePathData,
  GetApiV1KbAttachmentsDownloadByFilePathErrors,
  GetApiV1KbAttachmentsDownloadByFilePathResponses,
  GetApiV1KbSimulationBranchBreakdownStatsData,
  GetApiV1KbSimulationBranchBreakdownStatsErrors,
  GetApiV1KbSimulationBranchBreakdownStatsResponses,
  GetApiV1KbSimulationCommitsData,
  GetApiV1KbSimulationCommitsErrors,
  GetApiV1KbSimulationCommitsResponses,
  GetApiV1KbSimulationCompareSummaryData,
  GetApiV1KbSimulationCompareSummaryErrors,
  GetApiV1KbSimulationCompareSummaryResponses,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  GetApiV1KbSimulationDatapointsData,
  GetApiV1KbSimulationDatapointsErrors,
  GetApiV1KbSimulationDatapointsResponses,
  GetApiV1KbSimulationResultsBySimulationResultIdData,
  GetApiV1KbSimulationResultsBySimulationResultIdErrors,
  GetApiV1KbSimulationResultsBySimulationResultIdResponses,
  GetApiV1KbSimulationResultsData,
  GetApiV1KbSimulationResultsErrors,
  GetApiV1KbSimulationResultsResponses,
  GetApiV1KbsOwnedData,
  GetApiV1KbsOwnedErrors,
  GetApiV1KbsOwnedResponses,
  GetApiV1MachineUsersByMachineUserIdApiKeysData,
  GetApiV1MachineUsersByMachineUserIdApiKeysErrors,
  GetApiV1MachineUsersByMachineUserIdApiKeysResponses,
  GetApiV1MachineUsersByMachineUserIdData,
  GetApiV1MachineUsersByMachineUserIdErrors,
  GetApiV1MachineUsersByMachineUserIdResponses,
  GetApiV1MachineUsersData,
  GetApiV1MachineUsersErrors,
  GetApiV1MachineUsersResponses,
  GetApiV1McpToolsetsData,
  GetApiV1McpToolsetsResponses,
  GetApiV1MetricsChildJudgementData,
  GetApiV1MetricsChildJudgementErrors,
  GetApiV1MetricsChildJudgementResponses,
  GetApiV1OauthApplicationsByOauthApplicationIdData,
  GetApiV1OauthApplicationsByOauthApplicationIdErrors,
  GetApiV1OauthApplicationsByOauthApplicationIdResponses,
  GetApiV1OauthApplicationsData,
  GetApiV1OauthApplicationsErrors,
  GetApiV1OauthApplicationsResponses,
  GetApiV1ObjectArticleByObjectArticleIdData,
  GetApiV1ObjectArticleByObjectArticleIdErrors,
  GetApiV1ObjectArticleByObjectArticleIdResponses,
  GetApiV1ReposByRepositoryIdArticleByRefData,
  GetApiV1ReposByRepositoryIdArticleByRefErrors,
  GetApiV1ReposByRepositoryIdArticleByRefResponses,
  GetApiV1ReposByRepositoryIdBlobByRefData,
  GetApiV1ReposByRepositoryIdBlobByRefErrors,
  GetApiV1ReposByRepositoryIdBlobByRefResponses,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses,
  GetApiV1ReposByRepositoryIdBranchesByNameData,
  GetApiV1ReposByRepositoryIdBranchesByNameErrors,
  GetApiV1ReposByRepositoryIdBranchesByNameResponses,
  GetApiV1ReposByRepositoryIdBranchesData,
  GetApiV1ReposByRepositoryIdBranchesErrors,
  GetApiV1ReposByRepositoryIdBranchesResponses,
  GetApiV1ReposByRepositoryIdCommitByRefData,
  GetApiV1ReposByRepositoryIdCommitByRefErrors,
  GetApiV1ReposByRepositoryIdCommitByRefResponses,
  GetApiV1ReposByRepositoryIdCommitsByRefData,
  GetApiV1ReposByRepositoryIdCommitsByRefErrors,
  GetApiV1ReposByRepositoryIdCommitsByRefResponses,
  GetApiV1ReposByRepositoryIdCompareByBaseheadData,
  GetApiV1ReposByRepositoryIdCompareByBaseheadErrors,
  GetApiV1ReposByRepositoryIdCompareByBaseheadResponses,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses,
  GetApiV1ReposByRepositoryIdTreeByRefData,
  GetApiV1ReposByRepositoryIdTreeByRefErrors,
  GetApiV1ReposByRepositoryIdTreeByRefResponses,
  GetApiV1SearchData,
  GetApiV1SearchErrors,
  GetApiV1SearchResponses,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdArticlesData,
  GetApiV1ServiceNowTenantsByTenantIdArticlesErrors,
  GetApiV1ServiceNowTenantsByTenantIdArticlesResponses,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses,
  GetApiV1ServiceNowTenantsByTenantIdData,
  GetApiV1ServiceNowTenantsByTenantIdErrors,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses,
  GetApiV1ServiceNowTenantsByTenantIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdTagsData,
  GetApiV1ServiceNowTenantsByTenantIdTagsErrors,
  GetApiV1ServiceNowTenantsByTenantIdTagsResponses,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses,
  GetApiV1ServiceNowTenantsByTenantIdTicketsData,
  GetApiV1ServiceNowTenantsByTenantIdTicketsErrors,
  GetApiV1ServiceNowTenantsByTenantIdTicketsResponses,
  GetApiV1ServiceNowTenantsByTenantIdUsersData,
  GetApiV1ServiceNowTenantsByTenantIdUsersErrors,
  GetApiV1ServiceNowTenantsByTenantIdUsersResponses,
  GetApiV1ServiceNowTenantsData,
  GetApiV1ServiceNowTenantsErrors,
  GetApiV1ServiceNowTenantsResponses,
  GetApiV1SesameEdraAccessData,
  GetApiV1SesameEdraAccessErrors,
  GetApiV1SesameEdraAccessResponses,
  GetApiV1TasksByTaskIdFeedbackLabelsData,
  GetApiV1TasksByTaskIdFeedbackLabelsErrors,
  GetApiV1TasksByTaskIdFeedbackLabelsResponses,
  GetApiV1TasksByTaskIdPromptsByPromptIdData,
  GetApiV1TasksByTaskIdPromptsByPromptIdErrors,
  GetApiV1TasksByTaskIdPromptsByPromptIdResponses,
  GetApiV1TasksByTaskIdPromptsData,
  GetApiV1TasksByTaskIdPromptsErrors,
  GetApiV1TasksByTaskIdPromptsResponses,
  GetApiV1UsageStatsAgentsData,
  GetApiV1UsageStatsAgentsErrors,
  GetApiV1UsageStatsAgentsResponses,
  GetApiV1UsersByUserIdData,
  GetApiV1UsersByUserIdErrors,
  GetApiV1UsersByUserIdNotificationSettingsData,
  GetApiV1UsersByUserIdNotificationSettingsErrors,
  GetApiV1UsersByUserIdNotificationSettingsResponses,
  GetApiV1UsersByUserIdResponses,
  GetApiV1UsersData,
  GetApiV1UsersErrors,
  GetApiV1UsersMeData,
  GetApiV1UsersMeResponses,
  GetApiV1UsersResponses,
  GetApiV1WorkEventsByEventIdData,
  GetApiV1WorkEventsByEventIdErrors,
  GetApiV1WorkEventsByEventIdResponses,
  GetApiV1WorkflowAnalyticsEventsData,
  GetApiV1WorkflowAnalyticsEventsErrors,
  GetApiV1WorkflowAnalyticsEventsResponses,
  GetApiV1WorkflowRunsByWorkflowRunIdData,
  GetApiV1WorkflowRunsByWorkflowRunIdErrors,
  GetApiV1WorkflowRunsByWorkflowRunIdResponses,
  GetApiV1WorkflowsData,
  GetApiV1WorkflowsErrors,
  GetApiV1WorkflowsResponses,
  GetApiV1WorkspacesByWorkspaceIdData,
  GetApiV1WorkspacesByWorkspaceIdErrors,
  GetApiV1WorkspacesByWorkspaceIdResponses,
  GetApiV1WorkspacesData,
  GetApiV1WorkspacesErrors,
  GetApiV1WorkspacesResponses,
  GetApiV1ZendeskOauthRedirectUriData,
  GetApiV1ZendeskOauthRedirectUriResponses,
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData,
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors,
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentResponses,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses,
  GetApiV1ZendeskTenantsByTenantIdArticlesData,
  GetApiV1ZendeskTenantsByTenantIdArticlesErrors,
  GetApiV1ZendeskTenantsByTenantIdArticlesResponses,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionData,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses,
  GetApiV1ZendeskTenantsByTenantIdData,
  GetApiV1ZendeskTenantsByTenantIdErrors,
  GetApiV1ZendeskTenantsByTenantIdResponses,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses,
  GetApiV1ZendeskTenantsByTenantIdTicketsData,
  GetApiV1ZendeskTenantsByTenantIdTicketsErrors,
  GetApiV1ZendeskTenantsByTenantIdTicketsResponses,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses,
  GetApiV1ZendeskTenantsByTenantIdUsersData,
  GetApiV1ZendeskTenantsByTenantIdUsersErrors,
  GetApiV1ZendeskTenantsByTenantIdUsersResponses,
  GetApiV1ZendeskTenantsData,
  GetApiV1ZendeskTenantsErrors,
  GetApiV1ZendeskTenantsResponses,
  GetApiV2AttachmentsDataByAttachmentIdByFilenameData,
  GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors,
  GetApiV2AttachmentsDataByAttachmentIdByFilenameResponses,
  GetApiV2FinalizedConversationsData,
  GetApiV2FinalizedConversationsErrors,
  GetApiV2FinalizedConversationsResponses,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdData,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses,
  GetApiV2FullFinalizedConversationsData,
  GetApiV2FullFinalizedConversationsErrors,
  GetApiV2FullFinalizedConversationsResponses,
  GetApiV2FullInferenceConversationInferencesData,
  GetApiV2FullInferenceConversationInferencesErrors,
  GetApiV2FullInferenceConversationInferencesResponses,
  GetApiV2FullInferenceConversationsData,
  GetApiV2FullInferenceConversationsErrors,
  GetApiV2FullInferenceConversationsResponses,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
  GetApiV2InferenceConversationsByExternalIdData,
  GetApiV2InferenceConversationsByExternalIdErrors,
  GetApiV2InferenceConversationsByExternalIdResponses,
  GetApiV2InferenceConversationsData,
  GetApiV2InferenceConversationsErrors,
  GetApiV2InferenceConversationsResponses,
  GetApiV2JudgementsData,
  GetApiV2JudgementsErrors,
  GetApiV2JudgementsResponses,
  GetApiV2JudgesByJudgeIdData,
  GetApiV2JudgesByJudgeIdErrors,
  GetApiV2JudgesByJudgeIdResponses,
  GetApiV2JudgesData,
  GetApiV2JudgesErrors,
  GetApiV2JudgesResponses,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdData,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses,
  GetApiV2KanonicalDatapointsData,
  GetApiV2KanonicalDatapointsErrors,
  GetApiV2KanonicalDatapointsResponses,
  GetApiV2KbsByKbIdData,
  GetApiV2KbsByKbIdEmbeddingSummaryData,
  GetApiV2KbsByKbIdEmbeddingSummaryErrors,
  GetApiV2KbsByKbIdEmbeddingSummaryResponses,
  GetApiV2KbsByKbIdErrors,
  GetApiV2KbsByKbIdResponses,
  GetApiV2MetricsChangeCountsData,
  GetApiV2MetricsChangeCountsErrors,
  GetApiV2MetricsChangeCountsResponses,
  GetApiV2MetricsChangeUsersData,
  GetApiV2MetricsChangeUsersErrors,
  GetApiV2MetricsChangeUsersResponses,
  GetApiV2MetricsTopArticleJudgementData,
  GetApiV2MetricsTopArticleJudgementErrors,
  GetApiV2MetricsTopArticleJudgementResponses,
  GetApiV2MetricsVerificationData,
  GetApiV2MetricsVerificationErrors,
  GetApiV2MetricsVerificationResponses,
  GetApiV2TasksByTaskIdData,
  GetApiV2TasksByTaskIdErrors,
  GetApiV2TasksByTaskIdResponses,
  GetApiV2TasksData,
  GetApiV2TasksErrors,
  GetApiV2TasksResponses,
  GetApiV3DatapointsByDatapointIdData,
  GetApiV3DatapointsByDatapointIdErrors,
  GetApiV3DatapointsByDatapointIdResponses,
  GetApiV3FullJudgementsData,
  GetApiV3FullJudgementsErrors,
  GetApiV3FullJudgementsResponses,
  GetApiV4KbsData,
  GetApiV4KbsErrors,
  GetApiV4KbsResponses,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesData,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses,
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData,
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors,
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdResponses,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsData,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses,
  GetEdraPbOpenapiJsonData,
  GetEdraPbOpenapiJsonResponses,
  GetPublicHealthData,
  GetPublicHealthResponses,
  GetSdkOpenapiJsonData,
  GetSdkOpenapiJsonResponses,
  HeadApiV1AttachmentsMetadataByFilePathData,
  HeadApiV1AttachmentsMetadataByFilePathErrors,
  HeadApiV1AttachmentsMetadataByFilePathResponses,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses,
  PatchApiConfluenceV1TenantsByTenantIdData,
  PatchApiConfluenceV1TenantsByTenantIdErrors,
  PatchApiConfluenceV1TenantsByTenantIdResponses,
  PatchApiEntraV1TenantsByTenantIdData,
  PatchApiEntraV1TenantsByTenantIdErrors,
  PatchApiEntraV1TenantsByTenantIdResponses,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
  PatchApiFreshserviceV1TenantsByTenantIdData,
  PatchApiFreshserviceV1TenantsByTenantIdErrors,
  PatchApiFreshserviceV1TenantsByTenantIdResponses,
  PatchApiJiraV1TenantsByTenantIdData,
  PatchApiJiraV1TenantsByTenantIdErrors,
  PatchApiJiraV1TenantsByTenantIdResponses,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses,
  PatchApiPlainV1TenantsByTenantIdData,
  PatchApiPlainV1TenantsByTenantIdErrors,
  PatchApiPlainV1TenantsByTenantIdResponses,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
  PatchApiSalesforceV1TenantsByTenantIdData,
  PatchApiSalesforceV1TenantsByTenantIdErrors,
  PatchApiSalesforceV1TenantsByTenantIdResponses,
  PatchApiSecretsVaultV1SecretsBySecretIdData,
  PatchApiSecretsVaultV1SecretsBySecretIdErrors,
  PatchApiSecretsVaultV1SecretsBySecretIdResponses,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  PatchApiSharepointV1TenantsByTenantIdData,
  PatchApiSharepointV1TenantsByTenantIdErrors,
  PatchApiSharepointV1TenantsByTenantIdResponses,
  PatchApiSlackV1TenantsByTenantIdData,
  PatchApiSlackV1TenantsByTenantIdErrors,
  PatchApiSlackV1TenantsByTenantIdResponses,
  PatchApiTeamsV1TenantsByTenantIdData,
  PatchApiTeamsV1TenantsByTenantIdErrors,
  PatchApiTeamsV1TenantsByTenantIdResponses,
  PatchApiV1AgentSessionsByAgentSessionIdData,
  PatchApiV1AgentSessionsByAgentSessionIdErrors,
  PatchApiV1AgentSessionsByAgentSessionIdResponses,
  PatchApiV1ApiKeysByApiKeyIdData,
  PatchApiV1ApiKeysByApiKeyIdErrors,
  PatchApiV1ApiKeysByApiKeyIdResponses,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdData,
  PatchApiV1AuthzOrganizationsByOrgIdErrors,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  PatchApiV1ChangeRequestsByChangeRequestIdData,
  PatchApiV1ChangeRequestsByChangeRequestIdErrors,
  PatchApiV1ChangeRequestsByChangeRequestIdResponses,
  PatchApiV1CommentsByCommentIdData,
  PatchApiV1CommentsByCommentIdErrors,
  PatchApiV1CommentsByCommentIdResponses,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdData,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses,
  PatchApiV1ExternalInferencesByInferenceIdData,
  PatchApiV1ExternalInferencesByInferenceIdErrors,
  PatchApiV1ExternalInferencesByInferenceIdResponses,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdData,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses,
  PatchApiV1HubspotTenantsByTenantIdData,
  PatchApiV1HubspotTenantsByTenantIdErrors,
  PatchApiV1HubspotTenantsByTenantIdResponses,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdData,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses,
  PatchApiV1JudgesByJudgeIdData,
  PatchApiV1JudgesByJudgeIdErrors,
  PatchApiV1JudgesByJudgeIdResponses,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
  PatchApiV1KbsByKbIdArticlesByArticleIdData,
  PatchApiV1KbsByKbIdArticlesByArticleIdErrors,
  PatchApiV1KbsByKbIdArticlesByArticleIdResponses,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  PatchApiV1KbSimulationResultsBySimulationResultIdData,
  PatchApiV1KbSimulationResultsBySimulationResultIdErrors,
  PatchApiV1KbSimulationResultsBySimulationResultIdResponses,
  PatchApiV1MachineUsersByMachineUserIdData,
  PatchApiV1MachineUsersByMachineUserIdErrors,
  PatchApiV1MachineUsersByMachineUserIdResponses,
  PatchApiV1OauthApplicationsByOauthApplicationIdData,
  PatchApiV1OauthApplicationsByOauthApplicationIdErrors,
  PatchApiV1OauthApplicationsByOauthApplicationIdResponses,
  PatchApiV1ReposByRepositoryIdBranchesByNameData,
  PatchApiV1ReposByRepositoryIdBranchesByNameErrors,
  PatchApiV1ReposByRepositoryIdBranchesByNameResponses,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdData,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
  PatchApiV1ServiceNowTenantsByTenantIdData,
  PatchApiV1ServiceNowTenantsByTenantIdErrors,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
  PatchApiV1ServiceNowTenantsByTenantIdResponses,
  PatchApiV1SesameEdraAccessData,
  PatchApiV1SesameEdraAccessErrors,
  PatchApiV1SesameEdraAccessResponses,
  PatchApiV1UsersByUserIdNotificationSettingsData,
  PatchApiV1UsersByUserIdNotificationSettingsErrors,
  PatchApiV1UsersByUserIdNotificationSettingsResponses,
  PatchApiV1UsersMeData,
  PatchApiV1UsersMeErrors,
  PatchApiV1UsersMeResponses,
  PatchApiV1WorkflowRunsByWorkflowRunIdData,
  PatchApiV1WorkflowRunsByWorkflowRunIdErrors,
  PatchApiV1WorkflowRunsByWorkflowRunIdResponses,
  PatchApiV1ZendeskTenantsByTenantIdData,
  PatchApiV1ZendeskTenantsByTenantIdErrors,
  PatchApiV1ZendeskTenantsByTenantIdResponses,
  PatchApiV2JudgesByJudgeIdData,
  PatchApiV2JudgesByJudgeIdErrors,
  PatchApiV2JudgesByJudgeIdResponses,
  PatchApiV2TasksByTaskIdData,
  PatchApiV2TasksByTaskIdErrors,
  PatchApiV2TasksByTaskIdResponses,
  PatchApiV3DatapointsByDatapointIdData,
  PatchApiV3DatapointsByDatapointIdErrors,
  PatchApiV3DatapointsByDatapointIdResponses,
  PatchApiV3DatapointsData,
  PatchApiV3DatapointsErrors,
  PatchApiV3DatapointsResponses,
  PatchApiV3KbsByKbIdCrReviewSlaData,
  PatchApiV3KbsByKbIdCrReviewSlaErrors,
  PatchApiV3KbsByKbIdCrReviewSlaResponses,
  PatchApiV3KbsByKbIdData,
  PatchApiV3KbsByKbIdErrors,
  PatchApiV3KbsByKbIdResponses,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesData,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
  PostApiConfluenceV1TenantsByTenantIdCallbackData,
  PostApiConfluenceV1TenantsByTenantIdCallbackErrors,
  PostApiConfluenceV1TenantsByTenantIdCallbackResponses,
  PostApiConfluenceV1TenantsByTenantIdConnectData,
  PostApiConfluenceV1TenantsByTenantIdConnectErrors,
  PostApiConfluenceV1TenantsByTenantIdConnectResponses,
  PostApiConfluenceV1TenantsData,
  PostApiConfluenceV1TenantsErrors,
  PostApiConfluenceV1TenantsResponses,
  PostApiDebugV1BackgroundTaskErrorData,
  PostApiDebugV1BackgroundTaskErrorResponses,
  PostApiDebugV1OpenfgaCheckData,
  PostApiDebugV1OpenfgaCheckErrors,
  PostApiDebugV1OpenfgaCheckResponses,
  PostApiDebugV1OpenfgaReadTuplesData,
  PostApiDebugV1OpenfgaReadTuplesErrors,
  PostApiDebugV1OpenfgaReadTuplesResponses,
  PostApiDebugV1OpenfgaWriteTuplesData,
  PostApiDebugV1OpenfgaWriteTuplesErrors,
  PostApiDebugV1OpenfgaWriteTuplesResponses,
  PostApiDebugV1SearchReindexData,
  PostApiDebugV1SearchReindexErrors,
  PostApiDebugV1SearchReindexResponses,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerData,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses,
  PostApiEntraV1TenantsByTenantIdProposedActionsData,
  PostApiEntraV1TenantsByTenantIdProposedActionsErrors,
  PostApiEntraV1TenantsByTenantIdProposedActionsResponses,
  PostApiEntraV1TenantsData,
  PostApiEntraV1TenantsErrors,
  PostApiEntraV1TenantsResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses,
  PostApiFreshserviceV1TenantsData,
  PostApiFreshserviceV1TenantsErrors,
  PostApiFreshserviceV1TenantsResponses,
  PostApiHubspotV1ActionsCreateThreadOnTicketData,
  PostApiHubspotV1ActionsCreateThreadOnTicketErrors,
  PostApiHubspotV1ActionsCreateThreadOnTicketResponses,
  PostApiHubspotV1ActionsReplyToThreadData,
  PostApiHubspotV1ActionsReplyToThreadErrors,
  PostApiHubspotV1ActionsReplyToThreadResponses,
  PostApiHubspotV1ActionsUpdateNoteData,
  PostApiHubspotV1ActionsUpdateNoteErrors,
  PostApiHubspotV1ActionsUpdateNoteResponses,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteData,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses,
  PostApiJiraV1TenantsData,
  PostApiJiraV1TenantsErrors,
  PostApiJiraV1TenantsResponses,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentData,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses,
  PostApiNotionV1TenantsByTenantIdActionsPagesData,
  PostApiNotionV1TenantsByTenantIdActionsPagesErrors,
  PostApiNotionV1TenantsByTenantIdActionsPagesResponses,
  PostApiNotionV1TenantsByTenantIdCallbackData,
  PostApiNotionV1TenantsByTenantIdCallbackErrors,
  PostApiNotionV1TenantsByTenantIdCallbackResponses,
  PostApiNotionV1TenantsByTenantIdConnectData,
  PostApiNotionV1TenantsByTenantIdConnectErrors,
  PostApiNotionV1TenantsByTenantIdConnectResponses,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses,
  PostApiNotionV1TenantsData,
  PostApiNotionV1TenantsErrors,
  PostApiNotionV1TenantsResponses,
  PostApiOutlookV1ActionsAddEmailAttachmentData,
  PostApiOutlookV1ActionsAddEmailAttachmentErrors,
  PostApiOutlookV1ActionsAddEmailAttachmentResponses,
  PostApiOutlookV1ActionsCopyEmailData,
  PostApiOutlookV1ActionsCopyEmailErrors,
  PostApiOutlookV1ActionsCopyEmailResponses,
  PostApiOutlookV1ActionsCreateDraftData,
  PostApiOutlookV1ActionsCreateDraftErrors,
  PostApiOutlookV1ActionsCreateDraftResponses,
  PostApiOutlookV1ActionsDeleteEmailData,
  PostApiOutlookV1ActionsDeleteEmailErrors,
  PostApiOutlookV1ActionsDeleteEmailResponses,
  PostApiOutlookV1ActionsForwardEmailData,
  PostApiOutlookV1ActionsForwardEmailErrors,
  PostApiOutlookV1ActionsForwardEmailResponses,
  PostApiOutlookV1ActionsGetEmailAttachmentData,
  PostApiOutlookV1ActionsGetEmailAttachmentErrors,
  PostApiOutlookV1ActionsGetEmailAttachmentResponses,
  PostApiOutlookV1ActionsMarkEmailReadData,
  PostApiOutlookV1ActionsMarkEmailReadErrors,
  PostApiOutlookV1ActionsMarkEmailReadResponses,
  PostApiOutlookV1ActionsMoveEmailData,
  PostApiOutlookV1ActionsMoveEmailErrors,
  PostApiOutlookV1ActionsMoveEmailResponses,
  PostApiOutlookV1ActionsRemoveEmailAttachmentData,
  PostApiOutlookV1ActionsRemoveEmailAttachmentErrors,
  PostApiOutlookV1ActionsRemoveEmailAttachmentResponses,
  PostApiOutlookV1ActionsReplyEmailData,
  PostApiOutlookV1ActionsReplyEmailErrors,
  PostApiOutlookV1ActionsReplyEmailResponses,
  PostApiOutlookV1ActionsSendEmailData,
  PostApiOutlookV1ActionsSendEmailErrors,
  PostApiOutlookV1ActionsSendEmailResponses,
  PostApiOutlookV1ActionsSetEmailCategoriesData,
  PostApiOutlookV1ActionsSetEmailCategoriesErrors,
  PostApiOutlookV1ActionsSetEmailCategoriesResponses,
  PostApiOutlookV1ActionsSetEmailFlagData,
  PostApiOutlookV1ActionsSetEmailFlagErrors,
  PostApiOutlookV1ActionsSetEmailFlagResponses,
  PostApiOutlookV1ActionsSetEmailImportanceData,
  PostApiOutlookV1ActionsSetEmailImportanceErrors,
  PostApiOutlookV1ActionsSetEmailImportanceResponses,
  PostApiOutlookV2SubscriptionsData,
  PostApiOutlookV2SubscriptionsErrors,
  PostApiOutlookV2SubscriptionsResponses,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsData,
  PostApiPlainV1TenantsByTenantIdActionsThreadsErrors,
  PostApiPlainV1TenantsByTenantIdActionsThreadsResponses,
  PostApiPlainV1TenantsData,
  PostApiPlainV1TenantsErrors,
  PostApiPlainV1TenantsResponses,
  PostApiPublicFreshserviceV1WebhooksByTenantIdData,
  PostApiPublicFreshserviceV1WebhooksByTenantIdErrors,
  PostApiPublicFreshserviceV1WebhooksByTenantIdResponses,
  PostApiPublicHubspotV1EventsByTenantIdData,
  PostApiPublicHubspotV1EventsByTenantIdErrors,
  PostApiPublicHubspotV1EventsByTenantIdResponses,
  PostApiPublicJiraV1EventsData,
  PostApiPublicJiraV1EventsResponses,
  PostApiPublicNotionV1WebhooksIngestByTenantIdData,
  PostApiPublicNotionV1WebhooksIngestByTenantIdErrors,
  PostApiPublicNotionV1WebhooksIngestByTenantIdResponses,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectData,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectResponses,
  PostApiPublicOauthV1ByOauthApplicationIdTokenData,
  PostApiPublicOauthV1ByOauthApplicationIdTokenErrors,
  PostApiPublicOauthV1ByOauthApplicationIdTokenResponses,
  PostApiPublicOauthV1TokenData,
  PostApiPublicOauthV1TokenResponses,
  PostApiPublicOutlookV2SubscriptionsEventsData,
  PostApiPublicOutlookV2SubscriptionsEventsErrors,
  PostApiPublicOutlookV2SubscriptionsEventsResponses,
  PostApiPublicOutlookV2SubscriptionsLifecycleData,
  PostApiPublicOutlookV2SubscriptionsLifecycleErrors,
  PostApiPublicOutlookV2SubscriptionsLifecycleResponses,
  PostApiPublicPlainV1WebhooksIngestByTenantIdData,
  PostApiPublicPlainV1WebhooksIngestByTenantIdErrors,
  PostApiPublicPlainV1WebhooksIngestByTenantIdResponses,
  PostApiPublicServiceNowV1WebhooksData,
  PostApiPublicServiceNowV1WebhooksErrors,
  PostApiPublicServiceNowV1WebhooksResponses,
  PostApiPublicSharepointV1LifecycleByTenantIdData,
  PostApiPublicSharepointV1LifecycleByTenantIdErrors,
  PostApiPublicSharepointV1LifecycleByTenantIdResponses,
  PostApiPublicSharepointV1NotificationsByTenantIdData,
  PostApiPublicSharepointV1NotificationsByTenantIdErrors,
  PostApiPublicSharepointV1NotificationsByTenantIdResponses,
  PostApiPublicSlackV2TenantsByTenantIdEventsData,
  PostApiPublicSlackV2TenantsByTenantIdEventsErrors,
  PostApiPublicSlackV2TenantsByTenantIdEventsResponses,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityData,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses,
  PostApiPublicV1SalesforceOauthTokenByTenantIdData,
  PostApiPublicV1SalesforceOauthTokenByTenantIdErrors,
  PostApiPublicV1SalesforceOauthTokenByTenantIdResponses,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdData,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdData,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesData,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesData,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
  PostApiSalesforceV1TenantsByTenantIdCallbackData,
  PostApiSalesforceV1TenantsByTenantIdCallbackErrors,
  PostApiSalesforceV1TenantsByTenantIdCallbackResponses,
  PostApiSalesforceV1TenantsByTenantIdConnectData,
  PostApiSalesforceV1TenantsByTenantIdConnectErrors,
  PostApiSalesforceV1TenantsByTenantIdConnectResponses,
  PostApiSalesforceV1TenantsData,
  PostApiSalesforceV1TenantsErrors,
  PostApiSalesforceV1TenantsResponses,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreData,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsData,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses,
  PostApiSecretsVaultV1SecretsData,
  PostApiSecretsVaultV1SecretsErrors,
  PostApiSecretsVaultV1SecretsResponses,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsData,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses,
  PostApiSecretsVaultV2SecretsData,
  PostApiSecretsVaultV2SecretsErrors,
  PostApiSecretsVaultV2SecretsResponses,
  PostApiServiceNowV1ActionsChangeAssignmentGroupData,
  PostApiServiceNowV1ActionsChangeAssignmentGroupErrors,
  PostApiServiceNowV1ActionsChangeAssignmentGroupResponses,
  PostApiServiceNowV1ActionsChangeIncidentStateData,
  PostApiServiceNowV1ActionsChangeIncidentStateErrors,
  PostApiServiceNowV1ActionsChangeIncidentStateResponses,
  PostApiServiceNowV1ActionsReplyData,
  PostApiServiceNowV1ActionsReplyErrors,
  PostApiServiceNowV1ActionsReplyResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchData,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesData,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsData,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses,
  PostApiSharepointV1TenantsByTenantIdCallbackData,
  PostApiSharepointV1TenantsByTenantIdCallbackErrors,
  PostApiSharepointV1TenantsByTenantIdCallbackResponses,
  PostApiSharepointV1TenantsByTenantIdConnectData,
  PostApiSharepointV1TenantsByTenantIdConnectErrors,
  PostApiSharepointV1TenantsByTenantIdConnectResponses,
  PostApiSharepointV1TenantsByTenantIdFolderScopesData,
  PostApiSharepointV1TenantsByTenantIdFolderScopesErrors,
  PostApiSharepointV1TenantsByTenantIdFolderScopesResponses,
  PostApiSharepointV1TenantsByTenantIdSitesData,
  PostApiSharepointV1TenantsByTenantIdSitesErrors,
  PostApiSharepointV1TenantsByTenantIdSitesGrantData,
  PostApiSharepointV1TenantsByTenantIdSitesGrantErrors,
  PostApiSharepointV1TenantsByTenantIdSitesGrantResponses,
  PostApiSharepointV1TenantsByTenantIdSitesResponses,
  PostApiSharepointV1TenantsData,
  PostApiSharepointV1TenantsErrors,
  PostApiSharepointV1TenantsResponses,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenData,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushData,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses,
  PostApiSlackV1TenantsByTenantIdCallbackData,
  PostApiSlackV1TenantsByTenantIdCallbackErrors,
  PostApiSlackV1TenantsByTenantIdCallbackResponses,
  PostApiSlackV1TenantsByTenantIdConnectData,
  PostApiSlackV1TenantsByTenantIdConnectErrors,
  PostApiSlackV1TenantsByTenantIdConnectResponses,
  PostApiSlackV1TenantsData,
  PostApiSlackV1TenantsErrors,
  PostApiSlackV1TenantsResponses,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionData,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses,
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData,
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors,
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadResponses,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadData,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses,
  PostApiTeamsV1TenantsByTenantIdIconsData,
  PostApiTeamsV1TenantsByTenantIdIconsErrors,
  PostApiTeamsV1TenantsByTenantIdIconsResponses,
  PostApiTeamsV1TenantsData,
  PostApiTeamsV1TenantsErrors,
  PostApiTeamsV1TenantsResponses,
  PostApiV1AgentSessionInferenceByAgentSessionIdData,
  PostApiV1AgentSessionInferenceByAgentSessionIdErrors,
  PostApiV1AgentSessionInferenceByAgentSessionIdResponses,
  PostApiV1AgentSessionsByAgentSessionIdMessagesData,
  PostApiV1AgentSessionsByAgentSessionIdMessagesErrors,
  PostApiV1AgentSessionsByAgentSessionIdMessagesResponses,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses,
  PostApiV1AgentSessionsByAgentSessionIdStopData,
  PostApiV1AgentSessionsByAgentSessionIdStopErrors,
  PostApiV1AgentSessionsByAgentSessionIdStopResponses,
  PostApiV1AgentSessionsData,
  PostApiV1AgentSessionsErrors,
  PostApiV1AgentSessionsResponses,
  PostApiV1ApiKeysData,
  PostApiV1ApiKeysErrors,
  PostApiV1ApiKeysResponses,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses,
  PostApiV1ArticleLineRangeCommentThreadsData,
  PostApiV1ArticleLineRangeCommentThreadsErrors,
  PostApiV1ArticleLineRangeCommentThreadsResponses,
  PostApiV1AttachmentsUploadUrlData,
  PostApiV1AttachmentsUploadUrlErrors,
  PostApiV1AttachmentsUploadUrlResponses,
  PostApiV1AuthzKbOwnersSyncData,
  PostApiV1AuthzKbOwnersSyncResponses,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsData,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
  PostApiV1AuthzOrganizationsByOrgIdTeamsData,
  PostApiV1AuthzOrganizationsByOrgIdTeamsErrors,
  PostApiV1AuthzOrganizationsByOrgIdTeamsResponses,
  PostApiV1AuthzSyncArticlesToOpenfgaData,
  PostApiV1AuthzSyncArticlesToOpenfgaErrors,
  PostApiV1AuthzSyncArticlesToOpenfgaResponses,
  PostApiV1BrandingLogoUploadUrlData,
  PostApiV1BrandingLogoUploadUrlErrors,
  PostApiV1BrandingLogoUploadUrlResponses,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses,
  PostApiV1CalibrationFeedbackDimensionsData,
  PostApiV1CalibrationFeedbackDimensionsErrors,
  PostApiV1CalibrationFeedbackDimensionsResponses,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses,
  PostApiV1CalibrationFeedbackInferenceDatapointsData,
  PostApiV1CalibrationFeedbackInferenceDatapointsErrors,
  PostApiV1CalibrationFeedbackInferenceDatapointsResponses,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses,
  PostApiV1CalibrationFeedbackQueueItemsData,
  PostApiV1CalibrationFeedbackQueueItemsErrors,
  PostApiV1CalibrationFeedbackQueueItemsResponses,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses,
  PostApiV1CalibrationFeedbackVerdictsData,
  PostApiV1CalibrationFeedbackVerdictsErrors,
  PostApiV1CalibrationFeedbackVerdictsResponses,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses,
  PostApiV1ChangeRequestLineRangeCommentThreadsData,
  PostApiV1ChangeRequestLineRangeCommentThreadsErrors,
  PostApiV1ChangeRequestLineRangeCommentThreadsResponses,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreData,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses,
  PostApiV1ChangeRequestsData,
  PostApiV1ChangeRequestsErrors,
  PostApiV1ChangeRequestsResponses,
  PostApiV1CommentsByCommentIdRestoreData,
  PostApiV1CommentsByCommentIdRestoreErrors,
  PostApiV1CommentsByCommentIdRestoreResponses,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses,
  PostApiV1DataDumpConversationsData,
  PostApiV1DataDumpConversationsErrors,
  PostApiV1DataDumpConversationsResponses,
  PostApiV1DatapointEvidenceSearchData,
  PostApiV1DatapointEvidenceSearchErrors,
  PostApiV1DatapointEvidenceSearchResponses,
  PostApiV1DatapointsBackfillIndexData,
  PostApiV1DatapointsBackfillIndexErrors,
  PostApiV1DatapointsBackfillIndexResponses,
  PostApiV1DatapointsEmbedData,
  PostApiV1DatapointsEmbedErrors,
  PostApiV1DatapointsEmbedResponses,
  PostApiV1DatapointsRegexSearchData,
  PostApiV1DatapointsRegexSearchErrors,
  PostApiV1DatapointsRegexSearchResponses,
  PostApiV1DatapointsSearchData,
  PostApiV1DatapointsSearchErrors,
  PostApiV1DatapointsSearchResponses,
  PostApiV1ExternalInferencesData,
  PostApiV1ExternalInferencesErrors,
  PostApiV1ExternalInferencesResponses,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses,
  PostApiV1FullEvaluatedInferenceDatapointsSearchData,
  PostApiV1FullEvaluatedInferenceDatapointsSearchErrors,
  PostApiV1FullEvaluatedInferenceDatapointsSearchResponses,
  PostApiV1HubspotTenantsData,
  PostApiV1HubspotTenantsErrors,
  PostApiV1HubspotTenantsResponses,
  PostApiV1ImageAttachmentsUploadUrlData,
  PostApiV1ImageAttachmentsUploadUrlErrors,
  PostApiV1ImageAttachmentsUploadUrlResponses,
  PostApiV1InferenceConversationsByExternalIdRestoreData,
  PostApiV1InferenceConversationsByExternalIdRestoreErrors,
  PostApiV1InferenceConversationsByExternalIdRestoreResponses,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses,
  PostApiV1IngestionKnowledgeBasesIngestionFilesData,
  PostApiV1IngestionKnowledgeBasesIngestionFilesErrors,
  PostApiV1IngestionKnowledgeBasesIngestionFilesResponses,
  PostApiV1IngestionSupportIngestionFilesData,
  PostApiV1IngestionSupportIngestionFilesErrors,
  PostApiV1IngestionSupportIngestionFilesResponses,
  PostApiV1JudgesByJudgeIdRestoreData,
  PostApiV1JudgesByJudgeIdRestoreErrors,
  PostApiV1JudgesByJudgeIdRestoreResponses,
  PostApiV1JudgesData,
  PostApiV1JudgesErrors,
  PostApiV1JudgesResponses,
  PostApiV1JudgesSyncData,
  PostApiV1JudgesSyncResponses,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses,
  PostApiV1KbAttachmentsUploadUrlData,
  PostApiV1KbAttachmentsUploadUrlErrors,
  PostApiV1KbAttachmentsUploadUrlResponses,
  PostApiV1KbsByKbIdEmbeddingSearchData,
  PostApiV1KbsByKbIdEmbeddingSearchErrors,
  PostApiV1KbsByKbIdEmbeddingSearchResponses,
  PostApiV1KbsByKbIdHybridSearchData,
  PostApiV1KbsByKbIdHybridSearchErrors,
  PostApiV1KbsByKbIdHybridSearchResponses,
  PostApiV1KbsByKbIdRegexSearchData,
  PostApiV1KbsByKbIdRegexSearchErrors,
  PostApiV1KbsByKbIdRegexSearchResponses,
  PostApiV1KbsData,
  PostApiV1KbsErrors,
  PostApiV1KbSimulationDatapointsBatchData,
  PostApiV1KbSimulationDatapointsBatchErrors,
  PostApiV1KbSimulationDatapointsBatchResponses,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses,
  PostApiV1KbSimulationDatapointsData,
  PostApiV1KbSimulationDatapointsErrors,
  PostApiV1KbSimulationDatapointsResponses,
  PostApiV1KbSimulationResultJudgementsBatchData,
  PostApiV1KbSimulationResultJudgementsBatchErrors,
  PostApiV1KbSimulationResultJudgementsBatchResponses,
  PostApiV1KbSimulationResultsBatchData,
  PostApiV1KbSimulationResultsBatchErrors,
  PostApiV1KbSimulationResultsBatchResponses,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreData,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses,
  PostApiV1KbSimulationResultsData,
  PostApiV1KbSimulationResultsErrors,
  PostApiV1KbSimulationResultsResponses,
  PostApiV1KbsResponses,
  PostApiV1MachineUsersByMachineUserIdApiKeysData,
  PostApiV1MachineUsersByMachineUserIdApiKeysErrors,
  PostApiV1MachineUsersByMachineUserIdApiKeysResponses,
  PostApiV1MachineUsersData,
  PostApiV1MachineUsersErrors,
  PostApiV1MachineUsersResponses,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses,
  PostApiV1OauthApplicationsData,
  PostApiV1OauthApplicationsErrors,
  PostApiV1OauthApplicationsResponses,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueData,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueData,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses,
  PostApiV1PipelinesCreateInferenceDatapointsInputData,
  PostApiV1PipelinesCreateInferenceDatapointsInputErrors,
  PostApiV1PipelinesCreateInferenceDatapointsInputResponses,
  PostApiV1PipelinesCreateInferenceDatapointsOutputData,
  PostApiV1PipelinesCreateInferenceDatapointsOutputErrors,
  PostApiV1PipelinesCreateInferenceDatapointsOutputResponses,
  PostApiV1PipelinesCreateProdEvalsDequeueData,
  PostApiV1PipelinesCreateProdEvalsDequeueErrors,
  PostApiV1PipelinesCreateProdEvalsDequeueResponses,
  PostApiV1PipelinesCreateProdEvalsEnqueueData,
  PostApiV1PipelinesCreateProdEvalsEnqueueErrors,
  PostApiV1PipelinesCreateProdEvalsEnqueueResponses,
  PostApiV1PipelinesCreateProdEvalsInputData,
  PostApiV1PipelinesCreateProdEvalsInputErrors,
  PostApiV1PipelinesCreateProdEvalsInputResponses,
  PostApiV1PipelinesCreateProdEvalsOutputData,
  PostApiV1PipelinesCreateProdEvalsOutputErrors,
  PostApiV1PipelinesCreateProdEvalsOutputResponses,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueData,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueData,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses,
  PostApiV1PipelinesExtractDataDumpConversationsInputData,
  PostApiV1PipelinesExtractDataDumpConversationsInputErrors,
  PostApiV1PipelinesExtractDataDumpConversationsInputResponses,
  PostApiV1PipelinesExtractDataDumpConversationsOutputData,
  PostApiV1PipelinesExtractDataDumpConversationsOutputErrors,
  PostApiV1PipelinesExtractDataDumpConversationsOutputResponses,
  PostApiV1PipelinesExtractDatapointsDequeueData,
  PostApiV1PipelinesExtractDatapointsDequeueErrors,
  PostApiV1PipelinesExtractDatapointsDequeueResponses,
  PostApiV1PipelinesExtractDatapointsEnqueueData,
  PostApiV1PipelinesExtractDatapointsEnqueueErrors,
  PostApiV1PipelinesExtractDatapointsEnqueueResponses,
  PostApiV1PipelinesExtractDatapointsInputData,
  PostApiV1PipelinesExtractDatapointsInputErrors,
  PostApiV1PipelinesExtractDatapointsInputResponses,
  PostApiV1PipelinesExtractDatapointsOutputData,
  PostApiV1PipelinesExtractDatapointsOutputErrors,
  PostApiV1PipelinesExtractDatapointsOutputResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses,
  PostApiV1PipelinesFinalizeConversationsDequeueData,
  PostApiV1PipelinesFinalizeConversationsDequeueErrors,
  PostApiV1PipelinesFinalizeConversationsDequeueResponses,
  PostApiV1PipelinesFinalizeConversationsEnqueueData,
  PostApiV1PipelinesFinalizeConversationsEnqueueErrors,
  PostApiV1PipelinesFinalizeConversationsEnqueueResponses,
  PostApiV1PipelinesFinalizeConversationsInputData,
  PostApiV1PipelinesFinalizeConversationsInputErrors,
  PostApiV1PipelinesFinalizeConversationsInputResponses,
  PostApiV1PipelinesFinalizeConversationsOutputData,
  PostApiV1PipelinesFinalizeConversationsOutputErrors,
  PostApiV1PipelinesFinalizeConversationsOutputResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputData,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputData,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueData,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueData,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses,
  PostApiV1PipelinesKanonicalizeDatapointsInputData,
  PostApiV1PipelinesKanonicalizeDatapointsInputErrors,
  PostApiV1PipelinesKanonicalizeDatapointsInputResponses,
  PostApiV1PipelinesKanonicalizeDatapointsOutputData,
  PostApiV1PipelinesKanonicalizeDatapointsOutputErrors,
  PostApiV1PipelinesKanonicalizeDatapointsOutputResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreData,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses,
  PostApiV1ReposByRepositoryIdBranchesData,
  PostApiV1ReposByRepositoryIdBranchesErrors,
  PostApiV1ReposByRepositoryIdBranchesResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyData,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses,
  PostApiV1ServiceNowTenantsByTenantIdArticlesData,
  PostApiV1ServiceNowTenantsByTenantIdArticlesErrors,
  PostApiV1ServiceNowTenantsByTenantIdArticlesResponses,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
  PostApiV1ServiceNowTenantsByTenantIdRestoreData,
  PostApiV1ServiceNowTenantsByTenantIdRestoreErrors,
  PostApiV1ServiceNowTenantsByTenantIdRestoreResponses,
  PostApiV1ServiceNowTenantsByTenantIdSetupData,
  PostApiV1ServiceNowTenantsByTenantIdSetupErrors,
  PostApiV1ServiceNowTenantsByTenantIdSetupResponses,
  PostApiV1ServiceNowTenantsByTenantIdTagsData,
  PostApiV1ServiceNowTenantsByTenantIdTagsErrors,
  PostApiV1ServiceNowTenantsByTenantIdTagsResponses,
  PostApiV1ServiceNowTenantsData,
  PostApiV1ServiceNowTenantsErrors,
  PostApiV1ServiceNowTenantsResponses,
  PostApiV1SesameEdraAccessData,
  PostApiV1SesameEdraAccessErrors,
  PostApiV1SesameEdraAccessResponses,
  PostApiV1TasksByTaskIdFeedbackLabelsData,
  PostApiV1TasksByTaskIdFeedbackLabelsErrors,
  PostApiV1TasksByTaskIdFeedbackLabelsResponses,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsData,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses,
  PostApiV1TasksByTaskIdPromptsData,
  PostApiV1TasksByTaskIdPromptsErrors,
  PostApiV1TasksByTaskIdPromptsResponses,
  PostApiV1UsersBotData,
  PostApiV1UsersBotErrors,
  PostApiV1UsersBotResponses,
  PostApiV1UsersByUserIdRestoreData,
  PostApiV1UsersByUserIdRestoreErrors,
  PostApiV1UsersByUserIdRestoreResponses,
  PostApiV1WorkClaimsByClaimIdCompleteData,
  PostApiV1WorkClaimsByClaimIdCompleteErrors,
  PostApiV1WorkClaimsByClaimIdCompleteResponses,
  PostApiV1WorkClaimsData,
  PostApiV1WorkClaimsErrors,
  PostApiV1WorkClaimsResponses,
  PostApiV1WorkEventsData,
  PostApiV1WorkEventsErrors,
  PostApiV1WorkEventsResponses,
  PostApiV1WorkflowAnalyticsEventsData,
  PostApiV1WorkflowAnalyticsEventsErrors,
  PostApiV1WorkflowAnalyticsEventsResponses,
  PostApiV1WorkspacesByWorkspaceIdRestoreData,
  PostApiV1WorkspacesByWorkspaceIdRestoreErrors,
  PostApiV1WorkspacesByWorkspaceIdRestoreResponses,
  PostApiV1WorkspacesData,
  PostApiV1WorkspacesResponses,
  PostApiV1ZendeskTenantsByTenantIdCallbackData,
  PostApiV1ZendeskTenantsByTenantIdCallbackErrors,
  PostApiV1ZendeskTenantsByTenantIdCallbackResponses,
  PostApiV1ZendeskTenantsByTenantIdConnectData,
  PostApiV1ZendeskTenantsByTenantIdConnectErrors,
  PostApiV1ZendeskTenantsByTenantIdConnectResponses,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
  PostApiV1ZendeskTenantsData,
  PostApiV1ZendeskTenantsErrors,
  PostApiV1ZendeskTenantsResponses,
  PostApiV2AttachmentsUploadUrlData,
  PostApiV2AttachmentsUploadUrlErrors,
  PostApiV2AttachmentsUploadUrlResponses,
  PostApiV2ConversationsByExternalIdFeedbackData,
  PostApiV2ConversationsByExternalIdFeedbackErrors,
  PostApiV2ConversationsByExternalIdFeedbackResponses,
  PostApiV2ConversationsByExternalIdMessagesData,
  PostApiV2ConversationsByExternalIdMessagesErrors,
  PostApiV2ConversationsByExternalIdMessagesResponses,
  PostApiV2ConversationsByExternalIdStatefulInferenceData,
  PostApiV2ConversationsByExternalIdStatefulInferenceErrors,
  PostApiV2ConversationsByExternalIdStatefulInferenceResponses,
  PostApiV2ConversationsByExternalIdStatelessInferenceData,
  PostApiV2ConversationsByExternalIdStatelessInferenceErrors,
  PostApiV2ConversationsByExternalIdStatelessInferenceResponses,
  PostApiV2DatapointsByDatapointIdRestoreData,
  PostApiV2DatapointsByDatapointIdRestoreErrors,
  PostApiV2DatapointsByDatapointIdRestoreResponses,
  PostApiV2FinalizedConversationsData,
  PostApiV2FinalizedConversationsErrors,
  PostApiV2FinalizedConversationsResponses,
  PostApiV2InferenceConversationsByExternalIdMessagesData,
  PostApiV2InferenceConversationsByExternalIdMessagesErrors,
  PostApiV2InferenceConversationsByExternalIdMessagesResponses,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceData,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceData,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses,
  PostApiV2InferenceDatapointsData,
  PostApiV2InferenceDatapointsErrors,
  PostApiV2InferenceDatapointsResponses,
  PostApiV2JudgementsData,
  PostApiV2JudgementsErrors,
  PostApiV2JudgementsResponses,
  PostApiV2JudgesBulkData,
  PostApiV2JudgesBulkErrors,
  PostApiV2JudgesBulkResponses,
  PostApiV2JudgesData,
  PostApiV2JudgesErrors,
  PostApiV2JudgesResponses,
  PostApiV2KanonicalDatapointsData,
  PostApiV2KanonicalDatapointsErrors,
  PostApiV2KanonicalDatapointsResponses,
  PostApiV2KbsByKbIdEmbedData,
  PostApiV2KbsByKbIdEmbedErrors,
  PostApiV2KbsByKbIdEmbedResponses,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses,
  PostApiV2TasksByTaskIdRestoreData,
  PostApiV2TasksByTaskIdRestoreErrors,
  PostApiV2TasksByTaskIdRestoreResponses,
  PostApiV2TasksData,
  PostApiV2TasksErrors,
  PostApiV2TasksResponses,
  PostApiV3DatapointsData,
  PostApiV3DatapointsErrors,
  PostApiV3DatapointsResponses,
  PostApiV3JudgementsData,
  PostApiV3JudgementsErrors,
  PostApiV3JudgementsResponses,
  PostApiV3KbsByKbIdRestoreData,
  PostApiV3KbsByKbIdRestoreErrors,
  PostApiV3KbsByKbIdRestoreResponses,
  PostApiZendeskV1ActionsReplyToTicketData,
  PostApiZendeskV1ActionsReplyToTicketErrors,
  PostApiZendeskV1ActionsReplyToTicketResponses,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses,
  PutApiDebugV1ValkeyValuesByKeyData,
  PutApiDebugV1ValkeyValuesByKeyErrors,
  PutApiDebugV1ValkeyValuesByKeyResponses,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesData,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses,
  PutApiPlainV1TenantsByTenantIdActionsCustomersData,
  PutApiPlainV1TenantsByTenantIdActionsCustomersErrors,
  PutApiPlainV1TenantsByTenantIdActionsCustomersResponses,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses,
  PutApiSalesforceV1TenantsByTenantIdIngestClientData,
  PutApiSalesforceV1TenantsByTenantIdIngestClientErrors,
  PutApiSalesforceV1TenantsByTenantIdIngestClientResponses,
  PutApiV1AuthzOrganizationsByExternalIdData,
  PutApiV1AuthzOrganizationsByExternalIdErrors,
  PutApiV1AuthzOrganizationsByExternalIdResponses,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses,
  PutApiV1SesameOrgMemberRolesData,
  PutApiV1SesameOrgMemberRolesErrors,
  PutApiV1SesameOrgMemberRolesResponses,
  PutApiV1SesameOrgMembershipsData,
  PutApiV1SesameOrgMembershipsErrors,
  PutApiV1SesameOrgMembershipsResponses,
  PutApiV1UsersExternalByExternalIdData,
  PutApiV1UsersExternalByExternalIdErrors,
  PutApiV1UsersExternalByExternalIdResponses,
  PutApiV2ConversationsByExternalIdData,
  PutApiV2ConversationsByExternalIdErrors,
  PutApiV2ConversationsByExternalIdResponses,
  PutApiV2InferenceConversationsByExternalIdData,
  PutApiV2InferenceConversationsByExternalIdErrors,
  PutApiV2InferenceConversationsByExternalIdResponses,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Agent Session Inferences V1
 */
export const get_agent_session_inferences_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AgentSessionInferenceByAgentSessionIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AgentSessionInferenceByAgentSessionIdResponses,
  GetApiV1AgentSessionInferenceByAgentSessionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AgentSessionInferenceByAgentSessionIdResponses,
    GetApiV1AgentSessionInferenceByAgentSessionIdErrors,
    ThrowOnError
  >({ url: "/api/v1/agent-session-inference/{agent_session_id}", ...options });

/**
 * Create Agent Session Inference V1
 */
export const create_agent_session_inference_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1AgentSessionInferenceByAgentSessionIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AgentSessionInferenceByAgentSessionIdResponses,
  PostApiV1AgentSessionInferenceByAgentSessionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AgentSessionInferenceByAgentSessionIdResponses,
    PostApiV1AgentSessionInferenceByAgentSessionIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/agent-session-inference/{agent_session_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Agent Sessions V1
 */
export const get_agent_sessions_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1AgentSessionsData, ThrowOnError>,
): RequestResult<
  GetApiV1AgentSessionsResponses,
  GetApiV1AgentSessionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1AgentSessionsResponses,
    GetApiV1AgentSessionsErrors,
    ThrowOnError
  >({ url: "/api/v1/agent-sessions", ...options });

/**
 * Create Agent Session V1
 */
export const create_agent_session_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1AgentSessionsData, ThrowOnError>,
): RequestResult<
  PostApiV1AgentSessionsResponses,
  PostApiV1AgentSessionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AgentSessionsResponses,
    PostApiV1AgentSessionsErrors,
    ThrowOnError
  >({
    url: "/api/v1/agent-sessions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Agent Sessions V1
 */
export const get_full_agent_sessions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullAgentSessionsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullAgentSessionsResponses,
  GetApiV1FullAgentSessionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullAgentSessionsResponses,
    GetApiV1FullAgentSessionsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-agent-sessions", ...options });

/**
 * Delete Agent Session V1
 */
export const delete_agent_session_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1AgentSessionsByAgentSessionIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1AgentSessionsByAgentSessionIdResponses,
  DeleteApiV1AgentSessionsByAgentSessionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1AgentSessionsByAgentSessionIdResponses,
    DeleteApiV1AgentSessionsByAgentSessionIdErrors,
    ThrowOnError
  >({ url: "/api/v1/agent-sessions/{agent_session_id}", ...options });

/**
 * Get Full Agent Session V1
 */
export const get_full_agent_session_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AgentSessionsByAgentSessionIdData, ThrowOnError>,
): RequestResult<
  GetApiV1AgentSessionsByAgentSessionIdResponses,
  GetApiV1AgentSessionsByAgentSessionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AgentSessionsByAgentSessionIdResponses,
    GetApiV1AgentSessionsByAgentSessionIdErrors,
    ThrowOnError
  >({ url: "/api/v1/agent-sessions/{agent_session_id}", ...options });

/**
 * Update Agent Session V1
 */
export const update_agent_session_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1AgentSessionsByAgentSessionIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1AgentSessionsByAgentSessionIdResponses,
  PatchApiV1AgentSessionsByAgentSessionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1AgentSessionsByAgentSessionIdResponses,
    PatchApiV1AgentSessionsByAgentSessionIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/agent-sessions/{agent_session_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full User Agent Sessions V1
 */
export const get_full_user_agent_sessions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullUserAgentSessionsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullUserAgentSessionsResponses,
  GetApiV1FullUserAgentSessionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullUserAgentSessionsResponses,
    GetApiV1FullUserAgentSessionsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-user-agent-sessions", ...options });

/**
 * Send Agent Session Message V1
 */
export const send_agent_session_message_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1AgentSessionsByAgentSessionIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AgentSessionsByAgentSessionIdMessagesResponses,
  PostApiV1AgentSessionsByAgentSessionIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AgentSessionsByAgentSessionIdMessagesResponses,
    PostApiV1AgentSessionsByAgentSessionIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/v1/agent-sessions/{agent_session_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send Agent Session Message Sync V1
 *
 * Experimental endpoint that runs the agent synchronously and returns when the run completes. Currently returns only the final response message from the agent. Behaviour may change as the endpoint evolves.
 */
export const send_agent_session_message_sync_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses,
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses,
    PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors,
    ThrowOnError
  >({
    url: "/api/v1/agent-sessions/{agent_session_id}/messages/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Stop Agent Session V1
 */
export const stop_agent_session_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1AgentSessionsByAgentSessionIdStopData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AgentSessionsByAgentSessionIdStopResponses,
  PostApiV1AgentSessionsByAgentSessionIdStopErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AgentSessionsByAgentSessionIdStopResponses,
    PostApiV1AgentSessionsByAgentSessionIdStopErrors,
    ThrowOnError
  >({ url: "/api/v1/agent-sessions/{agent_session_id}/stop", ...options });

/**
 * Get Agents V1
 */
export const get_agents_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1AgentsData, ThrowOnError>,
): RequestResult<GetApiV1AgentsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1AgentsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/agents", ...options });

/**
 * Get Mcp Toolsets V1
 */
export const get_mcp_toolsets_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1McpToolsetsData, ThrowOnError>,
): RequestResult<GetApiV1McpToolsetsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1McpToolsetsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/mcp-toolsets", ...options });

/**
 * Get A2A Agents V1
 */
export const get_a2a_agents_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1A2aAgentsData, ThrowOnError>,
): RequestResult<GetApiV1A2aAgentsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1A2aAgentsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/a2a-agents", ...options });

/**
 * Get Agent V1
 */
export const get_agent_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AgentsByAgentKeyData, ThrowOnError>,
): RequestResult<
  GetApiV1AgentsByAgentKeyResponses,
  GetApiV1AgentsByAgentKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AgentsByAgentKeyResponses,
    GetApiV1AgentsByAgentKeyErrors,
    ThrowOnError
  >({ url: "/api/v1/agents/{agent_key}", ...options });

/**
 * Get Section Analytics Charts V1
 */
export const get_section_analytics_charts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1AnalyticsSectionsChartsData, ThrowOnError>,
): RequestResult<
  GetApiV1AnalyticsSectionsChartsResponses,
  GetApiV1AnalyticsSectionsChartsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1AnalyticsSectionsChartsResponses,
    GetApiV1AnalyticsSectionsChartsErrors,
    ThrowOnError
  >({ url: "/api/v1/analytics/sections/charts", ...options });

/**
 * Get Workflow Analytics Charts V1
 */
export const get_workflow_analytics_charts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1AnalyticsWorkflowsChartsData, ThrowOnError>,
): RequestResult<
  GetApiV1AnalyticsWorkflowsChartsResponses,
  GetApiV1AnalyticsWorkflowsChartsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1AnalyticsWorkflowsChartsResponses,
    GetApiV1AnalyticsWorkflowsChartsErrors,
    ThrowOnError
  >({ url: "/api/v1/analytics/workflows/charts", ...options });

/**
 * Get Overview Analytics Charts V1
 */
export const get_overview_analytics_charts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1AnalyticsOverviewsChartsData, ThrowOnError>,
): RequestResult<
  GetApiV1AnalyticsOverviewsChartsResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1AnalyticsOverviewsChartsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/analytics/overviews/charts", ...options });

/**
 * Get Section Analytics Chart Content V1
 */
export const get_section_analytics_chart_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses,
    GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/analytics/sections/{section_id}/charts/{chart_key}/content",
    ...options,
  });

/**
 * Get Tree Analytics Chart Content V1
 */
export const get_tree_analytics_chart_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses,
    GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/analytics/trees/{kb_id}/charts/{chart_key}/content",
    ...options,
  });

/**
 * Get Kb Analytics Chart Content V1
 */
export const get_kb_analytics_chart_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
    GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/analytics/knowledge-bases/{kb_id}/charts/{chart_key}/content",
    ...options,
  });

/**
 * Get Workflow Analytics Chart Content V1
 */
export const get_workflow_analytics_chart_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses,
    GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/analytics/workflows/{workflow_id}/charts/{chart_key}/content",
    ...options,
  });

/**
 * Get Overview Analytics Chart Content V1
 */
export const get_overview_analytics_chart_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
    GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/analytics/overviews/knowledge-bases/{kb_id}/charts/{chart_key}/content",
    ...options,
  });

/**
 * Create Api Key V1
 */
export const create_api_key_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1ApiKeysData, ThrowOnError>,
): RequestResult<
  PostApiV1ApiKeysResponses,
  PostApiV1ApiKeysErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ApiKeysResponses,
    PostApiV1ApiKeysErrors,
    ThrowOnError
  >({
    url: "/api/v1/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Api Keys V1
 */
export const get_full_api_keys_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1FullApiKeysData, ThrowOnError>,
): RequestResult<
  GetApiV1FullApiKeysResponses,
  GetApiV1FullApiKeysErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullApiKeysResponses,
    GetApiV1FullApiKeysErrors,
    ThrowOnError
  >({ url: "/api/v1/full-api-keys", ...options });

/**
 * Delete Api Key V1
 */
export const delete_api_key_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1ApiKeysByApiKeyIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1ApiKeysByApiKeyIdResponses,
  DeleteApiV1ApiKeysByApiKeyIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ApiKeysByApiKeyIdResponses,
    DeleteApiV1ApiKeysByApiKeyIdErrors,
    ThrowOnError
  >({ url: "/api/v1/api-keys/{api_key_id}", ...options });

/**
 * Update Api Key V1
 */
export const update_api_key_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1ApiKeysByApiKeyIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1ApiKeysByApiKeyIdResponses,
  PatchApiV1ApiKeysByApiKeyIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ApiKeysByApiKeyIdResponses,
    PatchApiV1ApiKeysByApiKeyIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/api-keys/{api_key_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Article Line Range Comment Threads V1
 */
export const get_full_article_line_range_comment_threads_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1FullArticleLineRangeCommentThreadsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1FullArticleLineRangeCommentThreadsResponses,
  GetApiV1FullArticleLineRangeCommentThreadsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullArticleLineRangeCommentThreadsResponses,
    GetApiV1FullArticleLineRangeCommentThreadsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-article-line-range-comment-threads", ...options });

/**
 * Delete Article Line Range Comment Thread V1
 */
export const delete_article_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
    DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/article-line-range-comment-threads/{thread_id}",
    ...options,
  });

/**
 * Get Article Line Range Comment Thread V1
 */
export const get_article_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ArticleLineRangeCommentThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
    GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/article-line-range-comment-threads/{thread_id}",
    ...options,
  });

/**
 * Update Article Line Range Comment Thread V1
 */
export const update_article_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
    PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/article-line-range-comment-threads/{thread_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Article Line Range Comment Thread V1
 */
export const create_article_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1ArticleLineRangeCommentThreadsData, ThrowOnError>,
): RequestResult<
  PostApiV1ArticleLineRangeCommentThreadsResponses,
  PostApiV1ArticleLineRangeCommentThreadsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ArticleLineRangeCommentThreadsResponses,
    PostApiV1ArticleLineRangeCommentThreadsErrors,
    ThrowOnError
  >({
    url: "/api/v1/article-line-range-comment-threads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Article Line Range Comment Thread Comment V1
 */
export const create_article_line_range_comment_thread_comment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses,
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors,
    ThrowOnError
  >({
    url: "/api/v1/article-line-range-comment-threads/{thread_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Article Line Range Comment Thread V1
 */
export const restore_article_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses,
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses,
    PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/article-line-range-comment-threads/{thread_id}/restore",
    ...options,
  });

/**
 * Create Upload Url V1
 */
export const create_upload_url_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1AttachmentsUploadUrlData, ThrowOnError>,
): RequestResult<
  PostApiV1AttachmentsUploadUrlResponses,
  PostApiV1AttachmentsUploadUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AttachmentsUploadUrlResponses,
    PostApiV1AttachmentsUploadUrlErrors,
    ThrowOnError
  >({
    url: "/api/v1/attachments/upload-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Upload Url V2
 */
export const create_upload_url_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2AttachmentsUploadUrlData, ThrowOnError>,
): RequestResult<
  PostApiV2AttachmentsUploadUrlResponses,
  PostApiV2AttachmentsUploadUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2AttachmentsUploadUrlResponses,
    PostApiV2AttachmentsUploadUrlErrors,
    ThrowOnError
  >({
    url: "/api/v2/attachments/upload-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Attachment Data V1
 */
export const get_attachment_data_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AttachmentsDataByFilePathData, ThrowOnError>,
): RequestResult<
  GetApiV1AttachmentsDataByFilePathResponses,
  GetApiV1AttachmentsDataByFilePathErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AttachmentsDataByFilePathResponses,
    GetApiV1AttachmentsDataByFilePathErrors,
    ThrowOnError
  >({ url: "/api/v1/attachments/data/{file_path}", ...options });

/**
 * Get Attachment Data V2
 */
export const get_attachment_data_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV2AttachmentsDataByAttachmentIdByFilenameData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV2AttachmentsDataByAttachmentIdByFilenameResponses,
  GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2AttachmentsDataByAttachmentIdByFilenameResponses,
    GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors,
    ThrowOnError
  >({ url: "/api/v2/attachments/data/{attachment_id}/{filename}", ...options });

/**
 * Get Attachment Metadata V1
 */
export const get_attachment_metadata_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<HeadApiV1AttachmentsMetadataByFilePathData, ThrowOnError>,
): RequestResult<
  HeadApiV1AttachmentsMetadataByFilePathResponses,
  HeadApiV1AttachmentsMetadataByFilePathErrors,
  ThrowOnError
> =>
  (options.client ?? client).head<
    HeadApiV1AttachmentsMetadataByFilePathResponses,
    HeadApiV1AttachmentsMetadataByFilePathErrors,
    ThrowOnError
  >({ url: "/api/v1/attachments/metadata/{file_path}", ...options });

/**
 * Get Organizations V1
 */
export const get_organizations_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1AuthzOrganizationsData, ThrowOnError>,
): RequestResult<
  GetApiV1AuthzOrganizationsResponses,
  GetApiV1AuthzOrganizationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1AuthzOrganizationsResponses,
    GetApiV1AuthzOrganizationsErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/organizations", ...options });

/**
 * Get Organization V1
 */
export const get_organization_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AuthzOrganizationsByOrgIdData, ThrowOnError>,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdResponses,
  GetApiV1AuthzOrganizationsByOrgIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdResponses,
    GetApiV1AuthzOrganizationsByOrgIdErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/organizations/{org_id}", ...options });

/**
 * Update Organization V1
 */
export const update_organization_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1AuthzOrganizationsByOrgIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1AuthzOrganizationsByOrgIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1AuthzOrganizationsByOrgIdResponses,
    PatchApiV1AuthzOrganizationsByOrgIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upsert Organization V1
 */
export const upsert_organization_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PutApiV1AuthzOrganizationsByExternalIdData, ThrowOnError>,
): RequestResult<
  PutApiV1AuthzOrganizationsByExternalIdResponses,
  PutApiV1AuthzOrganizationsByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1AuthzOrganizationsByExternalIdResponses,
    PutApiV1AuthzOrganizationsByExternalIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{external_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Org Members V1
 */
export const get_org_members_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AuthzOrganizationsByOrgIdMembersData, ThrowOnError>,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdMembersResponses,
  GetApiV1AuthzOrganizationsByOrgIdMembersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdMembersResponses,
    GetApiV1AuthzOrganizationsByOrgIdMembersErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/organizations/{org_id}/members", ...options });

/**
 * Delete Org Member V1
 */
export const delete_org_member_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
    DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/members/{user_id}",
    ...options,
  });

/**
 * Update Org Member V1
 */
export const update_org_member_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
    PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/members/{user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Roles V1
 */
export const get_roles_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AuthzOrganizationsByOrgIdRolesData, ThrowOnError>,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdRolesResponses,
  GetApiV1AuthzOrganizationsByOrgIdRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdRolesResponses,
    GetApiV1AuthzOrganizationsByOrgIdRolesErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/organizations/{org_id}/roles", ...options });

/**
 * Get Teams V1
 */
export const get_teams_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1AuthzOrganizationsByOrgIdTeamsData, ThrowOnError>,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdTeamsResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdTeamsResponses,
    GetApiV1AuthzOrganizationsByOrgIdTeamsErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/organizations/{org_id}/teams", ...options });

/**
 * Create Team V1
 */
export const create_team_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1AuthzOrganizationsByOrgIdTeamsData, ThrowOnError>,
): RequestResult<
  PostApiV1AuthzOrganizationsByOrgIdTeamsResponses,
  PostApiV1AuthzOrganizationsByOrgIdTeamsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AuthzOrganizationsByOrgIdTeamsResponses,
    PostApiV1AuthzOrganizationsByOrgIdTeamsErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Team V1
 */
export const delete_team_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
    DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}",
    ...options,
  });

/**
 * Get Team V1
 */
export const get_team_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}",
    ...options,
  });

/**
 * Update Team V1
 */
export const update_team_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
    PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync Articles To Openfga V1
 */
export const sync_articles_to_openfga_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostApiV1AuthzSyncArticlesToOpenfgaData, ThrowOnError>,
): RequestResult<
  PostApiV1AuthzSyncArticlesToOpenfgaResponses,
  PostApiV1AuthzSyncArticlesToOpenfgaErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostApiV1AuthzSyncArticlesToOpenfgaResponses,
    PostApiV1AuthzSyncArticlesToOpenfgaErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/sync-articles-to-openfga", ...options });

/**
 * Sync Kb Owners V1
 */
export const sync_kb_owners_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<PostApiV1AuthzKbOwnersSyncData, ThrowOnError>,
): RequestResult<PostApiV1AuthzKbOwnersSyncResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostApiV1AuthzKbOwnersSyncResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/authz/kb-owners/sync", ...options });

/**
 * Set Team Kb Role V1
 */
export const set_team_kb_role_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData,
    ThrowOnError
  >,
): RequestResult<
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses,
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/knowledge-bases/{kb_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Team Kb Assignments V1
 */
export const get_team_kb_assignments_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/knowledge-bases",
    ...options,
  });

/**
 * Get Team Article Permissions V1
 */
export const get_team_article_permissions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
    GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/articles",
    ...options,
  });

/**
 * Set Team Article Permissions V1
 */
export const set_team_article_permissions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
    ThrowOnError
  >,
): RequestResult<
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/articles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Team Article Permission V1
 */
export const set_team_article_permission_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData,
    ThrowOnError
  >,
): RequestResult<
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses,
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses,
    PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/articles/{article_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Invitations V1
 */
export const get_invitations_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdInvitationsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
    GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
    ThrowOnError
  >({ url: "/api/v1/authz/organizations/{org_id}/invitations", ...options });

/**
 * Create Invitation V1
 */
export const create_invitation_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1AuthzOrganizationsByOrgIdInvitationsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
  PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
    PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/invitations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Invitations V1
 */
export const get_full_invitations_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses,
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses,
    GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/full-invitations",
    ...options,
  });

/**
 * Delete Invitation V1
 */
export const delete_invitation_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
    DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/invitations/{invitation_id}",
    ...options,
  });

/**
 * Get Invitation V1
 */
export const get_invitation_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
    GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/invitations/{invitation_id}",
    ...options,
  });

/**
 * Update Invitation V1
 */
export const update_invitation_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
    PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/invitations/{invitation_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Branding V1
 */
export const get_branding_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1BrandingData, ThrowOnError>,
): RequestResult<GetApiV1BrandingResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1BrandingResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/branding", ...options });

/**
 * Create Branding Logo Upload Url V1
 */
export const create_branding_logo_upload_url_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1BrandingLogoUploadUrlData, ThrowOnError>,
): RequestResult<
  PostApiV1BrandingLogoUploadUrlResponses,
  PostApiV1BrandingLogoUploadUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1BrandingLogoUploadUrlResponses,
    PostApiV1BrandingLogoUploadUrlErrors,
    ThrowOnError
  >({
    url: "/api/v1/branding/logo/upload-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Change Request Line Range Comment Threads V1
 */
export const get_full_change_request_line_range_comment_threads_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1FullChangeRequestLineRangeCommentThreadsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1FullChangeRequestLineRangeCommentThreadsResponses,
  GetApiV1FullChangeRequestLineRangeCommentThreadsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullChangeRequestLineRangeCommentThreadsResponses,
    GetApiV1FullChangeRequestLineRangeCommentThreadsErrors,
    ThrowOnError
  >({
    url: "/api/v1/full-change-request-line-range-comment-threads",
    ...options,
  });

/**
 * Delete Change Request Line Range Comment Thread V1
 */
export const delete_change_request_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
    DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}",
    ...options,
  });

/**
 * Get Change Request Line Range Comment Thread V1
 */
export const get_change_request_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
    GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}",
    ...options,
  });

/**
 * Update Change Request Line Range Comment Thread V1
 */
export const update_change_request_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
    PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Change Request Line Range Comment Thread V1
 */
export const create_change_request_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ChangeRequestLineRangeCommentThreadsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ChangeRequestLineRangeCommentThreadsResponses,
  PostApiV1ChangeRequestLineRangeCommentThreadsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ChangeRequestLineRangeCommentThreadsResponses,
    PostApiV1ChangeRequestLineRangeCommentThreadsErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-request-line-range-comment-threads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Change Request Line Range Comment Thread Comment V1
 */
export const create_change_request_line_range_comment_thread_comment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses,
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Change Request Line Range Comment Thread V1
 */
export const restore_change_request_line_range_comment_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses,
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses,
    PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}/restore",
    ...options,
  });

/**
 * Get Change Request Tags V1
 */
export const get_change_request_tags_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1ChangeRequestTagsData, ThrowOnError>,
): RequestResult<
  GetApiV1ChangeRequestTagsResponses,
  GetApiV1ChangeRequestTagsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ChangeRequestTagsResponses,
    GetApiV1ChangeRequestTagsErrors,
    ThrowOnError
  >({ url: "/api/v1/change-request-tags", ...options });

/**
 * Get Change Requests V1
 */
export const get_change_requests_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1ChangeRequestsData, ThrowOnError>,
): RequestResult<
  GetApiV1ChangeRequestsResponses,
  GetApiV1ChangeRequestsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ChangeRequestsResponses,
    GetApiV1ChangeRequestsErrors,
    ThrowOnError
  >({ url: "/api/v1/change-requests", ...options });

/**
 * Create Change Request V1
 */
export const create_change_request_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1ChangeRequestsData, ThrowOnError>,
): RequestResult<
  PostApiV1ChangeRequestsResponses,
  PostApiV1ChangeRequestsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ChangeRequestsResponses,
    PostApiV1ChangeRequestsErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-requests",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Change Requests V1
 */
export const get_full_change_requests_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullChangeRequestsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullChangeRequestsResponses,
  GetApiV1FullChangeRequestsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullChangeRequestsResponses,
    GetApiV1FullChangeRequestsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-change-requests", ...options });

/**
 * Delete Change Request V1
 */
export const delete_change_request_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiV1ChangeRequestsByChangeRequestIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1ChangeRequestsByChangeRequestIdResponses,
  DeleteApiV1ChangeRequestsByChangeRequestIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ChangeRequestsByChangeRequestIdResponses,
    DeleteApiV1ChangeRequestsByChangeRequestIdErrors,
    ThrowOnError
  >({ url: "/api/v1/change-requests/{change_request_id}", ...options });

/**
 * Get Change Request V1
 */
export const get_change_request_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ChangeRequestsByChangeRequestIdData, ThrowOnError>,
): RequestResult<
  GetApiV1ChangeRequestsByChangeRequestIdResponses,
  GetApiV1ChangeRequestsByChangeRequestIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ChangeRequestsByChangeRequestIdResponses,
    GetApiV1ChangeRequestsByChangeRequestIdErrors,
    ThrowOnError
  >({ url: "/api/v1/change-requests/{change_request_id}", ...options });

/**
 * Update Change Request V1
 */
export const update_change_request_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1ChangeRequestsByChangeRequestIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1ChangeRequestsByChangeRequestIdResponses,
  PatchApiV1ChangeRequestsByChangeRequestIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ChangeRequestsByChangeRequestIdResponses,
    PatchApiV1ChangeRequestsByChangeRequestIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-requests/{change_request_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Change Request V1
 */
export const restore_change_request_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ChangeRequestsByChangeRequestIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses,
  PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses,
    PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v1/change-requests/{change_request_id}/restore", ...options });

/**
 * Get Change Request Possible Assignees V1
 */
export const get_change_request_possible_assignees_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses,
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses,
    GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors,
    ThrowOnError
  >({
    url: "/api/v1/change-requests/{change_request_id}/possible-assignees",
    ...options,
  });

/**
 * Get Full Comments V1
 */
export const get_full_comments_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1FullCommentsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullCommentsResponses,
  GetApiV1FullCommentsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullCommentsResponses,
    GetApiV1FullCommentsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-comments", ...options });

/**
 * Delete Comment V1
 */
export const delete_comment_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1CommentsByCommentIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1CommentsByCommentIdResponses,
  DeleteApiV1CommentsByCommentIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1CommentsByCommentIdResponses,
    DeleteApiV1CommentsByCommentIdErrors,
    ThrowOnError
  >({ url: "/api/v1/comments/{comment_id}", ...options });

/**
 * Get Comment V1
 */
export const get_comment_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1CommentsByCommentIdData, ThrowOnError>,
): RequestResult<
  GetApiV1CommentsByCommentIdResponses,
  GetApiV1CommentsByCommentIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1CommentsByCommentIdResponses,
    GetApiV1CommentsByCommentIdErrors,
    ThrowOnError
  >({ url: "/api/v1/comments/{comment_id}", ...options });

/**
 * Update Comment V1
 */
export const update_comment_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1CommentsByCommentIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1CommentsByCommentIdResponses,
  PatchApiV1CommentsByCommentIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1CommentsByCommentIdResponses,
    PatchApiV1CommentsByCommentIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/comments/{comment_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Comment V1
 */
export const restore_comment_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1CommentsByCommentIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV1CommentsByCommentIdRestoreResponses,
  PostApiV1CommentsByCommentIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CommentsByCommentIdRestoreResponses,
    PostApiV1CommentsByCommentIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v1/comments/{comment_id}/restore", ...options });

/**
 * Confluence Get Spaces V1
 */
export const confluence_get_spaces_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/spaces",
    ...options,
  });

/**
 * Confluence Get Pages V1
 */
export const confluence_get_pages_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages",
    ...options,
  });

/**
 * Confluence Create Page V1
 */
export const confluence_create_page_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiConfluenceV1TenantsByTenantIdActionsPagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
    PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confluence Get Page Content V1
 */
export const confluence_get_page_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/content",
    ...options,
  });

/**
 * Confluence Get Comments V1
 */
export const confluence_get_comments_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/comments",
    ...options,
  });

/**
 * Confluence Add Comment V1
 */
export const confluence_add_comment_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
    PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confluence Get Page Labels V1
 */
export const confluence_get_page_labels_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/labels",
    ...options,
  });

/**
 * Confluence Get Page Attachments V1
 */
export const confluence_get_page_attachments_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/attachments",
    ...options,
  });

/**
 * Confluence Get Attachment Content V1
 */
export const confluence_get_attachment_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses,
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses,
    GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/attachments/{attachment_id}/content",
    ...options,
  });

/**
 * Confluence Update Page V1
 */
export const confluence_update_page_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses,
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses,
    PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confluence Get Oauth Scopes V1
 */
export const confluence_get_oauth_scopes_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiConfluenceV1OauthScopesData, ThrowOnError>,
): RequestResult<
  GetApiConfluenceV1OauthScopesResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiConfluenceV1OauthScopesResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/confluence/v1/oauth-scopes", ...options });

/**
 * Confluence Get Tenants V1
 */
export const confluence_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiConfluenceV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiConfluenceV1TenantsResponses,
  GetApiConfluenceV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiConfluenceV1TenantsResponses,
    GetApiConfluenceV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/confluence/v1/tenants", ...options });

/**
 * Confluence Create Tenant V1
 */
export const confluence_create_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiConfluenceV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiConfluenceV1TenantsResponses,
  PostApiConfluenceV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiConfluenceV1TenantsResponses,
    PostApiConfluenceV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confluence Delete Tenant V1
 */
export const confluence_delete_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApiConfluenceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiConfluenceV1TenantsByTenantIdResponses,
  DeleteApiConfluenceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiConfluenceV1TenantsByTenantIdResponses,
    DeleteApiConfluenceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/confluence/v1/tenants/{tenant_id}", ...options });

/**
 * Confluence Get Tenant V1
 */
export const confluence_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiConfluenceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdResponses,
  GetApiConfluenceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdResponses,
    GetApiConfluenceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/confluence/v1/tenants/{tenant_id}", ...options });

/**
 * Confluence Patch Tenant V1
 */
export const confluence_patch_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiConfluenceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiConfluenceV1TenantsByTenantIdResponses,
  PatchApiConfluenceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiConfluenceV1TenantsByTenantIdResponses,
    PatchApiConfluenceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confluence Connect Tenant V1
 */
export const confluence_connect_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiConfluenceV1TenantsByTenantIdConnectData,
    ThrowOnError
  >,
): RequestResult<
  PostApiConfluenceV1TenantsByTenantIdConnectResponses,
  PostApiConfluenceV1TenantsByTenantIdConnectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiConfluenceV1TenantsByTenantIdConnectResponses,
    PostApiConfluenceV1TenantsByTenantIdConnectErrors,
    ThrowOnError
  >({ url: "/api/confluence/v1/tenants/{tenant_id}/connect", ...options });

/**
 * Confluence Callback Tenant V1
 */
export const confluence_callback_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiConfluenceV1TenantsByTenantIdCallbackData,
    ThrowOnError
  >,
): RequestResult<
  PostApiConfluenceV1TenantsByTenantIdCallbackResponses,
  PostApiConfluenceV1TenantsByTenantIdCallbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiConfluenceV1TenantsByTenantIdCallbackResponses,
    PostApiConfluenceV1TenantsByTenantIdCallbackErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Confluence Check Connection V1
 */
export const confluence_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiConfluenceV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses,
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses,
    GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/confluence/v1/tenants/{tenant_id}/check-connection",
    ...options,
  });

/**
 * Get Conversations V1
 */
export const get_conversations_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV1ConversationsResponses,
  GetApiV1ConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ConversationsResponses,
    GetApiV1ConversationsErrors,
    ThrowOnError
  >({ url: "/api/v1/conversations", ...options });

/**
 * Get Conversations Grouped By External Id V1
 */
export const get_conversations_grouped_by_external_id_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1ConversationsGroupByExternalIdData, ThrowOnError>,
): RequestResult<
  GetApiV1ConversationsGroupByExternalIdResponses,
  GetApiV1ConversationsGroupByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ConversationsGroupByExternalIdResponses,
    GetApiV1ConversationsGroupByExternalIdErrors,
    ThrowOnError
  >({ url: "/api/v1/conversations/group-by-external-id", ...options });

/**
 * Update Conversation V2
 */
export const update_conversation_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PutApiV2ConversationsByExternalIdData, ThrowOnError>,
): RequestResult<
  PutApiV2ConversationsByExternalIdResponses,
  PutApiV2ConversationsByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV2ConversationsByExternalIdResponses,
    PutApiV2ConversationsByExternalIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/conversations/{external_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Append Conversation Messages V2
 */
export const append_conversation_messages_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ConversationsByExternalIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ConversationsByExternalIdMessagesResponses,
  PostApiV2ConversationsByExternalIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ConversationsByExternalIdMessagesResponses,
    PostApiV2ConversationsByExternalIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/v2/conversations/{external_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stateless Conversation Inference V2
 */
export const create_stateless_conversation_inference_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ConversationsByExternalIdStatelessInferenceData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ConversationsByExternalIdStatelessInferenceResponses,
  PostApiV2ConversationsByExternalIdStatelessInferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ConversationsByExternalIdStatelessInferenceResponses,
    PostApiV2ConversationsByExternalIdStatelessInferenceErrors,
    ThrowOnError
  >({
    url: "/api/v2/conversations/{external_id}/stateless-inference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stateful Conversation Inference V2
 */
export const create_stateful_conversation_inference_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ConversationsByExternalIdStatefulInferenceData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ConversationsByExternalIdStatefulInferenceResponses,
  PostApiV2ConversationsByExternalIdStatefulInferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ConversationsByExternalIdStatefulInferenceResponses,
    PostApiV2ConversationsByExternalIdStatefulInferenceErrors,
    ThrowOnError
  >({
    url: "/api/v2/conversations/{external_id}/stateful-inference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Conversation Feedback V2
 */
export const create_conversation_feedback_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ConversationsByExternalIdFeedbackData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ConversationsByExternalIdFeedbackResponses,
  PostApiV2ConversationsByExternalIdFeedbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ConversationsByExternalIdFeedbackResponses,
    PostApiV2ConversationsByExternalIdFeedbackErrors,
    ThrowOnError
  >({
    url: "/api/v2/conversations/{external_id}/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Data Dump Conversations V1
 */
export const get_data_dump_conversations_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1DataDumpConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV1DataDumpConversationsResponses,
  GetApiV1DataDumpConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1DataDumpConversationsResponses,
    GetApiV1DataDumpConversationsErrors,
    ThrowOnError
  >({ url: "/api/v1/data-dump-conversations", ...options });

/**
 * Create Data Dump Conversation V1
 */
export const create_data_dump_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1DataDumpConversationsData, ThrowOnError>,
): RequestResult<
  PostApiV1DataDumpConversationsResponses,
  PostApiV1DataDumpConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DataDumpConversationsResponses,
    PostApiV1DataDumpConversationsErrors,
    ThrowOnError
  >({
    url: "/api/v1/data-dump-conversations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Data Dump Conversations V1
 */
export const get_full_data_dump_conversations_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1FullDataDumpConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullDataDumpConversationsResponses,
  GetApiV1FullDataDumpConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1FullDataDumpConversationsResponses,
    GetApiV1FullDataDumpConversationsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-data-dump-conversations", ...options });

/**
 * Delete Data Dump Conversation V1
 */
export const delete_data_dump_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1DataDumpConversationsByDataDumpConversationIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses,
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses,
    DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/data-dump-conversations/{data_dump_conversation_id}",
    ...options,
  });

/**
 * Update Data Dump Conversation V1
 */
export const update_data_dump_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1DataDumpConversationsByDataDumpConversationIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses,
  PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses,
    PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/data-dump-conversations/{data_dump_conversation_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Data Dump Conversation V1
 */
export const restore_data_dump_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses,
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses,
    PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/data-dump-conversations/{data_dump_conversation_id}/restore",
    ...options,
  });

/**
 * Update Datapoint By External Id V3
 */
export const update_datapoint_by_external_id_v3 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiV3DatapointsData, ThrowOnError>,
): RequestResult<
  PatchApiV3DatapointsResponses,
  PatchApiV3DatapointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV3DatapointsResponses,
    PatchApiV3DatapointsErrors,
    ThrowOnError
  >({
    url: "/api/v3/datapoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Datapoints V3
 */
export const create_datapoints_v3 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV3DatapointsData, ThrowOnError>,
): RequestResult<
  PostApiV3DatapointsResponses,
  PostApiV3DatapointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV3DatapointsResponses,
    PostApiV3DatapointsErrors,
    ThrowOnError
  >({
    url: "/api/v3/datapoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Embed Datapoints V1
 */
export const embed_datapoints_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1DatapointsEmbedData, ThrowOnError>,
): RequestResult<
  PostApiV1DatapointsEmbedResponses,
  PostApiV1DatapointsEmbedErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DatapointsEmbedResponses,
    PostApiV1DatapointsEmbedErrors,
    ThrowOnError
  >({
    url: "/api/v1/datapoints/embed",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Backfill Index V1
 */
export const backfill_index_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1DatapointsBackfillIndexData, ThrowOnError>,
): RequestResult<
  PostApiV1DatapointsBackfillIndexResponses,
  PostApiV1DatapointsBackfillIndexErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DatapointsBackfillIndexResponses,
    PostApiV1DatapointsBackfillIndexErrors,
    ThrowOnError
  >({
    url: "/api/v1/datapoints/backfill-index",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search Datapoints V1
 */
export const search_datapoints_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1DatapointsSearchData, ThrowOnError>,
): RequestResult<
  PostApiV1DatapointsSearchResponses,
  PostApiV1DatapointsSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DatapointsSearchResponses,
    PostApiV1DatapointsSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/datapoints/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Regex Search Datapoints V1
 */
export const regex_search_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1DatapointsRegexSearchData, ThrowOnError>,
): RequestResult<
  PostApiV1DatapointsRegexSearchResponses,
  PostApiV1DatapointsRegexSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DatapointsRegexSearchResponses,
    PostApiV1DatapointsRegexSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/datapoints/regex-search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search Datapoint Evidence V1
 */
export const search_datapoint_evidence_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1DatapointEvidenceSearchData, ThrowOnError>,
): RequestResult<
  PostApiV1DatapointEvidenceSearchResponses,
  PostApiV1DatapointEvidenceSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1DatapointEvidenceSearchResponses,
    PostApiV1DatapointEvidenceSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/datapoint-evidence/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Datapoint V3
 */
export const get_datapoint_v3 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV3DatapointsByDatapointIdData, ThrowOnError>,
): RequestResult<
  GetApiV3DatapointsByDatapointIdResponses,
  GetApiV3DatapointsByDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV3DatapointsByDatapointIdResponses,
    GetApiV3DatapointsByDatapointIdErrors,
    ThrowOnError
  >({ url: "/api/v3/datapoints/{datapoint_id}", ...options });

/**
 * Update Datapoint V3
 */
export const update_datapoint_v3 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV3DatapointsByDatapointIdData, ThrowOnError>,
): RequestResult<
  PatchApiV3DatapointsByDatapointIdResponses,
  PatchApiV3DatapointsByDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV3DatapointsByDatapointIdResponses,
    PatchApiV3DatapointsByDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v3/datapoints/{datapoint_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Datapoints V1
 */
export const get_full_datapoints_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1FullDatapointsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullDatapointsResponses,
  GetApiV1FullDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullDatapointsResponses,
    GetApiV1FullDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-datapoints", ...options });

/**
 * Get Datapoint Evidence V1
 */
export const get_datapoint_evidence_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1DatapointEvidenceData, ThrowOnError>,
): RequestResult<
  GetApiV1DatapointEvidenceResponses,
  GetApiV1DatapointEvidenceErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1DatapointEvidenceResponses,
    GetApiV1DatapointEvidenceErrors,
    ThrowOnError
  >({ url: "/api/v1/datapoint-evidence", ...options });

/**
 * Delete Datapoint V2
 */
export const delete_datapoint_v2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV2DatapointsByDatapointIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV2DatapointsByDatapointIdResponses,
  DeleteApiV2DatapointsByDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV2DatapointsByDatapointIdResponses,
    DeleteApiV2DatapointsByDatapointIdErrors,
    ThrowOnError
  >({ url: "/api/v2/datapoints/{datapoint_id}", ...options });

/**
 * Restore Datapoint V2
 */
export const restore_datapoint_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2DatapointsByDatapointIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV2DatapointsByDatapointIdRestoreResponses,
  PostApiV2DatapointsByDatapointIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2DatapointsByDatapointIdRestoreResponses,
    PostApiV2DatapointsByDatapointIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v2/datapoints/{datapoint_id}/restore", ...options });

/**
 * Openfga Write Tuples V1
 */
export const openfga_write_tuples_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiDebugV1OpenfgaWriteTuplesData, ThrowOnError>,
): RequestResult<
  PostApiDebugV1OpenfgaWriteTuplesResponses,
  PostApiDebugV1OpenfgaWriteTuplesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiDebugV1OpenfgaWriteTuplesResponses,
    PostApiDebugV1OpenfgaWriteTuplesErrors,
    ThrowOnError
  >({
    url: "/api/debug/v1/openfga/write-tuples",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Openfga Read Tuples V1
 */
export const openfga_read_tuples_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiDebugV1OpenfgaReadTuplesData, ThrowOnError>,
): RequestResult<
  PostApiDebugV1OpenfgaReadTuplesResponses,
  PostApiDebugV1OpenfgaReadTuplesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiDebugV1OpenfgaReadTuplesResponses,
    PostApiDebugV1OpenfgaReadTuplesErrors,
    ThrowOnError
  >({
    url: "/api/debug/v1/openfga/read-tuples",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Openfga Check V1
 */
export const openfga_check_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiDebugV1OpenfgaCheckData, ThrowOnError>,
): RequestResult<
  PostApiDebugV1OpenfgaCheckResponses,
  PostApiDebugV1OpenfgaCheckErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiDebugV1OpenfgaCheckResponses,
    PostApiDebugV1OpenfgaCheckErrors,
    ThrowOnError
  >({
    url: "/api/debug/v1/openfga/check",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Pool Stats V1
 */
export const get_pool_stats_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1GetPoolStatsData, ThrowOnError>,
): RequestResult<GetApiDebugV1GetPoolStatsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1GetPoolStatsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/get-pool-stats", ...options });

/**
 * Reader Pool Check V1
 */
export const reader_pool_check_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1ReaderPoolCheckData, ThrowOnError>,
): RequestResult<
  GetApiDebugV1ReaderPoolCheckResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiDebugV1ReaderPoolCheckResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/reader-pool-check", ...options });

/**
 * Log Error V1
 */
export const log_error_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1LogErrorData, ThrowOnError>,
): RequestResult<GetApiDebugV1LogErrorResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1LogErrorResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/log-error", ...options });

/**
 * Log Sentry Alert V1
 */
export const log_sentry_alert_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1LogSentryAlertData, ThrowOnError>,
): RequestResult<GetApiDebugV1LogSentryAlertResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1LogSentryAlertResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/log-sentry-alert", ...options });

/**
 * Return 500 V1
 */
export const return_500_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1Return500Data, ThrowOnError>,
): RequestResult<GetApiDebugV1Return500Responses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1Return500Responses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/return-500", ...options });

/**
 * Key Error V1
 */
export const key_error_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1KeyErrorData, ThrowOnError>,
): RequestResult<GetApiDebugV1KeyErrorResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1KeyErrorResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/key-error", ...options });

/**
 * Print Logs V1
 */
export const print_logs_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1PrintLogsData, ThrowOnError>,
): RequestResult<GetApiDebugV1PrintLogsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1PrintLogsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/print-logs", ...options });

/**
 * Unwrap Error V1
 */
export const unwrap_error_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1UnwrapErrorData, ThrowOnError>,
): RequestResult<GetApiDebugV1UnwrapErrorResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1UnwrapErrorResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/unwrap-error", ...options });

/**
 * Background Task Error V1
 */
export const background_task_error_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<PostApiDebugV1BackgroundTaskErrorData, ThrowOnError>,
): RequestResult<
  PostApiDebugV1BackgroundTaskErrorResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostApiDebugV1BackgroundTaskErrorResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/background-task-error", ...options });

/**
 * Search Reindex V1
 */
export const search_reindex_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiDebugV1SearchReindexData, ThrowOnError>,
): RequestResult<
  PostApiDebugV1SearchReindexResponses,
  PostApiDebugV1SearchReindexErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiDebugV1SearchReindexResponses,
    PostApiDebugV1SearchReindexErrors,
    ThrowOnError
  >({
    url: "/api/debug/v1/search/reindex",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Valkey Ping V1
 */
export const valkey_ping_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiDebugV1ValkeyPingData, ThrowOnError>,
): RequestResult<GetApiDebugV1ValkeyPingResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiDebugV1ValkeyPingResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/debug/v1/valkey/ping", ...options });

/**
 * Get Valkey Value V1
 */
export const get_valkey_value_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiDebugV1ValkeyValuesByKeyData, ThrowOnError>,
): RequestResult<
  GetApiDebugV1ValkeyValuesByKeyResponses,
  GetApiDebugV1ValkeyValuesByKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiDebugV1ValkeyValuesByKeyResponses,
    GetApiDebugV1ValkeyValuesByKeyErrors,
    ThrowOnError
  >({ url: "/api/debug/v1/valkey/values/{key}", ...options });

/**
 * Set Valkey Value V1
 */
export const set_valkey_value_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PutApiDebugV1ValkeyValuesByKeyData, ThrowOnError>,
): RequestResult<
  PutApiDebugV1ValkeyValuesByKeyResponses,
  PutApiDebugV1ValkeyValuesByKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiDebugV1ValkeyValuesByKeyResponses,
    PutApiDebugV1ValkeyValuesByKeyErrors,
    ThrowOnError
  >({
    url: "/api/debug/v1/valkey/values/{key}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Entra Get Users V1
 */
export const entra_get_users_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants/{tenant_id}/actions/users", ...options });

/**
 * Entra Get User V1
 */
export const entra_get_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}",
    ...options,
  });

/**
 * Entra Get User Licenses V1
 */
export const entra_get_user_licenses_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/licenses",
    ...options,
  });

/**
 * Entra Get User Manager V1
 */
export const entra_get_user_manager_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/manager",
    ...options,
  });

/**
 * Entra Get User Direct Reports V1
 */
export const entra_get_user_direct_reports_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/direct-reports",
    ...options,
  });

/**
 * Entra Get User Groups V1
 */
export const entra_get_user_groups_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/groups",
    ...options,
  });

/**
 * Entra Get User Sign In State V1
 */
export const entra_get_user_sign_in_state_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses,
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses,
    GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/sign-in-state",
    ...options,
  });

/**
 * Entra Get Groups V1
 */
export const entra_get_groups_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsGroupsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsGroupsResponses,
  GetApiEntraV1TenantsByTenantIdActionsGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsGroupsResponses,
    GetApiEntraV1TenantsByTenantIdActionsGroupsErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants/{tenant_id}/actions/groups", ...options });

/**
 * Entra Get Group V1
 */
export const entra_get_group_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses,
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/groups/{group_id}",
    ...options,
  });

/**
 * Entra Get Group Members V1
 */
export const entra_get_group_members_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses,
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses,
    GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/groups/{group_id}/members",
    ...options,
  });

/**
 * Entra Get Subscribed Skus V1
 */
export const entra_get_subscribed_skus_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses,
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses,
    GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/subscribed-skus",
    ...options,
  });

/**
 * Entra Get Directory Roles V1
 */
export const entra_get_directory_roles_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses,
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/directory-roles",
    ...options,
  });

/**
 * Entra Get Directory Role Members V1
 */
export const entra_get_directory_role_members_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses,
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses,
    GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/directory-roles/{role_id}/members",
    ...options,
  });

/**
 * Entra Resolve Caller V1
 */
export const entra_resolve_caller_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiEntraV1TenantsByTenantIdActionsResolveCallerData,
    ThrowOnError
  >,
): RequestResult<
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses,
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses,
    PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/actions/resolve-caller",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Entra Get Tenants V1
 */
export const entra_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiEntraV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiEntraV1TenantsResponses,
  GetApiEntraV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiEntraV1TenantsResponses,
    GetApiEntraV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants", ...options });

/**
 * Entra Create Tenant V1
 */
export const entra_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiEntraV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiEntraV1TenantsResponses,
  PostApiEntraV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiEntraV1TenantsResponses,
    PostApiEntraV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Entra Delete Tenant V1
 */
export const entra_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiEntraV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiEntraV1TenantsByTenantIdResponses,
  DeleteApiEntraV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiEntraV1TenantsByTenantIdResponses,
    DeleteApiEntraV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants/{tenant_id}", ...options });

/**
 * Entra Get Tenant V1
 */
export const entra_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiEntraV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdResponses,
  GetApiEntraV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdResponses,
    GetApiEntraV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants/{tenant_id}", ...options });

/**
 * Entra Patch Tenant V1
 */
export const entra_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiEntraV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiEntraV1TenantsByTenantIdResponses,
  PatchApiEntraV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiEntraV1TenantsByTenantIdResponses,
    PatchApiEntraV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Entra Get Full Tenants V1
 */
export const entra_get_full_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiEntraV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiEntraV1FullTenantsResponses,
  GetApiEntraV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiEntraV1FullTenantsResponses,
    GetApiEntraV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/full-tenants", ...options });

/**
 * Entra Check Connection V1
 */
export const entra_check_connection_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdCheckConnectionResponses,
  GetApiEntraV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdCheckConnectionResponses,
    GetApiEntraV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants/{tenant_id}/check-connection", ...options });

/**
 * Entra Permission Preflight V1
 */
export const entra_permission_preflight_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdPermissionPreflightData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses,
  GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses,
    GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/permission-preflight",
    ...options,
  });

/**
 * Entra Get Proposed Actions V1
 */
export const entra_get_proposed_actions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdProposedActionsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdProposedActionsResponses,
  GetApiEntraV1TenantsByTenantIdProposedActionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdProposedActionsResponses,
    GetApiEntraV1TenantsByTenantIdProposedActionsErrors,
    ThrowOnError
  >({ url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions", ...options });

/**
 * Entra Create Proposed Action V1
 */
export const entra_create_proposed_action_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiEntraV1TenantsByTenantIdProposedActionsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiEntraV1TenantsByTenantIdProposedActionsResponses,
  PostApiEntraV1TenantsByTenantIdProposedActionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiEntraV1TenantsByTenantIdProposedActionsResponses,
    PostApiEntraV1TenantsByTenantIdProposedActionsErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Entra Get Proposed Action V1
 */
export const entra_get_proposed_action_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses,
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses,
    GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions/{action_id}",
    ...options,
  });

/**
 * Entra Approve Proposed Action V1
 */
export const entra_approve_proposed_action_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData,
    ThrowOnError
  >,
): RequestResult<
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses,
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions/{action_id}/approve",
    ...options,
  });

/**
 * Entra Reject Proposed Action V1
 */
export const entra_reject_proposed_action_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData,
    ThrowOnError
  >,
): RequestResult<
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses,
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses,
    PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors,
    ThrowOnError
  >({
    url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions/{action_id}/reject",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Judges V1
 */
export const get_judges_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1JudgesData, ThrowOnError>,
): RequestResult<GetApiV1JudgesResponses, GetApiV1JudgesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetApiV1JudgesResponses,
    GetApiV1JudgesErrors,
    ThrowOnError
  >({ url: "/api/v1/judges", ...options });

/**
 * Create Judge V1
 */
export const create_judge_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1JudgesData, ThrowOnError>,
): RequestResult<
  PostApiV1JudgesResponses,
  PostApiV1JudgesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1JudgesResponses,
    PostApiV1JudgesErrors,
    ThrowOnError
  >({
    url: "/api/v1/judges",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Judge V1
 */
export const delete_judge_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1JudgesByJudgeIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1JudgesByJudgeIdResponses,
  DeleteApiV1JudgesByJudgeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1JudgesByJudgeIdResponses,
    DeleteApiV1JudgesByJudgeIdErrors,
    ThrowOnError
  >({ url: "/api/v1/judges/{judge_id}", ...options });

/**
 * Get Judge V1
 */
export const get_judge_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1JudgesByJudgeIdData, ThrowOnError>,
): RequestResult<
  GetApiV1JudgesByJudgeIdResponses,
  GetApiV1JudgesByJudgeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1JudgesByJudgeIdResponses,
    GetApiV1JudgesByJudgeIdErrors,
    ThrowOnError
  >({ url: "/api/v1/judges/{judge_id}", ...options });

/**
 * Update Judge V1
 */
export const update_judge_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1JudgesByJudgeIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1JudgesByJudgeIdResponses,
  PatchApiV1JudgesByJudgeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1JudgesByJudgeIdResponses,
    PatchApiV1JudgesByJudgeIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/judges/{judge_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Judge V1
 */
export const restore_judge_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1JudgesByJudgeIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV1JudgesByJudgeIdRestoreResponses,
  PostApiV1JudgesByJudgeIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1JudgesByJudgeIdRestoreResponses,
    PostApiV1JudgesByJudgeIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v1/judges/{judge_id}/restore", ...options });

/**
 * Get External Inferences V1
 */
export const get_external_inferences_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1ExternalInferencesData, ThrowOnError>,
): RequestResult<
  GetApiV1ExternalInferencesResponses,
  GetApiV1ExternalInferencesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ExternalInferencesResponses,
    GetApiV1ExternalInferencesErrors,
    ThrowOnError
  >({ url: "/api/v1/external-inferences", ...options });

/**
 * Create External Inferences V1
 */
export const create_external_inferences_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1ExternalInferencesData, ThrowOnError>,
): RequestResult<
  PostApiV1ExternalInferencesResponses,
  PostApiV1ExternalInferencesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ExternalInferencesResponses,
    PostApiV1ExternalInferencesErrors,
    ThrowOnError
  >({
    url: "/api/v1/external-inferences",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete External Inference V1
 */
export const delete_external_inference_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1ExternalInferencesByInferenceIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1ExternalInferencesByInferenceIdResponses,
  DeleteApiV1ExternalInferencesByInferenceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ExternalInferencesByInferenceIdResponses,
    DeleteApiV1ExternalInferencesByInferenceIdErrors,
    ThrowOnError
  >({ url: "/api/v1/external-inferences/{inference_id}", ...options });

/**
 * Get External Inference V1
 */
export const get_external_inference_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ExternalInferencesByInferenceIdData, ThrowOnError>,
): RequestResult<
  GetApiV1ExternalInferencesByInferenceIdResponses,
  GetApiV1ExternalInferencesByInferenceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ExternalInferencesByInferenceIdResponses,
    GetApiV1ExternalInferencesByInferenceIdErrors,
    ThrowOnError
  >({ url: "/api/v1/external-inferences/{inference_id}", ...options });

/**
 * Update External Inference V1
 */
export const update_external_inference_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiV1ExternalInferencesByInferenceIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1ExternalInferencesByInferenceIdResponses,
  PatchApiV1ExternalInferencesByInferenceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ExternalInferencesByInferenceIdResponses,
    PatchApiV1ExternalInferencesByInferenceIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/external-inferences/{inference_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Finalized Conversations V2
 */
export const get_finalized_conversations_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV2FinalizedConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV2FinalizedConversationsResponses,
  GetApiV2FinalizedConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2FinalizedConversationsResponses,
    GetApiV2FinalizedConversationsErrors,
    ThrowOnError
  >({ url: "/api/v2/finalized-conversations", ...options });

/**
 * Create Finalized Conversations V2
 */
export const create_finalized_conversations_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV2FinalizedConversationsData, ThrowOnError>,
): RequestResult<
  PostApiV2FinalizedConversationsResponses,
  PostApiV2FinalizedConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2FinalizedConversationsResponses,
    PostApiV2FinalizedConversationsErrors,
    ThrowOnError
  >({
    url: "/api/v2/finalized-conversations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Finalized Conversations V2
 */
export const get_full_finalized_conversations_v2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV2FullFinalizedConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV2FullFinalizedConversationsResponses,
  GetApiV2FullFinalizedConversationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV2FullFinalizedConversationsResponses,
    GetApiV2FullFinalizedConversationsErrors,
    ThrowOnError
  >({ url: "/api/v2/full-finalized-conversations", ...options });

/**
 * Get Full Finalized Conversation V2
 */
export const get_full_finalized_conversation_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV2FullFinalizedConversationsByFinalizedConversationIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses,
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses,
    GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/full-finalized-conversations/{finalized_conversation_id}",
    ...options,
  });

/**
 * Delete Finalized Conversation V1
 */
export const delete_finalized_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1FinalizedConversationsByFinalizedConversationIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses,
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses,
    DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}",
    ...options,
  });

/**
 * Update Finalized Conversation V1
 */
export const update_finalized_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1FinalizedConversationsByFinalizedConversationIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses,
    PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Finalized Conversation V1
 */
export const restore_finalized_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses,
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses,
    PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}/restore",
    ...options,
  });

/**
 * Append Finalized Conversation Messages V1
 */
export const append_finalized_conversation_messages_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses,
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses,
    PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Finalized Conversation Message V1
 */
export const update_finalized_conversation_message_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses,
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses,
    PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}/messages/{message_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Tickets V1
 */
export const freshservice_get_tickets_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets",
    ...options,
  });

/**
 * Freshservice Create Ticket V1
 */
export const freshservice_create_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Ticket V1
 */
export const freshservice_get_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}",
    ...options,
  });

/**
 * Freshservice Update Ticket V1
 */
export const freshservice_update_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
    PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Ticket Conversations V1
 */
export const freshservice_get_ticket_conversations_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}/conversations",
    ...options,
  });

/**
 * Freshservice Reply To Ticket V1
 */
export const freshservice_reply_to_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData,
    ThrowOnError
  >,
): RequestResult<
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses,
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}/reply",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Add Note To Ticket V1
 */
export const freshservice_add_note_to_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses,
    PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Categories V1
 */
export const freshservice_get_categories_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/categories",
    ...options,
  });

/**
 * Freshservice Get Folders V1
 */
export const freshservice_get_folders_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/folders",
    ...options,
  });

/**
 * Freshservice Create Folder V1
 */
export const freshservice_create_folder_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
    ThrowOnError
  >,
): RequestResult<
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Articles V1
 */
export const freshservice_get_articles_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles",
    ...options,
  });

/**
 * Freshservice Create Article V1
 */
export const freshservice_create_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
    PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Article V1
 */
export const freshservice_get_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles/{article_id}",
    ...options,
  });

/**
 * Freshservice Update Article V1
 */
export const freshservice_update_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
    PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles/{article_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Requesters V1
 */
export const freshservice_get_requesters_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/requesters",
    ...options,
  });

/**
 * Freshservice Get Requester V1
 */
export const freshservice_get_requester_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/requesters/{requester_id}",
    ...options,
  });

/**
 * Freshservice Get Agents V1
 */
export const freshservice_get_agents_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/agents",
    ...options,
  });

/**
 * Freshservice Get Agent V1
 */
export const freshservice_get_agent_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses,
    GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/agents/{agent_id}",
    ...options,
  });

/**
 * Freshservice Get Tenants V1
 */
export const freshservice_get_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiFreshserviceV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiFreshserviceV1TenantsResponses,
  GetApiFreshserviceV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiFreshserviceV1TenantsResponses,
    GetApiFreshserviceV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/freshservice/v1/tenants", ...options });

/**
 * Freshservice Create Tenant V1
 */
export const freshservice_create_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiFreshserviceV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiFreshserviceV1TenantsResponses,
  PostApiFreshserviceV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsResponses,
    PostApiFreshserviceV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Get Full Tenants V1
 */
export const freshservice_get_full_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiFreshserviceV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiFreshserviceV1FullTenantsResponses,
  GetApiFreshserviceV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiFreshserviceV1FullTenantsResponses,
    GetApiFreshserviceV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/freshservice/v1/full-tenants", ...options });

/**
 * Freshservice Delete Tenant V1
 */
export const freshservice_delete_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApiFreshserviceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiFreshserviceV1TenantsByTenantIdResponses,
  DeleteApiFreshserviceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiFreshserviceV1TenantsByTenantIdResponses,
    DeleteApiFreshserviceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/freshservice/v1/tenants/{tenant_id}", ...options });

/**
 * Freshservice Get Tenant V1
 */
export const freshservice_get_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiFreshserviceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdResponses,
  GetApiFreshserviceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdResponses,
    GetApiFreshserviceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/freshservice/v1/tenants/{tenant_id}", ...options });

/**
 * Freshservice Patch Tenant V1
 */
export const freshservice_patch_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiFreshserviceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiFreshserviceV1TenantsByTenantIdResponses,
  PatchApiFreshserviceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiFreshserviceV1TenantsByTenantIdResponses,
    PatchApiFreshserviceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Freshservice Provision Webhook V1
 */
export const freshservice_provision_webhook_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData,
    ThrowOnError
  >,
): RequestResult<
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses,
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses,
    PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/provision-webhook",
    ...options,
  });

/**
 * Freshservice Check Connection V1
 */
export const freshservice_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses,
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses,
    GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/freshservice/v1/tenants/{tenant_id}/check-connection",
    ...options,
  });

/**
 * Get Frontend Config V1
 */
export const get_frontend_config_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1FrontendConfigData, ThrowOnError>,
): RequestResult<GetApiV1FrontendConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1FrontendConfigResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/frontend-config", ...options });

/**
 * Hubspot Reply To Thread V1
 */
export const hubspot_reply_to_thread_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiHubspotV1ActionsReplyToThreadData, ThrowOnError>,
): RequestResult<
  PostApiHubspotV1ActionsReplyToThreadResponses,
  PostApiHubspotV1ActionsReplyToThreadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV1ActionsReplyToThreadResponses,
    PostApiHubspotV1ActionsReplyToThreadErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/actions/reply-to-thread",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Create Thread On Ticket V1
 */
export const hubspot_create_thread_on_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiHubspotV1ActionsCreateThreadOnTicketData,
    ThrowOnError
  >,
): RequestResult<
  PostApiHubspotV1ActionsCreateThreadOnTicketResponses,
  PostApiHubspotV1ActionsCreateThreadOnTicketErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV1ActionsCreateThreadOnTicketResponses,
    PostApiHubspotV1ActionsCreateThreadOnTicketErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/actions/create-thread-on-ticket",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Add Note V2
 */
export const hubspot_add_note_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiHubspotV2TenantsByTenantIdActionsAddNoteData,
    ThrowOnError
  >,
): RequestResult<
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses,
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses,
    PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v2/tenants/{tenant_id}/actions/add-note",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Update Note V1
 */
export const hubspot_update_note_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiHubspotV1ActionsUpdateNoteData, ThrowOnError>,
): RequestResult<
  PostApiHubspotV1ActionsUpdateNoteResponses,
  PostApiHubspotV1ActionsUpdateNoteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV1ActionsUpdateNoteResponses,
    PostApiHubspotV1ActionsUpdateNoteErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/actions/update-note",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Set Ticket Owner V1
 */
export const hubspot_set_ticket_owner_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData,
    ThrowOnError
  >,
): RequestResult<
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses,
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/tenants/{tenant_id}/actions/set-ticket-owner",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Set Ticket Status V1
 */
export const hubspot_set_ticket_status_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData,
    ThrowOnError
  >,
): RequestResult<
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses,
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses,
    PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/tenants/{tenant_id}/actions/set-ticket-status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Update Ticket Properties V1
 */
export const hubspot_update_ticket_properties_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses,
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses,
    PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/tenants/{tenant_id}/actions/update-ticket-properties",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Get Attachment Content V1
 */
export const hubspot_get_attachment_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses,
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/tenants/{tenant_id}/actions/attachment-content",
    ...options,
  });

/**
 * Hubspot Get Attachment Metadata V1
 */
export const hubspot_get_attachment_metadata_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData,
    ThrowOnError
  >,
): RequestResult<
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses,
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses,
    GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors,
    ThrowOnError
  >({
    url: "/api/hubspot/v1/tenants/{tenant_id}/actions/attachment-metadata",
    ...options,
  });

/**
 * Hubspot List Tickets V1
 */
export const hubspot_list_tickets_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1HubspotTenantsByTenantIdTicketsData, ThrowOnError>,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdTicketsResponses,
  GetApiV1HubspotTenantsByTenantIdTicketsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdTicketsResponses,
    GetApiV1HubspotTenantsByTenantIdTicketsErrors,
    ThrowOnError
  >({ url: "/api/v1/hubspot/tenants/{tenant_id}/tickets", ...options });

/**
 * Hubspot Get Ticket V1
 */
export const hubspot_get_ticket_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses,
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}/tickets/{ticket_id}",
    ...options,
  });

/**
 * Hubspot List Ticket Notes V1
 */
export const hubspot_list_ticket_notes_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses,
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses,
    GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}/tickets/{ticket_id}/notes",
    ...options,
  });

/**
 * Hubspot Get Company V1
 */
export const hubspot_get_company_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses,
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses,
    GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}/companies/{company_id}",
    ...options,
  });

/**
 * Hubspot Get Thread V1
 */
export const hubspot_get_thread_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses,
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}/threads/{thread_id}",
    ...options,
  });

/**
 * Hubspot List Thread Messages V1
 */
export const hubspot_list_thread_messages_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses,
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses,
    GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}/threads/{thread_id}/messages",
    ...options,
  });

/**
 * Hubspot Get Tenants V1
 */
export const hubspot_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1HubspotTenantsData, ThrowOnError>,
): RequestResult<
  GetApiV1HubspotTenantsResponses,
  GetApiV1HubspotTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1HubspotTenantsResponses,
    GetApiV1HubspotTenantsErrors,
    ThrowOnError
  >({ url: "/api/v1/hubspot/tenants", ...options });

/**
 * Hubspot Create Tenant V1
 */
export const hubspot_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1HubspotTenantsData, ThrowOnError>,
): RequestResult<
  PostApiV1HubspotTenantsResponses,
  PostApiV1HubspotTenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1HubspotTenantsResponses,
    PostApiV1HubspotTenantsErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Get Full Tenants V1
 */
export const hubspot_get_full_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1HubspotFullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiV1HubspotFullTenantsResponses,
  GetApiV1HubspotFullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1HubspotFullTenantsResponses,
    GetApiV1HubspotFullTenantsErrors,
    ThrowOnError
  >({ url: "/api/v1/hubspot/full-tenants", ...options });

/**
 * Hubspot Delete Tenant V1
 */
export const hubspot_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1HubspotTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1HubspotTenantsByTenantIdResponses,
  DeleteApiV1HubspotTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1HubspotTenantsByTenantIdResponses,
    DeleteApiV1HubspotTenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/v1/hubspot/tenants/{tenant_id}", ...options });

/**
 * Hubspot Get Tenant V1
 */
export const hubspot_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1HubspotTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdResponses,
  GetApiV1HubspotTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdResponses,
    GetApiV1HubspotTenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/v1/hubspot/tenants/{tenant_id}", ...options });

/**
 * Hubspot Patch Tenant V1
 */
export const hubspot_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1HubspotTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1HubspotTenantsByTenantIdResponses,
  PatchApiV1HubspotTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1HubspotTenantsByTenantIdResponses,
    PatchApiV1HubspotTenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hubspot Check Connection V1
 */
export const hubspot_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1HubspotTenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses,
  GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses,
    GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/v1/hubspot/tenants/{tenant_id}/check-connection",
    ...options,
  });

/**
 * Hubspot Download Manifest V1
 */
export const hubspot_download_manifest_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1HubspotTenantsByTenantIdManifestData, ThrowOnError>,
): RequestResult<
  GetApiV1HubspotTenantsByTenantIdManifestResponses,
  GetApiV1HubspotTenantsByTenantIdManifestErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1HubspotTenantsByTenantIdManifestResponses,
    GetApiV1HubspotTenantsByTenantIdManifestErrors,
    ThrowOnError
  >({ url: "/api/v1/hubspot/tenants/{tenant_id}/manifest", ...options });

/**
 * Get Full Inference Conversation Inferences V2
 */
export const get_full_inference_conversation_inferences_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV2FullInferenceConversationInferencesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV2FullInferenceConversationInferencesResponses,
  GetApiV2FullInferenceConversationInferencesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2FullInferenceConversationInferencesResponses,
    GetApiV2FullInferenceConversationInferencesErrors,
    ThrowOnError
  >({ url: "/api/v2/full-inference-conversation-inferences", ...options });

/**
 * Get Inference Conversation Inference V2
 */
export const get_inference_conversation_inference_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
    GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/inference-conversation-inferences/{inference_conversation_inference_id}",
    ...options,
  });

/**
 * Update Inference Conversation Inference V1
 */
export const update_inference_conversation_inference_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
    PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/inference-conversation-inferences/{inference_conversation_inference_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Inference Conversation V2
 */
export const delete_inference_conversation_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV2InferenceConversationsByExternalIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV2InferenceConversationsByExternalIdResponses,
  DeleteApiV2InferenceConversationsByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV2InferenceConversationsByExternalIdResponses,
    DeleteApiV2InferenceConversationsByExternalIdErrors,
    ThrowOnError
  >({ url: "/api/v2/inference-conversations/{external_id}", ...options });

/**
 * Get Inference Conversation V2
 */
export const get_inference_conversation_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV2InferenceConversationsByExternalIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV2InferenceConversationsByExternalIdResponses,
  GetApiV2InferenceConversationsByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2InferenceConversationsByExternalIdResponses,
    GetApiV2InferenceConversationsByExternalIdErrors,
    ThrowOnError
  >({ url: "/api/v2/inference-conversations/{external_id}", ...options });

/**
 * Upsert Inference Conversation V2
 */
export const upsert_inference_conversation_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiV2InferenceConversationsByExternalIdData,
    ThrowOnError
  >,
): RequestResult<
  PutApiV2InferenceConversationsByExternalIdResponses,
  PutApiV2InferenceConversationsByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV2InferenceConversationsByExternalIdResponses,
    PutApiV2InferenceConversationsByExternalIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/inference-conversations/{external_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Append Inference Conversation Messages V2
 */
export const append_inference_conversation_messages_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2InferenceConversationsByExternalIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2InferenceConversationsByExternalIdMessagesResponses,
  PostApiV2InferenceConversationsByExternalIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2InferenceConversationsByExternalIdMessagesResponses,
    PostApiV2InferenceConversationsByExternalIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/v2/inference-conversations/{external_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stateless Inference Conversation Inference V2
 */
export const create_stateless_inference_conversation_inference_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2InferenceConversationsByExternalIdStatelessInferenceData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses,
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses,
    PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors,
    ThrowOnError
  >({
    url: "/api/v2/inference-conversations/{external_id}/stateless-inference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Stateful Inference Conversation Inference V2
 */
export const create_stateful_inference_conversation_inference_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2InferenceConversationsByExternalIdStatefulInferenceData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses,
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses,
    PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors,
    ThrowOnError
  >({
    url: "/api/v2/inference-conversations/{external_id}/stateful-inference",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Inference Conversation V1
 */
export const restore_inference_conversation_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1InferenceConversationsByExternalIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1InferenceConversationsByExternalIdRestoreResponses,
  PostApiV1InferenceConversationsByExternalIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1InferenceConversationsByExternalIdRestoreResponses,
    PostApiV1InferenceConversationsByExternalIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/inference-conversations/{external_id}/restore",
    ...options,
  });

/**
 * Get Full Inference Conversations V2
 */
export const get_full_inference_conversations_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV2FullInferenceConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV2FullInferenceConversationsResponses,
  GetApiV2FullInferenceConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2FullInferenceConversationsResponses,
    GetApiV2FullInferenceConversationsErrors,
    ThrowOnError
  >({ url: "/api/v2/full-inference-conversations", ...options });

/**
 * Get Inference Conversations V2
 */
export const get_inference_conversations_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV2InferenceConversationsData, ThrowOnError>,
): RequestResult<
  GetApiV2InferenceConversationsResponses,
  GetApiV2InferenceConversationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2InferenceConversationsResponses,
    GetApiV2InferenceConversationsErrors,
    ThrowOnError
  >({ url: "/api/v2/inference-conversations", ...options });

/**
 * Get Full Inference Datapoints V1
 */
export const get_full_inference_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullInferenceDatapointsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullInferenceDatapointsResponses,
  GetApiV1FullInferenceDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullInferenceDatapointsResponses,
    GetApiV1FullInferenceDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-inference-datapoints", ...options });

/**
 * Get Full Inference Datapoint V1
 */
export const get_full_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1FullInferenceDatapointsByInferenceDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses,
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses,
    GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/full-inference-datapoints/{inference_datapoint_id}",
    ...options,
  });

/**
 * Search Full Evaluated Inference Datapoints V1
 */
export const search_full_evaluated_inference_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1FullEvaluatedInferenceDatapointsSearchData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1FullEvaluatedInferenceDatapointsSearchResponses,
  PostApiV1FullEvaluatedInferenceDatapointsSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1FullEvaluatedInferenceDatapointsSearchResponses,
    PostApiV1FullEvaluatedInferenceDatapointsSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/full-evaluated-inference-datapoints/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Judgement Filter Options V1
 */
export const judgement_filter_options_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses,
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses,
    PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors,
    ThrowOnError
  >({
    url: "/api/v1/full-evaluated-inference-datapoints/judgement-filter-options",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Evaluated Inference Datapoints V1
 */
export const get_evaluated_inference_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1EvaluatedInferenceDatapointsData, ThrowOnError>,
): RequestResult<
  GetApiV1EvaluatedInferenceDatapointsResponses,
  GetApiV1EvaluatedInferenceDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1EvaluatedInferenceDatapointsResponses,
    GetApiV1EvaluatedInferenceDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v1/evaluated-inference-datapoints", ...options });

/**
 * Create Inference Datapoint V2
 */
export const create_inference_datapoint_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV2InferenceDatapointsData, ThrowOnError>,
): RequestResult<
  PostApiV2InferenceDatapointsResponses,
  PostApiV2InferenceDatapointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2InferenceDatapointsResponses,
    PostApiV2InferenceDatapointsErrors,
    ThrowOnError
  >({
    url: "/api/v2/inference-datapoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Inference Datapoint V1
 */
export const delete_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1InferenceDatapointsByInferenceDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses,
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses,
    DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/inference-datapoints/{inference_datapoint_id}",
    ...options,
  });

/**
 * Update Inference Datapoint V1
 */
export const update_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1InferenceDatapointsByInferenceDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses,
  PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses,
    PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/inference-datapoints/{inference_datapoint_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Inference Datapoint V1
 */
export const restore_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses,
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses,
    PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/inference-datapoints/{inference_datapoint_id}/restore",
    ...options,
  });

/**
 * Get Inference Feedback V1
 */
export const get_inference_feedback_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1InferenceFeedbackData, ThrowOnError>,
): RequestResult<
  GetApiV1InferenceFeedbackResponses,
  GetApiV1InferenceFeedbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1InferenceFeedbackResponses,
    GetApiV1InferenceFeedbackErrors,
    ThrowOnError
  >({ url: "/api/v1/inference-feedback", ...options });

/**
 * Get Feedback Labels V1
 */
export const get_feedback_labels_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1TasksByTaskIdFeedbackLabelsData, ThrowOnError>,
): RequestResult<
  GetApiV1TasksByTaskIdFeedbackLabelsResponses,
  GetApiV1TasksByTaskIdFeedbackLabelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1TasksByTaskIdFeedbackLabelsResponses,
    GetApiV1TasksByTaskIdFeedbackLabelsErrors,
    ThrowOnError
  >({ url: "/api/v1/tasks/{task_id}/feedback-labels", ...options });

/**
 * Create Feedback Label V1
 */
export const create_feedback_label_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1TasksByTaskIdFeedbackLabelsData, ThrowOnError>,
): RequestResult<
  PostApiV1TasksByTaskIdFeedbackLabelsResponses,
  PostApiV1TasksByTaskIdFeedbackLabelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1TasksByTaskIdFeedbackLabelsResponses,
    PostApiV1TasksByTaskIdFeedbackLabelsErrors,
    ThrowOnError
  >({
    url: "/api/v1/tasks/{task_id}/feedback-labels",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Inference Feedback Label V1
 */
export const create_inference_feedback_label_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1TasksByTaskIdInferencesFeedbackLabelsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses,
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses,
    PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors,
    ThrowOnError
  >({
    url: "/api/v1/tasks/{task_id}/inferences/feedback-labels",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Inference Feedback V1
 */
export const create_inference_feedback_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses,
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses,
    PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors,
    ThrowOnError
  >({
    url: "/api/v1/tasks/{task_id}/inferences/{inference_id}/feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Kb Ingestion Files V1
 */
export const create_kb_ingestion_files_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1IngestionKnowledgeBasesIngestionFilesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1IngestionKnowledgeBasesIngestionFilesResponses,
  PostApiV1IngestionKnowledgeBasesIngestionFilesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1IngestionKnowledgeBasesIngestionFilesResponses,
    PostApiV1IngestionKnowledgeBasesIngestionFilesErrors,
    ThrowOnError
  >({
    url: "/api/v1/ingestion/knowledge-bases/ingestion-files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Support Ingestion Files V1
 */
export const create_support_ingestion_files_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1IngestionSupportIngestionFilesData, ThrowOnError>,
): RequestResult<
  PostApiV1IngestionSupportIngestionFilesResponses,
  PostApiV1IngestionSupportIngestionFilesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1IngestionSupportIngestionFilesResponses,
    PostApiV1IngestionSupportIngestionFilesErrors,
    ThrowOnError
  >({
    url: "/api/v1/ingestion/support/ingestion-files",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Jira Post Comment V2
 */
export const jira_post_comment_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiJiraV2TenantsByTenantIdActionsPostCommentData,
    ThrowOnError
  >,
): RequestResult<
  PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses,
  PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses,
    PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors,
    ThrowOnError
  >({
    url: "/api/jira/v2/tenants/{tenant_id}/actions/post-comment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Jira Get Attachment Content V2
 */
export const jira_get_attachment_content_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses,
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses,
    GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors,
    ThrowOnError
  >({
    url: "/api/jira/v2/tenants/{tenant_id}/actions/attachment-content",
    ...options,
  });

/**
 * Jira Update Issue Labels V1
 */
export const jira_update_issue_labels_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses,
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses,
    PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors,
    ThrowOnError
  >({
    url: "/api/jira/v1/tenants/{tenant_id}/actions/update-issue-labels",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Jira Set Custom Field V1
 */
export const jira_set_custom_field_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData,
    ThrowOnError
  >,
): RequestResult<
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses,
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses,
    PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors,
    ThrowOnError
  >({
    url: "/api/jira/v1/tenants/{tenant_id}/actions/set-custom-field",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Jira Get Issue V1
 */
export const jira_get_issue_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiJiraV1TenantsByTenantIdActionsGetIssueData,
    ThrowOnError
  >,
): RequestResult<
  GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses,
  GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses,
    GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/tenants/{tenant_id}/actions/get-issue", ...options });

/**
 * Jira Get Custom Field Options V1
 */
export const jira_get_custom_field_options_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses,
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses,
    GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors,
    ThrowOnError
  >({
    url: "/api/jira/v1/tenants/{tenant_id}/actions/get-custom-field-options",
    ...options,
  });

/**
 * Jira Get Issues V1
 */
export const jira_get_issues_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiJiraV1TenantsByTenantIdActionsGetIssuesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses,
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses,
    GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/tenants/{tenant_id}/actions/get-issues", ...options });

/**
 * Jira Get Tenants V1
 */
export const jira_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiJiraV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiJiraV1TenantsResponses,
  GetApiJiraV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiJiraV1TenantsResponses,
    GetApiJiraV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/tenants", ...options });

/**
 * Jira Create Tenant V1
 */
export const jira_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiJiraV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiJiraV1TenantsResponses,
  PostApiJiraV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiJiraV1TenantsResponses,
    PostApiJiraV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/jira/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Jira Get Full Tenants V1
 */
export const jira_get_full_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiJiraV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiJiraV1FullTenantsResponses,
  GetApiJiraV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiJiraV1FullTenantsResponses,
    GetApiJiraV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/full-tenants", ...options });

/**
 * Jira Delete Tenant V1
 */
export const jira_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiJiraV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiJiraV1TenantsByTenantIdResponses,
  DeleteApiJiraV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiJiraV1TenantsByTenantIdResponses,
    DeleteApiJiraV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/tenants/{tenant_id}", ...options });

/**
 * Jira Get Tenant V1
 */
export const jira_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiJiraV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiJiraV1TenantsByTenantIdResponses,
  GetApiJiraV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiJiraV1TenantsByTenantIdResponses,
    GetApiJiraV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/tenants/{tenant_id}", ...options });

/**
 * Jira Patch Tenant V1
 */
export const jira_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiJiraV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiJiraV1TenantsByTenantIdResponses,
  PatchApiJiraV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiJiraV1TenantsByTenantIdResponses,
    PatchApiJiraV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/jira/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Jira Check Connection V1
 */
export const jira_check_connection_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiJiraV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiJiraV1TenantsByTenantIdCheckConnectionResponses,
  GetApiJiraV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiJiraV1TenantsByTenantIdCheckConnectionResponses,
    GetApiJiraV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({ url: "/api/jira/v1/tenants/{tenant_id}/check-connection", ...options });

/**
 * Get Judgements V2
 */
export const get_judgements_v2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV2JudgementsData, ThrowOnError>,
): RequestResult<
  GetApiV2JudgementsResponses,
  GetApiV2JudgementsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV2JudgementsResponses,
    GetApiV2JudgementsErrors,
    ThrowOnError
  >({ url: "/api/v2/judgements", ...options });

/**
 * Create Judgements V2
 */
export const create_judgements_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2JudgementsData, ThrowOnError>,
): RequestResult<
  PostApiV2JudgementsResponses,
  PostApiV2JudgementsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2JudgementsResponses,
    PostApiV2JudgementsErrors,
    ThrowOnError
  >({
    url: "/api/v2/judgements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Judgement V2
 */
export const delete_judgement_v2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV2JudgementsByJudgementIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV2JudgementsByJudgementIdResponses,
  DeleteApiV2JudgementsByJudgementIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV2JudgementsByJudgementIdResponses,
    DeleteApiV2JudgementsByJudgementIdErrors,
    ThrowOnError
  >({ url: "/api/v2/judgements/{judgement_id}", ...options });

/**
 * Create Judgements V3
 */
export const create_judgements_v3 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV3JudgementsData, ThrowOnError>,
): RequestResult<
  PostApiV3JudgementsResponses,
  PostApiV3JudgementsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV3JudgementsResponses,
    PostApiV3JudgementsErrors,
    ThrowOnError
  >({
    url: "/api/v3/judgements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Judgements Full V3
 */
export const get_judgements_full_v3 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV3FullJudgementsData, ThrowOnError>,
): RequestResult<
  GetApiV3FullJudgementsResponses,
  GetApiV3FullJudgementsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV3FullJudgementsResponses,
    GetApiV3FullJudgementsErrors,
    ThrowOnError
  >({ url: "/api/v3/full-judgements", ...options });

/**
 * Delete Judgement V3
 */
export const delete_judgement_v3 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV3JudgementsByJudgementIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV3JudgementsByJudgementIdResponses,
  DeleteApiV3JudgementsByJudgementIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV3JudgementsByJudgementIdResponses,
    DeleteApiV3JudgementsByJudgementIdErrors,
    ThrowOnError
  >({ url: "/api/v3/judgements/{judgement_id}", ...options });

/**
 * Get Judges V2
 */
export const get_judges_v2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV2JudgesData, ThrowOnError>,
): RequestResult<GetApiV2JudgesResponses, GetApiV2JudgesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV2JudgesResponses,
    GetApiV2JudgesErrors,
    ThrowOnError
  >({ url: "/api/v2/judges", ...options });

/**
 * Create Judge V2
 */
export const create_judge_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2JudgesData, ThrowOnError>,
): RequestResult<
  PostApiV2JudgesResponses,
  PostApiV2JudgesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2JudgesResponses,
    PostApiV2JudgesErrors,
    ThrowOnError
  >({
    url: "/api/v2/judges",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Judges V2
 */
export const create_judges_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2JudgesBulkData, ThrowOnError>,
): RequestResult<
  PostApiV2JudgesBulkResponses,
  PostApiV2JudgesBulkErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2JudgesBulkResponses,
    PostApiV2JudgesBulkErrors,
    ThrowOnError
  >({
    url: "/api/v2/judges/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sync Judges V1
 */
export const sync_judges_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<PostApiV1JudgesSyncData, ThrowOnError>,
): RequestResult<PostApiV1JudgesSyncResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostApiV1JudgesSyncResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/judges/sync", ...options });

/**
 * Delete Judge V2
 */
export const delete_judge_v2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV2JudgesByJudgeIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV2JudgesByJudgeIdResponses,
  DeleteApiV2JudgesByJudgeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV2JudgesByJudgeIdResponses,
    DeleteApiV2JudgesByJudgeIdErrors,
    ThrowOnError
  >({ url: "/api/v2/judges/{judge_id}", ...options });

/**
 * Get Judge V2
 */
export const get_judge_v2 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV2JudgesByJudgeIdData, ThrowOnError>,
): RequestResult<
  GetApiV2JudgesByJudgeIdResponses,
  GetApiV2JudgesByJudgeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2JudgesByJudgeIdResponses,
    GetApiV2JudgesByJudgeIdErrors,
    ThrowOnError
  >({ url: "/api/v2/judges/{judge_id}", ...options });

/**
 * Patch Judge V2
 */
export const patch_judge_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV2JudgesByJudgeIdData, ThrowOnError>,
): RequestResult<
  PatchApiV2JudgesByJudgeIdResponses,
  PatchApiV2JudgesByJudgeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV2JudgesByJudgeIdResponses,
    PatchApiV2JudgesByJudgeIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/judges/{judge_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Kanonical Datapoints V2
 */
export const get_kanonical_datapoints_v2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV2KanonicalDatapointsData, ThrowOnError>,
): RequestResult<
  GetApiV2KanonicalDatapointsResponses,
  GetApiV2KanonicalDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV2KanonicalDatapointsResponses,
    GetApiV2KanonicalDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v2/kanonical-datapoints", ...options });

/**
 * Create Kanonical Datapoints V2
 */
export const create_kanonical_datapoints_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV2KanonicalDatapointsData, ThrowOnError>,
): RequestResult<
  PostApiV2KanonicalDatapointsResponses,
  PostApiV2KanonicalDatapointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2KanonicalDatapointsResponses,
    PostApiV2KanonicalDatapointsErrors,
    ThrowOnError
  >({
    url: "/api/v2/kanonical-datapoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Kanonical Datapoint V2
 */
export const get_kanonical_datapoint_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV2KanonicalDatapointsByKanonicalDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses,
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses,
    GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/kanonical-datapoints/{kanonical_datapoint_id}",
    ...options,
  });

/**
 * Delete Kanonical Datapoint V1
 */
export const delete_kanonical_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
    DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kanonical-datapoints/{kanonical_datapoint_id}",
    ...options,
  });

/**
 * Update Kanonical Datapoint V1
 */
export const update_kanonical_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
    PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kanonical-datapoints/{kanonical_datapoint_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Kanonical Datapoint V1
 */
export const restore_kanonical_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses,
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses,
    PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/kanonical-datapoints/{kanonical_datapoint_id}/restore",
    ...options,
  });

/**
 * Create Image Upload Url V1
 */
export const create_image_upload_url_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1ImageAttachmentsUploadUrlData, ThrowOnError>,
): RequestResult<
  PostApiV1ImageAttachmentsUploadUrlResponses,
  PostApiV1ImageAttachmentsUploadUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ImageAttachmentsUploadUrlResponses,
    PostApiV1ImageAttachmentsUploadUrlErrors,
    ThrowOnError
  >({
    url: "/api/v1/image-attachments/upload-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Download Image Attachment V1
 */
export const download_image_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ImageAttachmentsDownloadByFilePathData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ImageAttachmentsDownloadByFilePathResponses,
  GetApiV1ImageAttachmentsDownloadByFilePathErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ImageAttachmentsDownloadByFilePathResponses,
    GetApiV1ImageAttachmentsDownloadByFilePathErrors,
    ThrowOnError
  >({ url: "/api/v1/image-attachments/download/{file_path}", ...options });

/**
 * Get Kb Access Requests V1
 */
export const get_kb_access_requests_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests",
    ...options,
  });

/**
 * Create Kb Access Request V1
 */
export const create_kb_access_request_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get My Kb Access Request V1
 */
export const get_my_kb_access_request_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses,
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses,
    GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/knowledge-bases/{kb_id}/kb-access-requests/mine",
    ...options,
  });

/**
 * Get Requester Teams V1
 */
export const get_requester_teams_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses,
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests/{request_id}/requester-teams",
    ...options,
  });

/**
 * Get Teams With Access V1
 */
export const get_teams_with_access_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses,
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses,
    GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests/{request_id}/teams-with-access",
    ...options,
  });

/**
 * Resolve Kb Access Request V1
 */
export const resolve_kb_access_request_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses,
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses,
    PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors,
    ThrowOnError
  >({
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests/{request_id}/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Kb Upload Url V1
 */
export const create_kb_upload_url_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1KbAttachmentsUploadUrlData, ThrowOnError>,
): RequestResult<
  PostApiV1KbAttachmentsUploadUrlResponses,
  PostApiV1KbAttachmentsUploadUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbAttachmentsUploadUrlResponses,
    PostApiV1KbAttachmentsUploadUrlErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-attachments/upload-url",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Download Kb Attachment V1
 */
export const download_kb_attachment_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1KbAttachmentsDownloadByFilePathData, ThrowOnError>,
): RequestResult<
  GetApiV1KbAttachmentsDownloadByFilePathResponses,
  GetApiV1KbAttachmentsDownloadByFilePathErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1KbAttachmentsDownloadByFilePathResponses,
    GetApiV1KbAttachmentsDownloadByFilePathErrors,
    ThrowOnError
  >({ url: "/api/v1/kb-attachments/download/{file_path}", ...options });

/**
 * Get Full Kb Simulation Datapoints V1
 */
export const get_full_kb_simulation_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullKbSimulationDatapointsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullKbSimulationDatapointsResponses,
  GetApiV1FullKbSimulationDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullKbSimulationDatapointsResponses,
    GetApiV1FullKbSimulationDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-kb-simulation-datapoints", ...options });

/**
 * Get Full Kb Simulation Datapoint V1
 */
export const get_full_kb_simulation_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses,
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses,
    GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/full-kb-simulation-datapoints/{simulation_datapoint_id}",
    ...options,
  });

/**
 * Get Kb Simulation Datapoints V1
 */
export const get_kb_simulation_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1KbSimulationDatapointsData, ThrowOnError>,
): RequestResult<
  GetApiV1KbSimulationDatapointsResponses,
  GetApiV1KbSimulationDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1KbSimulationDatapointsResponses,
    GetApiV1KbSimulationDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v1/kb-simulation-datapoints", ...options });

/**
 * Create Kb Simulation Datapoint V1
 */
export const create_kb_simulation_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1KbSimulationDatapointsData, ThrowOnError>,
): RequestResult<
  PostApiV1KbSimulationDatapointsResponses,
  PostApiV1KbSimulationDatapointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationDatapointsResponses,
    PostApiV1KbSimulationDatapointsErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-datapoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Kb Simulation Datapoints V1
 */
export const create_kb_simulation_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1KbSimulationDatapointsBatchData, ThrowOnError>,
): RequestResult<
  PostApiV1KbSimulationDatapointsBatchResponses,
  PostApiV1KbSimulationDatapointsBatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationDatapointsBatchResponses,
    PostApiV1KbSimulationDatapointsBatchErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-datapoints/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Kb Simulation Datapoint V1
 */
export const delete_kb_simulation_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
    DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}",
    ...options,
  });

/**
 * Get Kb Simulation Datapoint V1
 */
export const get_kb_simulation_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1KbSimulationDatapointsBySimulationDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
    GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}",
    ...options,
  });

/**
 * Update Kb Simulation Datapoint V1
 */
export const update_kb_simulation_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
    PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Kb Simulation Datapoint V1
 */
export const restore_kb_simulation_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses,
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses,
    PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}/restore",
    ...options,
  });

/**
 * Get Full Kb Simulation Results V1
 */
export const get_full_kb_simulation_results_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullKbSimulationResultsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullKbSimulationResultsResponses,
  GetApiV1FullKbSimulationResultsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullKbSimulationResultsResponses,
    GetApiV1FullKbSimulationResultsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-kb-simulation-results", ...options });

/**
 * Get Full Kb Simulation Result V1
 */
export const get_full_kb_simulation_result_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1FullKbSimulationResultsBySimulationResultIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1FullKbSimulationResultsBySimulationResultIdResponses,
  GetApiV1FullKbSimulationResultsBySimulationResultIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1FullKbSimulationResultsBySimulationResultIdResponses,
    GetApiV1FullKbSimulationResultsBySimulationResultIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/full-kb-simulation-results/{simulation_result_id}",
    ...options,
  });

/**
 * Get Kb Simulation Results V1
 */
export const get_kb_simulation_results_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1KbSimulationResultsData, ThrowOnError>,
): RequestResult<
  GetApiV1KbSimulationResultsResponses,
  GetApiV1KbSimulationResultsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1KbSimulationResultsResponses,
    GetApiV1KbSimulationResultsErrors,
    ThrowOnError
  >({ url: "/api/v1/kb-simulation-results", ...options });

/**
 * Create Kb Simulation Result V1
 */
export const create_kb_simulation_result_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1KbSimulationResultsData, ThrowOnError>,
): RequestResult<
  PostApiV1KbSimulationResultsResponses,
  PostApiV1KbSimulationResultsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationResultsResponses,
    PostApiV1KbSimulationResultsErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Kb Simulation Results V1
 */
export const create_kb_simulation_results_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1KbSimulationResultsBatchData, ThrowOnError>,
): RequestResult<
  PostApiV1KbSimulationResultsBatchResponses,
  PostApiV1KbSimulationResultsBatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationResultsBatchResponses,
    PostApiV1KbSimulationResultsBatchErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Kb Simulation Result Judgements Batch V1
 */
export const create_kb_simulation_result_judgements_batch_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1KbSimulationResultJudgementsBatchData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1KbSimulationResultJudgementsBatchResponses,
  PostApiV1KbSimulationResultJudgementsBatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationResultJudgementsBatchResponses,
    PostApiV1KbSimulationResultJudgementsBatchErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-result-judgements/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Kb Simulation Result Judgements V1
 */
export const get_full_kb_simulation_result_judgements_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullKbSimulationResultJudgementsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullKbSimulationResultJudgementsResponses,
  GetApiV1FullKbSimulationResultJudgementsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullKbSimulationResultJudgementsResponses,
    GetApiV1FullKbSimulationResultJudgementsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-kb-simulation-result-judgements", ...options });

/**
 * Get Full Kb Simulation Run V1
 */
export const get_full_kb_simulation_run_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1FullKbSimulationRunData, ThrowOnError>,
): RequestResult<
  GetApiV1FullKbSimulationRunResponses,
  GetApiV1FullKbSimulationRunErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1FullKbSimulationRunResponses,
    GetApiV1FullKbSimulationRunErrors,
    ThrowOnError
  >({ url: "/api/v1/full-kb-simulation-run", ...options });

/**
 * Get Full Kb Simulation Compare V1
 */
export const get_full_kb_simulation_compare_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1FullKbSimulationCompareData, ThrowOnError>,
): RequestResult<
  GetApiV1FullKbSimulationCompareResponses,
  GetApiV1FullKbSimulationCompareErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1FullKbSimulationCompareResponses,
    GetApiV1FullKbSimulationCompareErrors,
    ThrowOnError
  >({ url: "/api/v1/full-kb-simulation-compare", ...options });

/**
 * Delete Kb Simulation Result V1
 */
export const delete_kb_simulation_result_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1KbSimulationResultsBySimulationResultIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1KbSimulationResultsBySimulationResultIdResponses,
  DeleteApiV1KbSimulationResultsBySimulationResultIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1KbSimulationResultsBySimulationResultIdResponses,
    DeleteApiV1KbSimulationResultsBySimulationResultIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results/{simulation_result_id}",
    ...options,
  });

/**
 * Get Kb Simulation Result V1
 */
export const get_kb_simulation_result_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1KbSimulationResultsBySimulationResultIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1KbSimulationResultsBySimulationResultIdResponses,
  GetApiV1KbSimulationResultsBySimulationResultIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1KbSimulationResultsBySimulationResultIdResponses,
    GetApiV1KbSimulationResultsBySimulationResultIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results/{simulation_result_id}",
    ...options,
  });

/**
 * Update Kb Simulation Result V1
 */
export const update_kb_simulation_result_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1KbSimulationResultsBySimulationResultIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1KbSimulationResultsBySimulationResultIdResponses,
  PatchApiV1KbSimulationResultsBySimulationResultIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1KbSimulationResultsBySimulationResultIdResponses,
    PatchApiV1KbSimulationResultsBySimulationResultIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results/{simulation_result_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Kb Simulation Result V1
 */
export const restore_kb_simulation_result_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1KbSimulationResultsBySimulationResultIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses,
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses,
    PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results/{simulation_result_id}/restore",
    ...options,
  });

/**
 * Create Kb Simulation Result Judgements V1
 */
export const create_kb_simulation_result_judgements_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses,
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses,
    PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors,
    ThrowOnError
  >({
    url: "/api/v1/kb-simulation-results/{simulation_result_id}/judgements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Kb Simulation Branch Breakdown Stats V1
 */
export const get_kb_simulation_branch_breakdown_stats_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1KbSimulationBranchBreakdownStatsData, ThrowOnError>,
): RequestResult<
  GetApiV1KbSimulationBranchBreakdownStatsResponses,
  GetApiV1KbSimulationBranchBreakdownStatsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1KbSimulationBranchBreakdownStatsResponses,
    GetApiV1KbSimulationBranchBreakdownStatsErrors,
    ThrowOnError
  >({ url: "/api/v1/kb-simulation-branch-breakdown-stats", ...options });

/**
 * Get Kb Simulation Compare Summary V1
 */
export const get_kb_simulation_compare_summary_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1KbSimulationCompareSummaryData, ThrowOnError>,
): RequestResult<
  GetApiV1KbSimulationCompareSummaryResponses,
  GetApiV1KbSimulationCompareSummaryErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1KbSimulationCompareSummaryResponses,
    GetApiV1KbSimulationCompareSummaryErrors,
    ThrowOnError
  >({ url: "/api/v1/kb-simulation-compare-summary", ...options });

/**
 * Get Kb Simulation Commits V1
 */
export const get_kb_simulation_commits_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1KbSimulationCommitsData, ThrowOnError>,
): RequestResult<
  GetApiV1KbSimulationCommitsResponses,
  GetApiV1KbSimulationCommitsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1KbSimulationCommitsResponses,
    GetApiV1KbSimulationCommitsErrors,
    ThrowOnError
  >({ url: "/api/v1/kb-simulation-commits", ...options });

/**
 * Get Article Tags V1
 */
export const get_article_tags_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1ArticleTagsData, ThrowOnError>,
): RequestResult<
  GetApiV1ArticleTagsResponses,
  GetApiV1ArticleTagsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ArticleTagsResponses,
    GetApiV1ArticleTagsErrors,
    ThrowOnError
  >({ url: "/api/v1/article-tags", ...options });

/**
 * Get Knowledge Bases V4
 */
export const get_knowledge_bases_v4 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV4KbsData, ThrowOnError>,
): RequestResult<GetApiV4KbsResponses, GetApiV4KbsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV4KbsResponses,
    GetApiV4KbsErrors,
    ThrowOnError
  >({ url: "/api/v4/kbs", ...options });

/**
 * Get Knowledge Base V2
 */
export const get_knowledge_base_v2 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV2KbsByKbIdData, ThrowOnError>,
): RequestResult<
  GetApiV2KbsByKbIdResponses,
  GetApiV2KbsByKbIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2KbsByKbIdResponses,
    GetApiV2KbsByKbIdErrors,
    ThrowOnError
  >({ url: "/api/v2/kbs/{kb_id}", ...options });

/**
 * Delete Knowledge Base V3
 */
export const delete_knowledge_base_v3 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV3KbsByKbIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV3KbsByKbIdResponses,
  DeleteApiV3KbsByKbIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV3KbsByKbIdResponses,
    DeleteApiV3KbsByKbIdErrors,
    ThrowOnError
  >({ url: "/api/v3/kbs/{kb_id}", ...options });

/**
 * Patch Knowledge Base V3
 */
export const patch_knowledge_base_v3 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV3KbsByKbIdData, ThrowOnError>,
): RequestResult<
  PatchApiV3KbsByKbIdResponses,
  PatchApiV3KbsByKbIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV3KbsByKbIdResponses,
    PatchApiV3KbsByKbIdErrors,
    ThrowOnError
  >({
    url: "/api/v3/kbs/{kb_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Patch Knowledge Base Review Sla V3
 */
export const patch_knowledge_base_review_sla_v3 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiV3KbsByKbIdCrReviewSlaData, ThrowOnError>,
): RequestResult<
  PatchApiV3KbsByKbIdCrReviewSlaResponses,
  PatchApiV3KbsByKbIdCrReviewSlaErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV3KbsByKbIdCrReviewSlaResponses,
    PatchApiV3KbsByKbIdCrReviewSlaErrors,
    ThrowOnError
  >({
    url: "/api/v3/kbs/{kb_id}/cr-review-sla",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Knowledge Base V3
 */
export const restore_knowledge_base_v3 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV3KbsByKbIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV3KbsByKbIdRestoreResponses,
  PostApiV3KbsByKbIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV3KbsByKbIdRestoreResponses,
    PostApiV3KbsByKbIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v3/kbs/{kb_id}/restore", ...options });

/**
 * Embed V2
 */
export const embed_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2KbsByKbIdEmbedData, ThrowOnError>,
): RequestResult<
  PostApiV2KbsByKbIdEmbedResponses,
  PostApiV2KbsByKbIdEmbedErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2KbsByKbIdEmbedResponses,
    PostApiV2KbsByKbIdEmbedErrors,
    ThrowOnError
  >({ url: "/api/v2/kbs/{kb_id}/embed", ...options });

/**
 * Get Embedding Summary V2
 */
export const get_embedding_summary_v2 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV2KbsByKbIdEmbeddingSummaryData, ThrowOnError>,
): RequestResult<
  GetApiV2KbsByKbIdEmbeddingSummaryResponses,
  GetApiV2KbsByKbIdEmbeddingSummaryErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2KbsByKbIdEmbeddingSummaryResponses,
    GetApiV2KbsByKbIdEmbeddingSummaryErrors,
    ThrowOnError
  >({ url: "/api/v2/kbs/{kb_id}/embedding-summary", ...options });

/**
 * Embedding Search V1
 */
export const embedding_search_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1KbsByKbIdEmbeddingSearchData, ThrowOnError>,
): RequestResult<
  PostApiV1KbsByKbIdEmbeddingSearchResponses,
  PostApiV1KbsByKbIdEmbeddingSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbsByKbIdEmbeddingSearchResponses,
    PostApiV1KbsByKbIdEmbeddingSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/kbs/{kb_id}/embedding-search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Hybrid Search V1
 */
export const hybrid_search_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1KbsByKbIdHybridSearchData, ThrowOnError>,
): RequestResult<
  PostApiV1KbsByKbIdHybridSearchResponses,
  PostApiV1KbsByKbIdHybridSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbsByKbIdHybridSearchResponses,
    PostApiV1KbsByKbIdHybridSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/kbs/{kb_id}/hybrid-search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Regex Search Articles V1
 */
export const regex_search_articles_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1KbsByKbIdRegexSearchData, ThrowOnError>,
): RequestResult<
  PostApiV1KbsByKbIdRegexSearchResponses,
  PostApiV1KbsByKbIdRegexSearchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1KbsByKbIdRegexSearchResponses,
    PostApiV1KbsByKbIdRegexSearchErrors,
    ThrowOnError
  >({
    url: "/api/v1/kbs/{kb_id}/regex-search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Object Article V1
 */
export const get_object_article_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ObjectArticleByObjectArticleIdData, ThrowOnError>,
): RequestResult<
  GetApiV1ObjectArticleByObjectArticleIdResponses,
  GetApiV1ObjectArticleByObjectArticleIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ObjectArticleByObjectArticleIdResponses,
    GetApiV1ObjectArticleByObjectArticleIdErrors,
    ThrowOnError
  >({ url: "/api/v1/object-article/{object_article_id}", ...options });

/**
 * Patch Article V1
 */
export const patch_article_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1KbsByKbIdArticlesByArticleIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1KbsByKbIdArticlesByArticleIdResponses,
  PatchApiV1KbsByKbIdArticlesByArticleIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1KbsByKbIdArticlesByArticleIdResponses,
    PatchApiV1KbsByKbIdArticlesByArticleIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/kbs/{kb_id}/articles/{article_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Owned Knowledge Bases V1
 */
export const get_owned_knowledge_bases_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1KbsOwnedData, ThrowOnError>,
): RequestResult<
  GetApiV1KbsOwnedResponses,
  GetApiV1KbsOwnedErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1KbsOwnedResponses,
    GetApiV1KbsOwnedErrors,
    ThrowOnError
  >({ url: "/api/v1/kbs/owned", ...options });

/**
 * Create Knowledge Base V1
 */
export const create_knowledge_base_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1KbsData, ThrowOnError>,
): RequestResult<PostApiV1KbsResponses, PostApiV1KbsErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PostApiV1KbsResponses,
    PostApiV1KbsErrors,
    ThrowOnError
  >({
    url: "/api/v1/kbs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update Index Text V3
 */
export const update_index_text_v3 = <ThrowOnError extends boolean = false>(
  options: Options<
    PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData,
    ThrowOnError
  >,
): RequestResult<
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses,
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses,
    PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors,
    ThrowOnError
  >({
    url: "/api/v3/kbs/{kb_id}/article/{ref}/{article_id}/index-text",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Machine Users V1
 */
export const get_machine_users_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1MachineUsersData, ThrowOnError>,
): RequestResult<
  GetApiV1MachineUsersResponses,
  GetApiV1MachineUsersErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1MachineUsersResponses,
    GetApiV1MachineUsersErrors,
    ThrowOnError
  >({ url: "/api/v1/machine-users", ...options });

/**
 * Create Machine User V1
 */
export const create_machine_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1MachineUsersData, ThrowOnError>,
): RequestResult<
  PostApiV1MachineUsersResponses,
  PostApiV1MachineUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1MachineUsersResponses,
    PostApiV1MachineUsersErrors,
    ThrowOnError
  >({
    url: "/api/v1/machine-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Machine User V1
 */
export const delete_machine_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1MachineUsersByMachineUserIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1MachineUsersByMachineUserIdResponses,
  DeleteApiV1MachineUsersByMachineUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1MachineUsersByMachineUserIdResponses,
    DeleteApiV1MachineUsersByMachineUserIdErrors,
    ThrowOnError
  >({ url: "/api/v1/machine-users/{machine_user_id}", ...options });

/**
 * Get Machine User V1
 */
export const get_machine_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1MachineUsersByMachineUserIdData, ThrowOnError>,
): RequestResult<
  GetApiV1MachineUsersByMachineUserIdResponses,
  GetApiV1MachineUsersByMachineUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1MachineUsersByMachineUserIdResponses,
    GetApiV1MachineUsersByMachineUserIdErrors,
    ThrowOnError
  >({ url: "/api/v1/machine-users/{machine_user_id}", ...options });

/**
 * Update Machine User V1
 */
export const update_machine_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1MachineUsersByMachineUserIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1MachineUsersByMachineUserIdResponses,
  PatchApiV1MachineUsersByMachineUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1MachineUsersByMachineUserIdResponses,
    PatchApiV1MachineUsersByMachineUserIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/machine-users/{machine_user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Machine User Api Keys V1
 */
export const get_machine_user_api_keys_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1MachineUsersByMachineUserIdApiKeysData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1MachineUsersByMachineUserIdApiKeysResponses,
  GetApiV1MachineUsersByMachineUserIdApiKeysErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1MachineUsersByMachineUserIdApiKeysResponses,
    GetApiV1MachineUsersByMachineUserIdApiKeysErrors,
    ThrowOnError
  >({ url: "/api/v1/machine-users/{machine_user_id}/api-keys", ...options });

/**
 * Create Machine User Api Key V1
 */
export const create_machine_user_api_key_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1MachineUsersByMachineUserIdApiKeysData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1MachineUsersByMachineUserIdApiKeysResponses,
  PostApiV1MachineUsersByMachineUserIdApiKeysErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1MachineUsersByMachineUserIdApiKeysResponses,
    PostApiV1MachineUsersByMachineUserIdApiKeysErrors,
    ThrowOnError
  >({
    url: "/api/v1/machine-users/{machine_user_id}/api-keys",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Machine User Api Key V1
 */
export const delete_machine_user_api_key_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses,
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses,
    DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/machine-users/{machine_user_id}/api-keys/{api_key_id}",
    ...options,
  });

/**
 * Get Verification Metrics V2
 */
export const get_verification_metrics_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV2MetricsVerificationData, ThrowOnError>,
): RequestResult<
  GetApiV2MetricsVerificationResponses,
  GetApiV2MetricsVerificationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2MetricsVerificationResponses,
    GetApiV2MetricsVerificationErrors,
    ThrowOnError
  >({ url: "/api/v2/metrics/verification", ...options });

/**
 * Get Change Counts V2
 */
export const get_change_counts_v2 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV2MetricsChangeCountsData, ThrowOnError>,
): RequestResult<
  GetApiV2MetricsChangeCountsResponses,
  GetApiV2MetricsChangeCountsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2MetricsChangeCountsResponses,
    GetApiV2MetricsChangeCountsErrors,
    ThrowOnError
  >({ url: "/api/v2/metrics/change-counts", ...options });

/**
 * Get Change Users V2
 */
export const get_change_users_v2 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV2MetricsChangeUsersData, ThrowOnError>,
): RequestResult<
  GetApiV2MetricsChangeUsersResponses,
  GetApiV2MetricsChangeUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2MetricsChangeUsersResponses,
    GetApiV2MetricsChangeUsersErrors,
    ThrowOnError
  >({ url: "/api/v2/metrics/change-users", ...options });

/**
 * Get Kb Child Judgement Metrics V1
 */
export const get_kb_child_judgement_metrics_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1MetricsChildJudgementData, ThrowOnError>,
): RequestResult<
  GetApiV1MetricsChildJudgementResponses,
  GetApiV1MetricsChildJudgementErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1MetricsChildJudgementResponses,
    GetApiV1MetricsChildJudgementErrors,
    ThrowOnError
  >({ url: "/api/v1/metrics/child-judgement", ...options });

/**
 * Get Kb Top Article Judgement Metrics V2
 */
export const get_kb_top_article_judgement_metrics_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV2MetricsTopArticleJudgementData, ThrowOnError>,
): RequestResult<
  GetApiV2MetricsTopArticleJudgementResponses,
  GetApiV2MetricsTopArticleJudgementErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2MetricsTopArticleJudgementResponses,
    GetApiV2MetricsTopArticleJudgementErrors,
    ThrowOnError
  >({ url: "/api/v2/metrics/top-article-judgement", ...options });

/**
 * Get Notification Settings V1
 */
export const get_notification_settings_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiV1UsersByUserIdNotificationSettingsData, ThrowOnError>,
): RequestResult<
  GetApiV1UsersByUserIdNotificationSettingsResponses,
  GetApiV1UsersByUserIdNotificationSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1UsersByUserIdNotificationSettingsResponses,
    GetApiV1UsersByUserIdNotificationSettingsErrors,
    ThrowOnError
  >({ url: "/api/v1/users/{user_id}/notification-settings", ...options });

/**
 * Patch Notification Settings V1
 */
export const patch_notification_settings_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1UsersByUserIdNotificationSettingsData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1UsersByUserIdNotificationSettingsResponses,
  PatchApiV1UsersByUserIdNotificationSettingsErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1UsersByUserIdNotificationSettingsResponses,
    PatchApiV1UsersByUserIdNotificationSettingsErrors,
    ThrowOnError
  >({
    url: "/api/v1/users/{user_id}/notification-settings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Get Pages V1
 */
export const notion_get_pages_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiNotionV1TenantsByTenantIdActionsPagesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdActionsPagesResponses,
  GetApiNotionV1TenantsByTenantIdActionsPagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdActionsPagesResponses,
    GetApiNotionV1TenantsByTenantIdActionsPagesErrors,
    ThrowOnError
  >({ url: "/api/notion/v1/tenants/{tenant_id}/actions/pages", ...options });

/**
 * Notion Create Page V1
 */
export const notion_create_page_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiNotionV1TenantsByTenantIdActionsPagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiNotionV1TenantsByTenantIdActionsPagesResponses,
  PostApiNotionV1TenantsByTenantIdActionsPagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsByTenantIdActionsPagesResponses,
    PostApiNotionV1TenantsByTenantIdActionsPagesErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/pages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Get Databases V1
 */
export const notion_get_databases_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiNotionV1TenantsByTenantIdActionsDatabasesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses,
    GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/databases",
    ...options,
  });

/**
 * Notion Get Database V1
 */
export const notion_get_database_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses,
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses,
    GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/databases/{database_id}",
    ...options,
  });

/**
 * Notion Query Database V1
 */
export const notion_query_database_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData,
    ThrowOnError
  >,
): RequestResult<
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses,
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses,
    PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/databases/{database_id}/query",
    ...options,
  });

/**
 * Notion Get Page Content V1
 */
export const notion_get_page_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
    GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}/content",
    ...options,
  });

/**
 * Notion Get Comments V1
 */
export const notion_get_comments_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
    GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}/comments",
    ...options,
  });

/**
 * Notion Create Blocks V1
 */
export const notion_create_blocks_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData,
    ThrowOnError
  >,
): RequestResult<
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses,
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses,
    PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}/blocks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Delete Page V1
 */
export const notion_delete_page_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
    DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}",
    ...options,
  });

/**
 * Notion Update Page V1
 */
export const notion_update_page_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
    PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Delete Block V1
 */
export const notion_delete_block_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
    DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/blocks/{block_id}",
    ...options,
  });

/**
 * Notion Update Block V1
 */
export const notion_update_block_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
    PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/actions/blocks/{block_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Get Tenants V1
 */
export const notion_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiNotionV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiNotionV1TenantsResponses,
  GetApiNotionV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiNotionV1TenantsResponses,
    GetApiNotionV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/notion/v1/tenants", ...options });

/**
 * Notion Create Tenant V1
 */
export const notion_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiNotionV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiNotionV1TenantsResponses,
  PostApiNotionV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsResponses,
    PostApiNotionV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Delete Tenant V1
 */
export const notion_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiNotionV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiNotionV1TenantsByTenantIdResponses,
  DeleteApiNotionV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiNotionV1TenantsByTenantIdResponses,
    DeleteApiNotionV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/notion/v1/tenants/{tenant_id}", ...options });

/**
 * Notion Get Tenant V1
 */
export const notion_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiNotionV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdResponses,
  GetApiNotionV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdResponses,
    GetApiNotionV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/notion/v1/tenants/{tenant_id}", ...options });

/**
 * Notion Connect Tenant V1
 */
export const notion_connect_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiNotionV1TenantsByTenantIdConnectData, ThrowOnError>,
): RequestResult<
  PostApiNotionV1TenantsByTenantIdConnectResponses,
  PostApiNotionV1TenantsByTenantIdConnectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsByTenantIdConnectResponses,
    PostApiNotionV1TenantsByTenantIdConnectErrors,
    ThrowOnError
  >({ url: "/api/notion/v1/tenants/{tenant_id}/connect", ...options });

/**
 * Notion Callback Tenant V1
 */
export const notion_callback_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiNotionV1TenantsByTenantIdCallbackData, ThrowOnError>,
): RequestResult<
  PostApiNotionV1TenantsByTenantIdCallbackResponses,
  PostApiNotionV1TenantsByTenantIdCallbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsByTenantIdCallbackResponses,
    PostApiNotionV1TenantsByTenantIdCallbackErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Notion Reveal Webhook Token V1
 */
export const notion_reveal_webhook_token_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData,
    ThrowOnError
  >,
): RequestResult<
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses,
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses,
    PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors,
    ThrowOnError
  >({
    url: "/api/notion/v1/tenants/{tenant_id}/reveal-webhook-token",
    ...options,
  });

/**
 * Notion Check Connection V1
 */
export const notion_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiNotionV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiNotionV1TenantsByTenantIdCheckConnectionResponses,
  GetApiNotionV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiNotionV1TenantsByTenantIdCheckConnectionResponses,
    GetApiNotionV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({ url: "/api/notion/v1/tenants/{tenant_id}/check-connection", ...options });

/**
 * Get Oauth Applications V1
 */
export const get_oauth_applications_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1OauthApplicationsData, ThrowOnError>,
): RequestResult<
  GetApiV1OauthApplicationsResponses,
  GetApiV1OauthApplicationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1OauthApplicationsResponses,
    GetApiV1OauthApplicationsErrors,
    ThrowOnError
  >({ url: "/api/v1/oauth-applications", ...options });

/**
 * Create Oauth Application V1
 */
export const create_oauth_application_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1OauthApplicationsData, ThrowOnError>,
): RequestResult<
  PostApiV1OauthApplicationsResponses,
  PostApiV1OauthApplicationsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1OauthApplicationsResponses,
    PostApiV1OauthApplicationsErrors,
    ThrowOnError
  >({
    url: "/api/v1/oauth-applications",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Oauth Applications V1
 */
export const get_full_oauth_applications_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1FullOauthApplicationsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullOauthApplicationsResponses,
  GetApiV1FullOauthApplicationsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullOauthApplicationsResponses,
    GetApiV1FullOauthApplicationsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-oauth-applications", ...options });

/**
 * Delete Oauth Application V1
 */
export const delete_oauth_application_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1OauthApplicationsByOauthApplicationIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1OauthApplicationsByOauthApplicationIdResponses,
  DeleteApiV1OauthApplicationsByOauthApplicationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1OauthApplicationsByOauthApplicationIdResponses,
    DeleteApiV1OauthApplicationsByOauthApplicationIdErrors,
    ThrowOnError
  >({ url: "/api/v1/oauth-applications/{oauth_application_id}", ...options });

/**
 * Get Oauth Application V1
 */
export const get_oauth_application_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1OauthApplicationsByOauthApplicationIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1OauthApplicationsByOauthApplicationIdResponses,
  GetApiV1OauthApplicationsByOauthApplicationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1OauthApplicationsByOauthApplicationIdResponses,
    GetApiV1OauthApplicationsByOauthApplicationIdErrors,
    ThrowOnError
  >({ url: "/api/v1/oauth-applications/{oauth_application_id}", ...options });

/**
 * Update Oauth Application V1
 */
export const update_oauth_application_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1OauthApplicationsByOauthApplicationIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1OauthApplicationsByOauthApplicationIdResponses,
  PatchApiV1OauthApplicationsByOauthApplicationIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1OauthApplicationsByOauthApplicationIdResponses,
    PatchApiV1OauthApplicationsByOauthApplicationIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/oauth-applications/{oauth_application_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Rotate Oauth Application Secret V1
 */
export const rotate_oauth_application_secret_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses,
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses,
    PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors,
    ThrowOnError
  >({
    url: "/api/v1/oauth-applications/{oauth_application_id}/rotate-secret",
    ...options,
  });

/**
 * Outlook Create Draft V1
 */
export const outlook_create_draft_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsCreateDraftData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsCreateDraftResponses,
  PostApiOutlookV1ActionsCreateDraftErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsCreateDraftResponses,
    PostApiOutlookV1ActionsCreateDraftErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/create-draft",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Reply Email V1
 */
export const outlook_reply_email_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsReplyEmailData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsReplyEmailResponses,
  PostApiOutlookV1ActionsReplyEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsReplyEmailResponses,
    PostApiOutlookV1ActionsReplyEmailErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/reply-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Forward Email V1
 */
export const outlook_forward_email_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsForwardEmailData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsForwardEmailResponses,
  PostApiOutlookV1ActionsForwardEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsForwardEmailResponses,
    PostApiOutlookV1ActionsForwardEmailErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/forward-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Send Email V1
 */
export const outlook_send_email_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsSendEmailData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsSendEmailResponses,
  PostApiOutlookV1ActionsSendEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsSendEmailResponses,
    PostApiOutlookV1ActionsSendEmailErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/send-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Set Email Categories V1
 */
export const outlook_set_email_categories_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiOutlookV1ActionsSetEmailCategoriesData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsSetEmailCategoriesResponses,
  PostApiOutlookV1ActionsSetEmailCategoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsSetEmailCategoriesResponses,
    PostApiOutlookV1ActionsSetEmailCategoriesErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/set-email-categories",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Set Email Importance V1
 */
export const outlook_set_email_importance_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiOutlookV1ActionsSetEmailImportanceData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsSetEmailImportanceResponses,
  PostApiOutlookV1ActionsSetEmailImportanceErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsSetEmailImportanceResponses,
    PostApiOutlookV1ActionsSetEmailImportanceErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/set-email-importance",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Set Email Flag V1
 */
export const outlook_set_email_flag_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsSetEmailFlagData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsSetEmailFlagResponses,
  PostApiOutlookV1ActionsSetEmailFlagErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsSetEmailFlagResponses,
    PostApiOutlookV1ActionsSetEmailFlagErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/set-email-flag",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Mark Email Read V1
 */
export const outlook_mark_email_read_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiOutlookV1ActionsMarkEmailReadData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsMarkEmailReadResponses,
  PostApiOutlookV1ActionsMarkEmailReadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsMarkEmailReadResponses,
    PostApiOutlookV1ActionsMarkEmailReadErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/mark-email-read",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Move Email V1
 */
export const outlook_move_email_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsMoveEmailData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsMoveEmailResponses,
  PostApiOutlookV1ActionsMoveEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsMoveEmailResponses,
    PostApiOutlookV1ActionsMoveEmailErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/move-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Copy Email V1
 */
export const outlook_copy_email_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsCopyEmailData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsCopyEmailResponses,
  PostApiOutlookV1ActionsCopyEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsCopyEmailResponses,
    PostApiOutlookV1ActionsCopyEmailErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/copy-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Delete Email V1
 */
export const outlook_delete_email_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiOutlookV1ActionsDeleteEmailData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsDeleteEmailResponses,
  PostApiOutlookV1ActionsDeleteEmailErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsDeleteEmailResponses,
    PostApiOutlookV1ActionsDeleteEmailErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/delete-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Get Email Attachment V1
 */
export const outlook_get_email_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiOutlookV1ActionsGetEmailAttachmentData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsGetEmailAttachmentResponses,
  PostApiOutlookV1ActionsGetEmailAttachmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsGetEmailAttachmentResponses,
    PostApiOutlookV1ActionsGetEmailAttachmentErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/get-email-attachment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Add Email Attachment V1
 */
export const outlook_add_email_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiOutlookV1ActionsAddEmailAttachmentData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV1ActionsAddEmailAttachmentResponses,
  PostApiOutlookV1ActionsAddEmailAttachmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsAddEmailAttachmentResponses,
    PostApiOutlookV1ActionsAddEmailAttachmentErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/add-email-attachment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Remove Email Attachment V1
 */
export const outlook_remove_email_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiOutlookV1ActionsRemoveEmailAttachmentData,
    ThrowOnError
  >,
): RequestResult<
  PostApiOutlookV1ActionsRemoveEmailAttachmentResponses,
  PostApiOutlookV1ActionsRemoveEmailAttachmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV1ActionsRemoveEmailAttachmentResponses,
    PostApiOutlookV1ActionsRemoveEmailAttachmentErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v1/actions/remove-email-attachment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Get Subscriptions V2
 */
export const outlook_get_subscriptions_v2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiOutlookV2SubscriptionsData, ThrowOnError>,
): RequestResult<
  GetApiOutlookV2SubscriptionsResponses,
  GetApiOutlookV2SubscriptionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiOutlookV2SubscriptionsResponses,
    GetApiOutlookV2SubscriptionsErrors,
    ThrowOnError
  >({ url: "/api/outlook/v2/subscriptions", ...options });

/**
 * Outlook Create Subscriptions V2
 */
export const outlook_create_subscriptions_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiOutlookV2SubscriptionsData, ThrowOnError>,
): RequestResult<
  PostApiOutlookV2SubscriptionsResponses,
  PostApiOutlookV2SubscriptionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiOutlookV2SubscriptionsResponses,
    PostApiOutlookV2SubscriptionsErrors,
    ThrowOnError
  >({
    url: "/api/outlook/v2/subscriptions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Outlook Delete Subscription V2
 */
export const outlook_delete_subscription_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiOutlookV2SubscriptionsBySubscriptionIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses,
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses,
    DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors,
    ThrowOnError
  >({ url: "/api/outlook/v2/subscriptions/{subscription_id}", ...options });

/**
 * Extract Data Dump Conversations Input V1
 */
export const extract_data_dump_conversations_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractDataDumpConversationsInputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractDataDumpConversationsInputResponses,
  PostApiV1PipelinesExtractDataDumpConversationsInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDataDumpConversationsInputResponses,
    PostApiV1PipelinesExtractDataDumpConversationsInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-data-dump-conversations/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Data Dump Conversations Output V1
 */
export const extract_data_dump_conversations_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractDataDumpConversationsOutputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractDataDumpConversationsOutputResponses,
  PostApiV1PipelinesExtractDataDumpConversationsOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDataDumpConversationsOutputResponses,
    PostApiV1PipelinesExtractDataDumpConversationsOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-data-dump-conversations/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Data Dump Conversations Enqueue V1
 */
export const extract_data_dump_conversations_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractDataDumpConversationsEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses,
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses,
    PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-data-dump-conversations/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Data Dump Conversations Dequeue V1
 */
export const extract_data_dump_conversations_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractDataDumpConversationsDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses,
  PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses,
    PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-data-dump-conversations/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Datapoints Input V1
 */
export const extract_datapoints_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1PipelinesExtractDatapointsInputData, ThrowOnError>,
): RequestResult<
  PostApiV1PipelinesExtractDatapointsInputResponses,
  PostApiV1PipelinesExtractDatapointsInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDatapointsInputResponses,
    PostApiV1PipelinesExtractDatapointsInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-datapoints/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Datapoints Output V1
 */
export const extract_datapoints_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1PipelinesExtractDatapointsOutputData, ThrowOnError>,
): RequestResult<
  PostApiV1PipelinesExtractDatapointsOutputResponses,
  PostApiV1PipelinesExtractDatapointsOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDatapointsOutputResponses,
    PostApiV1PipelinesExtractDatapointsOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-datapoints/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Datapoints Enqueue V1
 */
export const extract_datapoints_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractDatapointsEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractDatapointsEnqueueResponses,
  PostApiV1PipelinesExtractDatapointsEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDatapointsEnqueueResponses,
    PostApiV1PipelinesExtractDatapointsEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-datapoints/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Datapoints Dequeue V1
 */
export const extract_datapoints_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractDatapointsDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractDatapointsDequeueResponses,
  PostApiV1PipelinesExtractDatapointsDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractDatapointsDequeueResponses,
    PostApiV1PipelinesExtractDatapointsDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-datapoints/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Incoming Knowledge Bases Input V1
 */
export const extract_incoming_knowledge_bases_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-incoming-knowledge-bases/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Incoming Knowledge Bases Output V1
 */
export const extract_incoming_knowledge_bases_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-incoming-knowledge-bases/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Incoming Knowledge Bases Enqueue V1
 */
export const extract_incoming_knowledge_bases_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-incoming-knowledge-bases/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Extract Incoming Knowledge Bases Dequeue V1
 */
export const extract_incoming_knowledge_bases_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses,
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses,
    PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/extract-incoming-knowledge-bases/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finalize Conversations Input V1
 */
export const finalize_conversations_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinalizeConversationsInputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinalizeConversationsInputResponses,
  PostApiV1PipelinesFinalizeConversationsInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinalizeConversationsInputResponses,
    PostApiV1PipelinesFinalizeConversationsInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finalize-conversations/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finalize Conversations Output V1
 */
export const finalize_conversations_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinalizeConversationsOutputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinalizeConversationsOutputResponses,
  PostApiV1PipelinesFinalizeConversationsOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinalizeConversationsOutputResponses,
    PostApiV1PipelinesFinalizeConversationsOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finalize-conversations/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finalize Conversations Enqueue V1
 */
export const finalize_conversations_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinalizeConversationsEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinalizeConversationsEnqueueResponses,
  PostApiV1PipelinesFinalizeConversationsEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinalizeConversationsEnqueueResponses,
    PostApiV1PipelinesFinalizeConversationsEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finalize-conversations/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finalize Conversations Dequeue V1
 */
export const finalize_conversations_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinalizeConversationsDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinalizeConversationsDequeueResponses,
  PostApiV1PipelinesFinalizeConversationsDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinalizeConversationsDequeueResponses,
    PostApiV1PipelinesFinalizeConversationsDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finalize-conversations/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Kanonicalize Datapoints Input V1
 */
export const kanonicalize_datapoints_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesKanonicalizeDatapointsInputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesKanonicalizeDatapointsInputResponses,
  PostApiV1PipelinesKanonicalizeDatapointsInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesKanonicalizeDatapointsInputResponses,
    PostApiV1PipelinesKanonicalizeDatapointsInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/kanonicalize-datapoints/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Kanonicalize Datapoints Output V1
 */
export const kanonicalize_datapoints_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesKanonicalizeDatapointsOutputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesKanonicalizeDatapointsOutputResponses,
  PostApiV1PipelinesKanonicalizeDatapointsOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesKanonicalizeDatapointsOutputResponses,
    PostApiV1PipelinesKanonicalizeDatapointsOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/kanonicalize-datapoints/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Kanonicalize Datapoints Enqueue V1
 */
export const kanonicalize_datapoints_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesKanonicalizeDatapointsEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses,
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses,
    PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/kanonicalize-datapoints/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Kanonicalize Datapoints Dequeue V1
 */
export const kanonicalize_datapoints_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesKanonicalizeDatapointsDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses,
  PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses,
    PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/kanonicalize-datapoints/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Inference Datapoints Input V1
 */
export const create_inference_datapoints_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesCreateInferenceDatapointsInputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesCreateInferenceDatapointsInputResponses,
  PostApiV1PipelinesCreateInferenceDatapointsInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateInferenceDatapointsInputResponses,
    PostApiV1PipelinesCreateInferenceDatapointsInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-inference-datapoints/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Inference Datapoints Output V1
 */
export const create_inference_datapoints_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesCreateInferenceDatapointsOutputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesCreateInferenceDatapointsOutputResponses,
  PostApiV1PipelinesCreateInferenceDatapointsOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateInferenceDatapointsOutputResponses,
    PostApiV1PipelinesCreateInferenceDatapointsOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-inference-datapoints/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Inference Datapoints Enqueue V1
 */
export const create_inference_datapoints_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesCreateInferenceDatapointsEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses,
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses,
    PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-inference-datapoints/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Inference Datapoints Dequeue V1
 */
export const create_inference_datapoints_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesCreateInferenceDatapointsDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses,
  PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses,
    PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-inference-datapoints/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Prod Evals Input V1
 */
export const create_prod_evals_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1PipelinesCreateProdEvalsInputData, ThrowOnError>,
): RequestResult<
  PostApiV1PipelinesCreateProdEvalsInputResponses,
  PostApiV1PipelinesCreateProdEvalsInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateProdEvalsInputResponses,
    PostApiV1PipelinesCreateProdEvalsInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-prod-evals/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Prod Evals Output V1
 */
export const create_prod_evals_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1PipelinesCreateProdEvalsOutputData, ThrowOnError>,
): RequestResult<
  PostApiV1PipelinesCreateProdEvalsOutputResponses,
  PostApiV1PipelinesCreateProdEvalsOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateProdEvalsOutputResponses,
    PostApiV1PipelinesCreateProdEvalsOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-prod-evals/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Prod Evals Enqueue V1
 */
export const create_prod_evals_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1PipelinesCreateProdEvalsEnqueueData, ThrowOnError>,
): RequestResult<
  PostApiV1PipelinesCreateProdEvalsEnqueueResponses,
  PostApiV1PipelinesCreateProdEvalsEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateProdEvalsEnqueueResponses,
    PostApiV1PipelinesCreateProdEvalsEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-prod-evals/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Prod Evals Dequeue V1
 */
export const create_prod_evals_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1PipelinesCreateProdEvalsDequeueData, ThrowOnError>,
): RequestResult<
  PostApiV1PipelinesCreateProdEvalsDequeueResponses,
  PostApiV1PipelinesCreateProdEvalsDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesCreateProdEvalsDequeueResponses,
    PostApiV1PipelinesCreateProdEvalsDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/create-prod-evals/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finetune Knowledge Bases Input V1
 */
export const finetune_knowledge_bases_input_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinetuneKnowledgeBasesInputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses,
    PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finetune-knowledge-bases/input",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finetune Knowledge Bases Output V1
 */
export const finetune_knowledge_bases_output_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinetuneKnowledgeBasesOutputData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses,
    PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finetune-knowledge-bases/output",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finetune Knowledge Bases Enqueue V1
 */
export const finetune_knowledge_bases_enqueue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses,
    PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finetune-knowledge-bases/enqueue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Finetune Knowledge Bases Dequeue V1
 */
export const finetune_knowledge_bases_dequeue_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses,
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses,
    PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors,
    ThrowOnError
  >({
    url: "/api/v1/pipelines/finetune-knowledge-bases/dequeue",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Threads V1
 */
export const plain_get_threads_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsThreadsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsThreadsResponses,
  GetApiPlainV1TenantsByTenantIdActionsThreadsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsThreadsResponses,
    GetApiPlainV1TenantsByTenantIdActionsThreadsErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants/{tenant_id}/actions/threads", ...options });

/**
 * Plain Create Thread V1
 */
export const plain_create_thread_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Thread V1
 */
export const plain_get_thread_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses,
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}",
    ...options,
  });

/**
 * Plain Get Thread Timeline V1
 */
export const plain_get_thread_timeline_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses,
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses,
    GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/timeline",
    ...options,
  });

/**
 * Plain Mark Thread As Todo V1
 */
export const plain_mark_thread_as_todo_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/todo",
    ...options,
  });

/**
 * Plain Snooze Thread V1
 */
export const plain_snooze_thread_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/snooze",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Mark Thread As Done V1
 */
export const plain_mark_thread_as_done_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/done",
    ...options,
  });

/**
 * Plain Change Thread Priority V1
 */
export const plain_change_thread_priority_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses,
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/priority",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Update Thread Agent Status V1
 */
export const plain_update_thread_agent_status_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses,
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses,
    PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/agent-status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Unassign Thread V1
 */
export const plain_unassign_thread_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
    DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/assignee",
    ...options,
  });

/**
 * Plain Assign Thread V1
 */
export const plain_assign_thread_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/assignee",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Assign Thread To Self V1
 */
export const plain_assign_thread_to_self_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses,
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/assignee/self",
    ...options,
  });

/**
 * Plain Add Thread Labels V1
 */
export const plain_add_thread_labels_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/labels",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Remove Thread Labels V1
 */
export const plain_remove_thread_labels_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/labels/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Upsert Thread Field V1
 */
export const plain_upsert_thread_field_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses,
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses,
    PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/fields/{key}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Send Message V1
 */
export const plain_send_message_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Create Note V1
 */
export const plain_create_note_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses,
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses,
    PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Customers V1
 */
export const plain_get_customers_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsCustomersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsCustomersResponses,
  GetApiPlainV1TenantsByTenantIdActionsCustomersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsCustomersResponses,
    GetApiPlainV1TenantsByTenantIdActionsCustomersErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants/{tenant_id}/actions/customers", ...options });

/**
 * Plain Upsert Customer V1
 */
export const plain_upsert_customer_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsCustomersData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsCustomersResponses,
  PutApiPlainV1TenantsByTenantIdActionsCustomersErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsCustomersResponses,
    PutApiPlainV1TenantsByTenantIdActionsCustomersErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Delete Customer V1
 */
export const plain_delete_customer_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
    DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}",
    ...options,
  });

/**
 * Plain Get Customer V1
 */
export const plain_get_customer_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
    GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}",
    ...options,
  });

/**
 * Plain Get Companies V1
 */
export const plain_get_companies_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsCompaniesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
  GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
    GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants/{tenant_id}/actions/companies", ...options });

/**
 * Plain Upsert Company V1
 */
export const plain_upsert_company_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsCompaniesData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
  PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
    PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/companies",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Set Customer Company V1
 */
export const plain_set_customer_company_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses,
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses,
    PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}/company",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Customer Groups V1
 */
export const plain_get_customer_groups_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses,
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses,
    GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customer-groups",
    ...options,
  });

/**
 * Plain Add Customer To Groups V1
 */
export const plain_add_customer_to_groups_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses,
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Plain Tenants V1
 */
export const plain_get_plain_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
    GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/plain-tenants",
    ...options,
  });

/**
 * Plain Upsert Plain Tenant V1
 */
export const plain_upsert_plain_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
    ThrowOnError
  >,
): RequestResult<
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
    PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/plain-tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Delete Plain Tenant V1
 */
export const plain_delete_plain_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses,
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses,
    DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/plain-tenants/{plain_tenant_id}",
    ...options,
  });

/**
 * Plain Add Customer To Plain Tenants V1
 */
export const plain_add_customer_to_plain_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses,
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses,
    PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}/plain-tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Tenants V1
 */
export const plain_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiPlainV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiPlainV1TenantsResponses,
  GetApiPlainV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiPlainV1TenantsResponses,
    GetApiPlainV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants", ...options });

/**
 * Plain Create Tenant V1
 */
export const plain_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiPlainV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiPlainV1TenantsResponses,
  PostApiPlainV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPlainV1TenantsResponses,
    PostApiPlainV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Get Full Tenants V1
 */
export const plain_get_full_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiPlainV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiPlainV1FullTenantsResponses,
  GetApiPlainV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiPlainV1FullTenantsResponses,
    GetApiPlainV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/full-tenants", ...options });

/**
 * Plain Delete Tenant V1
 */
export const plain_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiPlainV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiPlainV1TenantsByTenantIdResponses,
  DeleteApiPlainV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiPlainV1TenantsByTenantIdResponses,
    DeleteApiPlainV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants/{tenant_id}", ...options });

/**
 * Plain Get Tenant V1
 */
export const plain_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiPlainV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdResponses,
  GetApiPlainV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdResponses,
    GetApiPlainV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants/{tenant_id}", ...options });

/**
 * Plain Patch Tenant V1
 */
export const plain_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiPlainV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiPlainV1TenantsByTenantIdResponses,
  PatchApiPlainV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiPlainV1TenantsByTenantIdResponses,
    PatchApiPlainV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/plain/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Plain Check Connection V1
 */
export const plain_check_connection_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPlainV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPlainV1TenantsByTenantIdCheckConnectionResponses,
  GetApiPlainV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPlainV1TenantsByTenantIdCheckConnectionResponses,
    GetApiPlainV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({ url: "/api/plain/v1/tenants/{tenant_id}/check-connection", ...options });

/**
 * Get Prompts V1
 */
export const get_prompts_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1TasksByTaskIdPromptsData, ThrowOnError>,
): RequestResult<
  GetApiV1TasksByTaskIdPromptsResponses,
  GetApiV1TasksByTaskIdPromptsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1TasksByTaskIdPromptsResponses,
    GetApiV1TasksByTaskIdPromptsErrors,
    ThrowOnError
  >({ url: "/api/v1/tasks/{task_id}/prompts", ...options });

/**
 * Create Prompt V1
 */
export const create_prompt_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1TasksByTaskIdPromptsData, ThrowOnError>,
): RequestResult<
  PostApiV1TasksByTaskIdPromptsResponses,
  PostApiV1TasksByTaskIdPromptsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1TasksByTaskIdPromptsResponses,
    PostApiV1TasksByTaskIdPromptsErrors,
    ThrowOnError
  >({
    url: "/api/v1/tasks/{task_id}/prompts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Prompt V1
 */
export const get_prompt_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1TasksByTaskIdPromptsByPromptIdData, ThrowOnError>,
): RequestResult<
  GetApiV1TasksByTaskIdPromptsByPromptIdResponses,
  GetApiV1TasksByTaskIdPromptsByPromptIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1TasksByTaskIdPromptsByPromptIdResponses,
    GetApiV1TasksByTaskIdPromptsByPromptIdErrors,
    ThrowOnError
  >({ url: "/api/v1/tasks/{task_id}/prompts/{prompt_id}", ...options });

/**
 * Git Branch List V1
 */
export const git_branch_list_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdBranchesData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdBranchesResponses,
  GetApiV1ReposByRepositoryIdBranchesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdBranchesResponses,
    GetApiV1ReposByRepositoryIdBranchesErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/branches", ...options });

/**
 * Git Branch Create V1
 */
export const git_branch_create_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1ReposByRepositoryIdBranchesData, ThrowOnError>,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesResponses,
  PostApiV1ReposByRepositoryIdBranchesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesResponses,
    PostApiV1ReposByRepositoryIdBranchesErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Rebase Preview V1
 */
export const git_rebase_preview_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses,
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses,
    GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{branch_name}/rebase-preview",
    ...options,
  });

/**
 * Git Branch Delete V1
 */
export const git_branch_delete_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiV1ReposByRepositoryIdBranchesByNameData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1ReposByRepositoryIdBranchesByNameResponses,
  DeleteApiV1ReposByRepositoryIdBranchesByNameErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ReposByRepositoryIdBranchesByNameResponses,
    DeleteApiV1ReposByRepositoryIdBranchesByNameErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/branches/{name}", ...options });

/**
 * Git Branch Get V1
 */
export const git_branch_get_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdBranchesByNameData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdBranchesByNameResponses,
  GetApiV1ReposByRepositoryIdBranchesByNameErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdBranchesByNameResponses,
    GetApiV1ReposByRepositoryIdBranchesByNameErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/branches/{name}", ...options });

/**
 * Git Branch Update V1
 */
export const git_branch_update_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiV1ReposByRepositoryIdBranchesByNameData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1ReposByRepositoryIdBranchesByNameResponses,
  PatchApiV1ReposByRepositoryIdBranchesByNameErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ReposByRepositoryIdBranchesByNameResponses,
    PatchApiV1ReposByRepositoryIdBranchesByNameErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Branch Restore V1
 */
export const git_branch_restore_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ReposByRepositoryIdBranchesByNameRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses,
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses,
    PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{name}/restore",
    ...options,
  });

/**
 * Git Log V1
 */
export const git_log_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdCommitsByRefData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdCommitsByRefResponses,
  GetApiV1ReposByRepositoryIdCommitsByRefErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdCommitsByRefResponses,
    GetApiV1ReposByRepositoryIdCommitsByRefErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/commits/{ref}", ...options });

/**
 * Git Show V1
 */
export const git_show_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdCommitByRefData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdCommitByRefResponses,
  GetApiV1ReposByRepositoryIdCommitByRefErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdCommitByRefResponses,
    GetApiV1ReposByRepositoryIdCommitByRefErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/commit/{ref}", ...options });

/**
 * Patch Commit V1
 */
export const patch_commit_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiV1ReposByRepositoryIdCommitByCommitIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses,
  PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses,
    PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/commit/{commit_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Commit V1
 */
export const git_commit_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{branch_name}/commit",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Amend V1
 */
export const git_amend_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{branch_name}/amend",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Merge V1
 */
export const git_merge_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{branch_name}/merge",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Rebase V1
 */
export const git_rebase_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{branch_name}/rebase",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Cherry Pick V1
 */
export const git_cherry_pick_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses,
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses,
    PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/branches/{branch_name}/cherry-pick",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Git Diff V1
 */
export const git_diff_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ReposByRepositoryIdCompareByBaseheadData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ReposByRepositoryIdCompareByBaseheadResponses,
  GetApiV1ReposByRepositoryIdCompareByBaseheadErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdCompareByBaseheadResponses,
    GetApiV1ReposByRepositoryIdCompareByBaseheadErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/compare/{basehead}", ...options });

/**
 * Git Diff Blame V1
 */
export const git_diff_blame_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses,
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses,
    GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors,
    ThrowOnError
  >({
    url: "/api/v1/repos/{repository_id}/git-diff-blame/{basehead}",
    ...options,
  });

/**
 * Git Ls Tree V1
 */
export const git_ls_tree_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdTreeByRefData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdTreeByRefResponses,
  GetApiV1ReposByRepositoryIdTreeByRefErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdTreeByRefResponses,
    GetApiV1ReposByRepositoryIdTreeByRefErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/tree/{ref}", ...options });

/**
 * Git Show Article V1
 */
export const git_show_article_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdArticleByRefData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdArticleByRefResponses,
  GetApiV1ReposByRepositoryIdArticleByRefErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdArticleByRefResponses,
    GetApiV1ReposByRepositoryIdArticleByRefErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/article/{ref}", ...options });

/**
 * Git Show Blob V1
 */
export const git_show_blob_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ReposByRepositoryIdBlobByRefData, ThrowOnError>,
): RequestResult<
  GetApiV1ReposByRepositoryIdBlobByRefResponses,
  GetApiV1ReposByRepositoryIdBlobByRefErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ReposByRepositoryIdBlobByRefResponses,
    GetApiV1ReposByRepositoryIdBlobByRefErrors,
    ThrowOnError
  >({ url: "/api/v1/repos/{repository_id}/blob/{ref}", ...options });

/**
 * Salesforce Get Cases V1
 */
export const salesforce_get_cases_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases",
    ...options,
  });

/**
 * Salesforce Create Case V1
 */
export const salesforce_create_case_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Get Case V1
 */
export const salesforce_get_case_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}",
    ...options,
  });

/**
 * Salesforce Update Case V1
 */
export const salesforce_update_case_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
    PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Post Case Comment V1
 */
export const salesforce_post_case_comment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Send Case Email V1
 */
export const salesforce_send_case_email_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/emails",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Create Case Email Draft V1
 */
export const salesforce_create_case_email_draft_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses,
    PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/email-drafts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Get Case Messages V1
 */
export const salesforce_get_case_messages_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/messages",
    ...options,
  });

/**
 * Salesforce Get Default Language V1
 */
export const salesforce_get_default_language_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/default-language",
    ...options,
  });

/**
 * Salesforce Get Articles V1
 */
export const salesforce_get_articles_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsArticlesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles",
    ...options,
  });

/**
 * Salesforce Create Article V1
 */
export const salesforce_create_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdActionsArticlesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
    PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Update Article V1
 */
export const salesforce_update_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses,
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses,
    PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles/{article_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Delete Article V1
 */
export const salesforce_delete_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses,
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses,
    DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles/{master_id}",
    ...options,
  });

/**
 * Salesforce Get Record Types V1
 */
export const salesforce_get_record_types_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/record-types",
    ...options,
  });

/**
 * Salesforce Get Record Type V1
 */
export const salesforce_get_record_type_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/record-types/{record_type_id}",
    ...options,
  });

/**
 * Salesforce Get Queues V1
 */
export const salesforce_get_queues_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/queues",
    ...options,
  });

/**
 * Salesforce Get Queue V1
 */
export const salesforce_get_queue_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/queues/{queue_id}",
    ...options,
  });

/**
 * Salesforce Get Users V1
 */
export const salesforce_get_users_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/users",
    ...options,
  });

/**
 * Salesforce Get User V1
 */
export const salesforce_get_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/users/{user_id}",
    ...options,
  });

/**
 * Salesforce Get Accounts V1
 */
export const salesforce_get_accounts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/accounts",
    ...options,
  });

/**
 * Salesforce Get Account V1
 */
export const salesforce_get_account_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/accounts/{account_id}",
    ...options,
  });

/**
 * Salesforce Get Contacts V1
 */
export const salesforce_get_contacts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsContactsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/contacts",
    ...options,
  });

/**
 * Salesforce Get Contact V1
 */
export const salesforce_get_contact_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/contacts/{contact_id}",
    ...options,
  });

/**
 * Salesforce Get Entitlements V1
 */
export const salesforce_get_entitlements_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/entitlements",
    ...options,
  });

/**
 * Salesforce Get Entitlement V1
 */
export const salesforce_get_entitlement_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses,
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses,
    GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/entitlements/{entitlement_id}",
    ...options,
  });

/**
 * Salesforce Get Tenants V1
 */
export const salesforce_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiSalesforceV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiSalesforceV1TenantsResponses,
  GetApiSalesforceV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSalesforceV1TenantsResponses,
    GetApiSalesforceV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/salesforce/v1/tenants", ...options });

/**
 * Salesforce Create Tenant V1
 */
export const salesforce_create_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiSalesforceV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiSalesforceV1TenantsResponses,
  PostApiSalesforceV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsResponses,
    PostApiSalesforceV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Delete Tenant V1
 */
export const salesforce_delete_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApiSalesforceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiSalesforceV1TenantsByTenantIdResponses,
  DeleteApiSalesforceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSalesforceV1TenantsByTenantIdResponses,
    DeleteApiSalesforceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/salesforce/v1/tenants/{tenant_id}", ...options });

/**
 * Salesforce Get Tenant V1
 */
export const salesforce_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiSalesforceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdResponses,
  GetApiSalesforceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdResponses,
    GetApiSalesforceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/salesforce/v1/tenants/{tenant_id}", ...options });

/**
 * Salesforce Patch Tenant V1
 */
export const salesforce_patch_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiSalesforceV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiSalesforceV1TenantsByTenantIdResponses,
  PatchApiSalesforceV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSalesforceV1TenantsByTenantIdResponses,
    PatchApiSalesforceV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Get Full Tenants V1
 */
export const salesforce_get_full_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiSalesforceV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiSalesforceV1FullTenantsResponses,
  GetApiSalesforceV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSalesforceV1FullTenantsResponses,
    GetApiSalesforceV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/salesforce/v1/full-tenants", ...options });

/**
 * Salesforce Get Oauth Redirect Uri V1
 */
export const salesforce_get_oauth_redirect_uri_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses,
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses,
    GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/oauth-redirect-uri",
    ...options,
  });

/**
 * Salesforce Connect Tenant V1
 */
export const salesforce_connect_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdConnectData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdConnectResponses,
  PostApiSalesforceV1TenantsByTenantIdConnectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdConnectResponses,
    PostApiSalesforceV1TenantsByTenantIdConnectErrors,
    ThrowOnError
  >({ url: "/api/salesforce/v1/tenants/{tenant_id}/connect", ...options });

/**
 * Salesforce Callback Tenant V1
 */
export const salesforce_callback_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSalesforceV1TenantsByTenantIdCallbackData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSalesforceV1TenantsByTenantIdCallbackResponses,
  PostApiSalesforceV1TenantsByTenantIdCallbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSalesforceV1TenantsByTenantIdCallbackResponses,
    PostApiSalesforceV1TenantsByTenantIdCallbackErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Salesforce Check Connection V1
 */
export const salesforce_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses,
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses,
    GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/check-connection",
    ...options,
  });

/**
 * Salesforce Check Ready V1
 */
export const salesforce_check_ready_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSalesforceV1TenantsByTenantIdCheckReadyData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses,
  GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses,
    GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors,
    ThrowOnError
  >({ url: "/api/salesforce/v1/tenants/{tenant_id}/check-ready", ...options });

/**
 * Salesforce Delete Ingest Client V1
 */
export const salesforce_delete_ingest_client_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiSalesforceV1TenantsByTenantIdIngestClientData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses,
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses,
    DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/ingest-client",
    ...options,
  });

/**
 * Salesforce Put Ingest Client V1
 */
export const salesforce_put_ingest_client_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutApiSalesforceV1TenantsByTenantIdIngestClientData,
    ThrowOnError
  >,
): RequestResult<
  PutApiSalesforceV1TenantsByTenantIdIngestClientResponses,
  PutApiSalesforceV1TenantsByTenantIdIngestClientErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiSalesforceV1TenantsByTenantIdIngestClientResponses,
    PutApiSalesforceV1TenantsByTenantIdIngestClientErrors,
    ThrowOnError
  >({
    url: "/api/salesforce/v1/tenants/{tenant_id}/ingest-client",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search V1
 */
export const search_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1SearchData, ThrowOnError>,
): RequestResult<GetApiV1SearchResponses, GetApiV1SearchErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetApiV1SearchResponses,
    GetApiV1SearchErrors,
    ThrowOnError
  >({ url: "/api/v1/search", ...options });

/**
 * Get Secrets Vault Secrets V1
 */
export const get_secrets_vault_secrets_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiSecretsVaultV1SecretsData, ThrowOnError>,
): RequestResult<
  GetApiSecretsVaultV1SecretsResponses,
  GetApiSecretsVaultV1SecretsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSecretsVaultV1SecretsResponses,
    GetApiSecretsVaultV1SecretsErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v1/secrets", ...options });

/**
 * Create Secrets Vault Secret V1
 */
export const create_secrets_vault_secret_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiSecretsVaultV1SecretsData, ThrowOnError>,
): RequestResult<
  PostApiSecretsVaultV1SecretsResponses,
  PostApiSecretsVaultV1SecretsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSecretsVaultV1SecretsResponses,
    PostApiSecretsVaultV1SecretsErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v1/secrets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Secrets Vault Full Secrets V1
 */
export const get_secrets_vault_full_secrets_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiSecretsVaultV1FullSecretsData, ThrowOnError>,
): RequestResult<
  GetApiSecretsVaultV1FullSecretsResponses,
  GetApiSecretsVaultV1FullSecretsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSecretsVaultV1FullSecretsResponses,
    GetApiSecretsVaultV1FullSecretsErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v1/full-secrets", ...options });

/**
 * Get Secrets Vault Secret Value V1
 */
export const get_secrets_vault_secret_value_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiSecretsVaultV1SecretsValueData, ThrowOnError>,
): RequestResult<
  GetApiSecretsVaultV1SecretsValueResponses,
  GetApiSecretsVaultV1SecretsValueErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSecretsVaultV1SecretsValueResponses,
    GetApiSecretsVaultV1SecretsValueErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v1/secrets/value", ...options });

/**
 * Get Secrets Vault Secret Value V2
 */
export const get_secrets_vault_secret_value_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiSecretsVaultV2SecretsValueData, ThrowOnError>,
): RequestResult<
  GetApiSecretsVaultV2SecretsValueResponses,
  GetApiSecretsVaultV2SecretsValueErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSecretsVaultV2SecretsValueResponses,
    GetApiSecretsVaultV2SecretsValueErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v2/secrets/value", ...options });

/**
 * Delete Secrets Vault Secret V1
 */
export const delete_secrets_vault_secret_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApiSecretsVaultV1SecretsBySecretIdData, ThrowOnError>,
): RequestResult<
  DeleteApiSecretsVaultV1SecretsBySecretIdResponses,
  DeleteApiSecretsVaultV1SecretsBySecretIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSecretsVaultV1SecretsBySecretIdResponses,
    DeleteApiSecretsVaultV1SecretsBySecretIdErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v1/secrets/{secret_id}", ...options });

/**
 * Get Secrets Vault Secret V1
 */
export const get_secrets_vault_secret_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiSecretsVaultV1SecretsBySecretIdData, ThrowOnError>,
): RequestResult<
  GetApiSecretsVaultV1SecretsBySecretIdResponses,
  GetApiSecretsVaultV1SecretsBySecretIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSecretsVaultV1SecretsBySecretIdResponses,
    GetApiSecretsVaultV1SecretsBySecretIdErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v1/secrets/{secret_id}", ...options });

/**
 * Update Secrets Vault Secret V1
 */
export const update_secrets_vault_secret_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiSecretsVaultV1SecretsBySecretIdData, ThrowOnError>,
): RequestResult<
  PatchApiSecretsVaultV1SecretsBySecretIdResponses,
  PatchApiSecretsVaultV1SecretsBySecretIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSecretsVaultV1SecretsBySecretIdResponses,
    PatchApiSecretsVaultV1SecretsBySecretIdErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v1/secrets/{secret_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create Secrets Vault Secret V2
 */
export const create_secrets_vault_secret_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiSecretsVaultV2SecretsData, ThrowOnError>,
): RequestResult<
  PostApiSecretsVaultV2SecretsResponses,
  PostApiSecretsVaultV2SecretsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSecretsVaultV2SecretsResponses,
    PostApiSecretsVaultV2SecretsErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v2/secrets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Secrets Vault Secret Version V1
 */
export const add_secrets_vault_secret_version_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSecretsVaultV1SecretsBySecretIdVersionsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses,
    PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v1/secrets/{secret_id}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add Secrets Vault Secret Version V2
 */
export const add_secrets_vault_secret_version_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSecretsVaultV2SecretsBySecretIdVersionsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses,
  PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses,
    PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v2/secrets/{secret_id}/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Secrets Vault Secret Version V1
 */
export const delete_secrets_vault_secret_version_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
    DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v1/secrets/{secret_id}/versions/{version_id}",
    ...options,
  });

/**
 * Update Secrets Vault Secret Version V1
 */
export const update_secrets_vault_secret_version_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
    PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v1/secrets/{secret_id}/versions/{version_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Secrets Vault Secret V1
 */
export const restore_secrets_vault_secret_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSecretsVaultV1SecretsBySecretIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses,
  PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses,
    PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/secrets-vault/v1/secrets/{secret_id}/restore", ...options });

/**
 * Restore Secrets Vault Secret Version V1
 */
export const restore_secrets_vault_secret_version_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses,
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses,
    PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/secrets-vault/v1/secrets/{secret_id}/versions/{version_id}/restore",
    ...options,
  });

/**
 * Service Now Reply V1
 */
export const service_now_reply_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiServiceNowV1ActionsReplyData, ThrowOnError>,
): RequestResult<
  PostApiServiceNowV1ActionsReplyResponses,
  PostApiServiceNowV1ActionsReplyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1ActionsReplyResponses,
    PostApiServiceNowV1ActionsReplyErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/actions/reply",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Change Incident State V1
 */
export const service_now_change_incident_state_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1ActionsChangeIncidentStateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1ActionsChangeIncidentStateResponses,
  PostApiServiceNowV1ActionsChangeIncidentStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1ActionsChangeIncidentStateResponses,
    PostApiServiceNowV1ActionsChangeIncidentStateErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/actions/change-incident-state",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Change Assignment Group V1
 */
export const service_now_change_assignment_group_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1ActionsChangeAssignmentGroupData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1ActionsChangeAssignmentGroupResponses,
  PostApiServiceNowV1ActionsChangeAssignmentGroupErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1ActionsChangeAssignmentGroupResponses,
    PostApiServiceNowV1ActionsChangeAssignmentGroupErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/actions/change-assignment-group",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Create Catalog Request V1
 */
export const service_now_create_catalog_request_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses,
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/create-catalog-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Submit Record Producer V1
 */
export const service_now_submit_record_producer_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/submit-record-producer",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Create Incident V1
 */
export const service_now_create_incident_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses,
    PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/create-incident",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Add Attachment V1
 */
export const service_now_add_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses,
    PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/add-attachment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Attach Tag V1
 */
export const service_now_attach_tag_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses,
    PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/attach-tag",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Change Request Item State V2
 */
export const service_now_change_request_item_state_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses,
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors,
    ThrowOnError
  >({
    url: "/api/v2/service-now/tenants/{tenant_id}/actions/change-request-item-state",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Change Task State V2
 */
export const service_now_change_task_state_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses,
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors,
    ThrowOnError
  >({
    url: "/api/v2/service-now/tenants/{tenant_id}/actions/change-task-state",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Change Approval State V1
 */
export const service_now_change_approval_state_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses,
    PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/change-approval-state",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Reply Tenant V1
 */
export const service_now_reply_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdActionsReplyData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses,
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses,
    PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/reply",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Change Request State V2
 */
export const service_now_change_request_state_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses,
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses,
    PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors,
    ThrowOnError
  >({
    url: "/api/v2/service-now/tenants/{tenant_id}/actions/change-request-state",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now List Articles V1
 */
export const service_now_list_articles_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdArticlesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdArticlesResponses,
  GetApiV1ServiceNowTenantsByTenantIdArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdArticlesResponses,
    GetApiV1ServiceNowTenantsByTenantIdArticlesErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}/articles", ...options });

/**
 * Service Now Create Article V1
 */
export const service_now_create_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdArticlesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdArticlesResponses,
  PostApiV1ServiceNowTenantsByTenantIdArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdArticlesResponses,
    PostApiV1ServiceNowTenantsByTenantIdArticlesErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/articles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Get Article V1
 */
export const service_now_get_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
    GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/articles/{sys_id}",
    ...options,
  });

/**
 * Service Now Update Article V1
 */
export const service_now_update_article_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
    PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/articles/{sys_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now List Knowledge Bases V1
 */
export const service_now_list_knowledge_bases_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases",
    ...options,
  });

/**
 * Service Now Create Knowledge Base V1
 */
export const service_now_create_knowledge_base_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
    PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Get Knowledge Base V1
 */
export const service_now_get_knowledge_base_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
    GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases/{sys_id}",
    ...options,
  });

/**
 * Service Now Update Knowledge Base V1
 */
export const service_now_update_knowledge_base_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
    PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases/{sys_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Get Incident State Choices V1
 */
export const service_now_get_incident_state_choices_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses,
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses,
    GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/incidents/state-choices",
    ...options,
  });

/**
 * Service Now List Assignment Groups V1
 */
export const service_now_list_assignment_groups_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses,
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses,
    GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/assignment-groups",
    ...options,
  });

/**
 * Service Now List Users V1
 */
export const service_now_list_users_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ServiceNowTenantsByTenantIdUsersData, ThrowOnError>,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdUsersResponses,
  GetApiV1ServiceNowTenantsByTenantIdUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdUsersResponses,
    GetApiV1ServiceNowTenantsByTenantIdUsersErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}/users", ...options });

/**
 * Service Now List Tags V1
 */
export const service_now_list_tags_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ServiceNowTenantsByTenantIdTagsData, ThrowOnError>,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdTagsResponses,
  GetApiV1ServiceNowTenantsByTenantIdTagsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdTagsResponses,
    GetApiV1ServiceNowTenantsByTenantIdTagsErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}/tags", ...options });

/**
 * Service Now Create Tag V1
 */
export const service_now_create_tag_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1ServiceNowTenantsByTenantIdTagsData, ThrowOnError>,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdTagsResponses,
  PostApiV1ServiceNowTenantsByTenantIdTagsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdTagsResponses,
    PostApiV1ServiceNowTenantsByTenantIdTagsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Get Request Item V1
 */
export const service_now_get_request_item_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses,
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/request-items/{sys_id}",
    ...options,
  });

/**
 * Service Now List Request Items V1
 */
export const service_now_list_request_items_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses,
    GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/requests/{request_sys_id}/request-items",
    ...options,
  });

/**
 * Service Now List Tasks V1
 */
export const service_now_list_tasks_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses,
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/request-items/{request_item_sys_id}/tasks",
    ...options,
  });

/**
 * Service Now Get Attachments V1
 */
export const service_now_get_attachments_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses,
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses,
    GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/tickets/{ticket_sys_id}/attachments",
    ...options,
  });

/**
 * Service Now Get Attachment Content V1
 */
export const service_now_get_attachment_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses,
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses,
    GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/attachments/{attachment_sys_id}/content",
    ...options,
  });

/**
 * Service Now List Approvals V1
 */
export const service_now_list_approvals_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses,
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses,
    GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/request-items/{request_item_sys_id}/approvals",
    ...options,
  });

/**
 * Service Now Get Approval State Choices V1
 */
export const service_now_get_approval_state_choices_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses,
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses,
    GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/approvals/state-choices",
    ...options,
  });

/**
 * Service Now List Catalog Items V1
 */
export const service_now_list_catalog_items_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/catalog-items",
    ...options,
  });

/**
 * Service Now Get Catalog Item V1
 */
export const service_now_get_catalog_item_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses,
    GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/catalog-items/{sys_id}",
    ...options,
  });

/**
 * Service Now List Tickets V1
 */
export const service_now_list_tickets_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdTicketsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdTicketsResponses,
  GetApiV1ServiceNowTenantsByTenantIdTicketsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdTicketsResponses,
    GetApiV1ServiceNowTenantsByTenantIdTicketsErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}/tickets", ...options });

/**
 * Service Now Get Ticket V1
 */
export const service_now_get_ticket_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses,
    GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}/tickets/{sys_id}",
    ...options,
  });

/**
 * Service Now Get Catalog Variable Values V1
 */
export const service_now_get_catalog_variable_values_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses,
    GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/catalog-variable-values",
    ...options,
  });

/**
 * Service Now Get User Profile V1
 */
export const service_now_get_user_profile_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData,
    ThrowOnError
  >,
): RequestResult<
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses,
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses,
    GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/user-profile",
    ...options,
  });

/**
 * Service Now Get Catalog Variable Lookup Metadata V1
 */
export const service_now_get_catalog_variable_lookup_metadata_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData,
    ThrowOnError
  >,
): RequestResult<
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses,
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses,
    GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/catalog-variable-lookup-metadata",
    ...options,
  });

/**
 * Service Now Search Records V1
 */
export const service_now_search_records_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/search-records",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Create Record V1
 */
export const service_now_create_record_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsRecordsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/records",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Update Record V1
 */
export const service_now_update_record_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses,
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses,
    PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/records/{record_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Aggregate Records V1
 */
export const service_now_aggregate_records_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/aggregate-records",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Create Change V1
 */
export const service_now_create_change_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsChangesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/changes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Update Change V1
 */
export const service_now_update_change_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses,
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses,
    PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/changes/{change_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Create Change Task V1
 */
export const service_now_create_change_task_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/changes/{change_id}/tasks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Run Batch V1
 */
export const service_now_run_batch_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsBatchData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/batch",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Add Record Attachment V1
 */
export const service_now_add_record_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData,
    ThrowOnError
  >,
): RequestResult<
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses,
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses,
    PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors,
    ThrowOnError
  >({
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/add-record-attachment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Get Tenants V1
 */
export const service_now_get_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1ServiceNowTenantsData, ThrowOnError>,
): RequestResult<
  GetApiV1ServiceNowTenantsResponses,
  GetApiV1ServiceNowTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ServiceNowTenantsResponses,
    GetApiV1ServiceNowTenantsErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants", ...options });

/**
 * Service Now Create Tenant V1
 */
export const service_now_create_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1ServiceNowTenantsData, ThrowOnError>,
): RequestResult<
  PostApiV1ServiceNowTenantsResponses,
  PostApiV1ServiceNowTenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsResponses,
    PostApiV1ServiceNowTenantsErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Delete Tenant V1
 */
export const service_now_delete_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApiV1ServiceNowTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1ServiceNowTenantsByTenantIdResponses,
  DeleteApiV1ServiceNowTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ServiceNowTenantsByTenantIdResponses,
    DeleteApiV1ServiceNowTenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}", ...options });

/**
 * Service Now Get Tenant V1
 */
export const service_now_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ServiceNowTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiV1ServiceNowTenantsByTenantIdResponses,
  GetApiV1ServiceNowTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ServiceNowTenantsByTenantIdResponses,
    GetApiV1ServiceNowTenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}", ...options });

/**
 * Service Now Update Tenant V1
 */
export const service_now_update_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiV1ServiceNowTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1ServiceNowTenantsByTenantIdResponses,
  PatchApiV1ServiceNowTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ServiceNowTenantsByTenantIdResponses,
    PatchApiV1ServiceNowTenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/service-now/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Service Now Restore Tenant V1
 */
export const service_now_restore_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ServiceNowTenantsByTenantIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdRestoreResponses,
  PostApiV1ServiceNowTenantsByTenantIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdRestoreResponses,
    PostApiV1ServiceNowTenantsByTenantIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}/restore", ...options });

/**
 * Service Now Setup Tenant V1
 */
export const service_now_setup_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1ServiceNowTenantsByTenantIdSetupData, ThrowOnError>,
): RequestResult<
  PostApiV1ServiceNowTenantsByTenantIdSetupResponses,
  PostApiV1ServiceNowTenantsByTenantIdSetupErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ServiceNowTenantsByTenantIdSetupResponses,
    PostApiV1ServiceNowTenantsByTenantIdSetupErrors,
    ThrowOnError
  >({ url: "/api/v1/service-now/tenants/{tenant_id}/setup", ...options });

/**
 * Sharepoint Get Drives V1
 */
export const sharepoint_get_drives_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses,
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses,
    GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/sites/{site_id}/drives",
    ...options,
  });

/**
 * Sharepoint Get Children V1
 */
export const sharepoint_get_children_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses,
    GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}/children",
    ...options,
  });

/**
 * Sharepoint Delete Item V1
 */
export const sharepoint_delete_item_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
    DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}",
    ...options,
  });

/**
 * Sharepoint Get Item V1
 */
export const sharepoint_get_item_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
    GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}",
    ...options,
  });

/**
 * Sharepoint Update Item V1
 */
export const sharepoint_update_item_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
    PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Create Download Url V1
 */
export const sharepoint_create_download_url_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses,
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}/download-url",
    ...options,
  });

/**
 * Sharepoint Create Upload Session V1
 */
export const sharepoint_create_upload_session_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses,
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}/upload-session",
    ...options,
  });

/**
 * Sharepoint Create Item Upload Session V1
 */
export const sharepoint_create_item_upload_session_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses,
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses,
    PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{folder_id}/children/upload-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Get Tenants V1
 */
export const sharepoint_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiSharepointV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiSharepointV1TenantsResponses,
  GetApiSharepointV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSharepointV1TenantsResponses,
    GetApiSharepointV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants", ...options });

/**
 * Sharepoint Create Tenant V1
 */
export const sharepoint_create_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiSharepointV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiSharepointV1TenantsResponses,
  PostApiSharepointV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsResponses,
    PostApiSharepointV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Get Full Tenants V1
 */
export const sharepoint_get_full_tenants_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiSharepointV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiSharepointV1FullTenantsResponses,
  GetApiSharepointV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSharepointV1FullTenantsResponses,
    GetApiSharepointV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/full-tenants", ...options });

/**
 * Sharepoint Delete Tenant V1
 */
export const sharepoint_delete_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApiSharepointV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiSharepointV1TenantsByTenantIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSharepointV1TenantsByTenantIdResponses,
    DeleteApiSharepointV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants/{tenant_id}", ...options });

/**
 * Sharepoint Get Tenant V1
 */
export const sharepoint_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiSharepointV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdResponses,
  GetApiSharepointV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdResponses,
    GetApiSharepointV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants/{tenant_id}", ...options });

/**
 * Sharepoint Patch Tenant V1
 */
export const sharepoint_patch_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchApiSharepointV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiSharepointV1TenantsByTenantIdResponses,
  PatchApiSharepointV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSharepointV1TenantsByTenantIdResponses,
    PatchApiSharepointV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Connect Tenant V1
 */
export const sharepoint_connect_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdConnectData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdConnectResponses,
  PostApiSharepointV1TenantsByTenantIdConnectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdConnectResponses,
    PostApiSharepointV1TenantsByTenantIdConnectErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants/{tenant_id}/connect", ...options });

/**
 * Sharepoint Callback Tenant V1
 */
export const sharepoint_callback_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdCallbackData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdCallbackResponses,
  PostApiSharepointV1TenantsByTenantIdCallbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdCallbackResponses,
    PostApiSharepointV1TenantsByTenantIdCallbackErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Check Connection V1
 */
export const sharepoint_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses,
  GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses,
    GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/check-connection",
    ...options,
  });

/**
 * Sharepoint Check Access V1
 */
export const sharepoint_check_access_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdCheckAccessData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdCheckAccessResponses,
  GetApiSharepointV1TenantsByTenantIdCheckAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdCheckAccessResponses,
    GetApiSharepointV1TenantsByTenantIdCheckAccessErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants/{tenant_id}/check-access", ...options });

/**
 * Sharepoint Get Admin Access V1
 */
export const sharepoint_get_admin_access_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdAdminAccessData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdAdminAccessResponses,
  GetApiSharepointV1TenantsByTenantIdAdminAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdAdminAccessResponses,
    GetApiSharepointV1TenantsByTenantIdAdminAccessErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants/{tenant_id}/admin-access", ...options });

/**
 * Sharepoint Get Sites V1
 */
export const sharepoint_get_sites_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiSharepointV1TenantsByTenantIdSitesData, ThrowOnError>,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdSitesResponses,
  GetApiSharepointV1TenantsByTenantIdSitesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdSitesResponses,
    GetApiSharepointV1TenantsByTenantIdSitesErrors,
    ThrowOnError
  >({ url: "/api/sharepoint/v1/tenants/{tenant_id}/sites", ...options });

/**
 * Sharepoint Create Site V1
 */
export const sharepoint_create_site_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiSharepointV1TenantsByTenantIdSitesData, ThrowOnError>,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdSitesResponses,
  PostApiSharepointV1TenantsByTenantIdSitesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdSitesResponses,
    PostApiSharepointV1TenantsByTenantIdSitesErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/sites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Grant Site V1
 */
export const sharepoint_grant_site_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdSitesGrantData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdSitesGrantResponses,
  PostApiSharepointV1TenantsByTenantIdSitesGrantErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdSitesGrantResponses,
    PostApiSharepointV1TenantsByTenantIdSitesGrantErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/sites/grant",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Delete Site V1
 */
export const sharepoint_delete_site_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses,
    DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/sites/{site_id}",
    ...options,
  });

/**
 * Sharepoint Get Folder Scopes V1
 */
export const sharepoint_get_folder_scopes_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSharepointV1TenantsByTenantIdFolderScopesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSharepointV1TenantsByTenantIdFolderScopesResponses,
  GetApiSharepointV1TenantsByTenantIdFolderScopesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSharepointV1TenantsByTenantIdFolderScopesResponses,
    GetApiSharepointV1TenantsByTenantIdFolderScopesErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/folder-scopes",
    ...options,
  });

/**
 * Sharepoint Create Folder Scope V1
 */
export const sharepoint_create_folder_scope_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSharepointV1TenantsByTenantIdFolderScopesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSharepointV1TenantsByTenantIdFolderScopesResponses,
  PostApiSharepointV1TenantsByTenantIdFolderScopesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSharepointV1TenantsByTenantIdFolderScopesResponses,
    PostApiSharepointV1TenantsByTenantIdFolderScopesErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/folder-scopes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sharepoint Delete Folder Scope V1
 */
export const sharepoint_delete_folder_scope_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses,
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses,
    DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors,
    ThrowOnError
  >({
    url: "/api/sharepoint/v1/tenants/{tenant_id}/folder-scopes/{folder_scope_id}",
    ...options,
  });

/**
 * Slack Post Chat Message V2
 */
export const slack_post_chat_message_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses,
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses,
    PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/post-chat-message",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Update Chat Message V2
 */
export const slack_update_chat_message_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses,
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses,
    PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/update-chat-message",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Add Reaction V2
 */
export const slack_add_reaction_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsAddReactionData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses,
  PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses,
    PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/add-reaction",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Set Channel Topic V2
 */
export const slack_set_channel_topic_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses,
    PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/set-channel-topic",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Set Channel Description V2
 */
export const slack_set_channel_description_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses,
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses,
    PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/set-channel-description",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Set Assistant Status V2
 */
export const slack_set_assistant_status_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses,
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses,
    PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/set-assistant-status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Set Suggested Prompts V1
 */
export const slack_set_suggested_prompts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses,
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses,
    PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/set-suggested-prompts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Set Assistant Title V1
 */
export const slack_set_assistant_title_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses,
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses,
    PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/set-assistant-title",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Open View V1
 */
export const slack_open_view_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsViewsOpenData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses,
    PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/views/open",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Update View V1
 */
export const slack_update_view_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses,
    PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/views/update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Push View V1
 */
export const slack_push_view_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsViewsPushData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses,
    PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/views/push",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Publish Home View V1
 */
export const slack_publish_home_view_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses,
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses,
    PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/views/publish-home",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Download File V2
 */
export const slack_download_file_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadResponses,
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadResponses,
    PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/files/{file_id}/download",
    ...options,
  });

/**
 * Slack Upload Files V2
 */
export const slack_upload_files_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses,
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/slack/v2/tenants/{tenant_id}/actions/files/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Slack Upload Content V2
 */
export const slack_upload_content_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses,
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses,
    PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/files/upload-content",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Get User Info V2
 */
export const slack_get_user_info_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses,
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses,
    GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/users/{user_id}",
    ...options,
  });

/**
 * Slack List Users V2
 */
export const slack_list_users_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSlackV2TenantsByTenantIdActionsUsersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV2TenantsByTenantIdActionsUsersResponses,
  GetApiSlackV2TenantsByTenantIdActionsUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV2TenantsByTenantIdActionsUsersResponses,
    GetApiSlackV2TenantsByTenantIdActionsUsersErrors,
    ThrowOnError
  >({ url: "/api/slack/v2/tenants/{tenant_id}/actions/users", ...options });

/**
 * Slack Get Channel Messages V2
 */
export const slack_get_channel_messages_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses,
    GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/channels/{channel}/messages",
    ...options,
  });

/**
 * Slack Get Reactions V2
 */
export const slack_get_reactions_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses,
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses,
    GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors,
    ThrowOnError
  >({
    url: "/api/slack/v2/tenants/{tenant_id}/actions/channels/{channel}/messages/{ts}/reactions",
    ...options,
  });

/**
 * Slack Get User Groups V1
 */
export const slack_get_user_groups_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses,
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/user-groups",
    ...options,
  });

/**
 * Slack Get User Group Users V1
 */
export const slack_get_user_group_users_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses,
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses,
    GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/user-groups/{usergroup_id}/users",
    ...options,
  });

/**
 * Slack Update User Group Users V1
 */
export const slack_update_user_group_users_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses,
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/update-user-group-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Update User Group V1
 */
export const slack_update_user_group_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData,
    ThrowOnError
  >,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses,
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses,
    PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/actions/update-user-group",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Get Oauth Scopes V1
 */
export const slack_get_oauth_scopes_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiSlackV1OauthScopesData, ThrowOnError>,
): RequestResult<GetApiSlackV1OauthScopesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiSlackV1OauthScopesResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/slack/v1/oauth-scopes", ...options });

/**
 * Slack Get Tenants V1
 */
export const slack_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiSlackV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiSlackV1TenantsResponses,
  GetApiSlackV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSlackV1TenantsResponses,
    GetApiSlackV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/tenants", ...options });

/**
 * Slack Create Tenant V1
 */
export const slack_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiSlackV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiSlackV1TenantsResponses,
  PostApiSlackV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsResponses,
    PostApiSlackV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Get Full Tenants V1
 */
export const slack_get_full_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiSlackV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiSlackV1FullTenantsResponses,
  GetApiSlackV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiSlackV1FullTenantsResponses,
    GetApiSlackV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/full-tenants", ...options });

/**
 * Slack Delete Tenant V1
 */
export const slack_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiSlackV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiSlackV1TenantsByTenantIdResponses,
  DeleteApiSlackV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiSlackV1TenantsByTenantIdResponses,
    DeleteApiSlackV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/tenants/{tenant_id}", ...options });

/**
 * Slack Get Tenant V1
 */
export const slack_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiSlackV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiSlackV1TenantsByTenantIdResponses,
  GetApiSlackV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV1TenantsByTenantIdResponses,
    GetApiSlackV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/tenants/{tenant_id}", ...options });

/**
 * Slack Patch Tenant V1
 */
export const slack_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiSlackV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiSlackV1TenantsByTenantIdResponses,
  PatchApiSlackV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiSlackV1TenantsByTenantIdResponses,
    PatchApiSlackV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Download Manifest V1
 */
export const slack_download_manifest_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiSlackV1TenantsByTenantIdManifestData, ThrowOnError>,
): RequestResult<
  GetApiSlackV1TenantsByTenantIdManifestResponses,
  GetApiSlackV1TenantsByTenantIdManifestErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV1TenantsByTenantIdManifestResponses,
    GetApiSlackV1TenantsByTenantIdManifestErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/tenants/{tenant_id}/manifest", ...options });

/**
 * Slack Connect Tenant V1
 */
export const slack_connect_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiSlackV1TenantsByTenantIdConnectData, ThrowOnError>,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdConnectResponses,
  PostApiSlackV1TenantsByTenantIdConnectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdConnectResponses,
    PostApiSlackV1TenantsByTenantIdConnectErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/tenants/{tenant_id}/connect", ...options });

/**
 * Slack Callback Tenant V1
 */
export const slack_callback_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiSlackV1TenantsByTenantIdCallbackData, ThrowOnError>,
): RequestResult<
  PostApiSlackV1TenantsByTenantIdCallbackResponses,
  PostApiSlackV1TenantsByTenantIdCallbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiSlackV1TenantsByTenantIdCallbackResponses,
    PostApiSlackV1TenantsByTenantIdCallbackErrors,
    ThrowOnError
  >({
    url: "/api/slack/v1/tenants/{tenant_id}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Slack Check Connection V1
 */
export const slack_check_connection_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiSlackV1TenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiSlackV1TenantsByTenantIdCheckConnectionResponses,
  GetApiSlackV1TenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiSlackV1TenantsByTenantIdCheckConnectionResponses,
    GetApiSlackV1TenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({ url: "/api/slack/v1/tenants/{tenant_id}/check-connection", ...options });

/**
 * Get Tasks V2
 */
export const get_tasks_v2 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV2TasksData, ThrowOnError>,
): RequestResult<GetApiV2TasksResponses, GetApiV2TasksErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV2TasksResponses,
    GetApiV2TasksErrors,
    ThrowOnError
  >({ url: "/api/v2/tasks", ...options });

/**
 * Create Task V2
 */
export const create_task_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2TasksData, ThrowOnError>,
): RequestResult<PostApiV2TasksResponses, PostApiV2TasksErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PostApiV2TasksResponses,
    PostApiV2TasksErrors,
    ThrowOnError
  >({
    url: "/api/v2/tasks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete Task V2
 */
export const delete_task_v2 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV2TasksByTaskIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV2TasksByTaskIdResponses,
  DeleteApiV2TasksByTaskIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV2TasksByTaskIdResponses,
    DeleteApiV2TasksByTaskIdErrors,
    ThrowOnError
  >({ url: "/api/v2/tasks/{task_id}", ...options });

/**
 * Get Task V2
 */
export const get_task_v2 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV2TasksByTaskIdData, ThrowOnError>,
): RequestResult<
  GetApiV2TasksByTaskIdResponses,
  GetApiV2TasksByTaskIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV2TasksByTaskIdResponses,
    GetApiV2TasksByTaskIdErrors,
    ThrowOnError
  >({ url: "/api/v2/tasks/{task_id}", ...options });

/**
 * Update Task V2
 */
export const update_task_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV2TasksByTaskIdData, ThrowOnError>,
): RequestResult<
  PatchApiV2TasksByTaskIdResponses,
  PatchApiV2TasksByTaskIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV2TasksByTaskIdResponses,
    PatchApiV2TasksByTaskIdErrors,
    ThrowOnError
  >({
    url: "/api/v2/tasks/{task_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Task V2
 */
export const restore_task_v2 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV2TasksByTaskIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV2TasksByTaskIdRestoreResponses,
  PostApiV2TasksByTaskIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV2TasksByTaskIdRestoreResponses,
    PostApiV2TasksByTaskIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v2/tasks/{task_id}/restore", ...options });

/**
 * Teams Post Message V1
 */
export const teams_post_message_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/post",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Update Message V1
 */
export const teams_update_message_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/update",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Delete Message V1
 */
export const teams_delete_message_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/delete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Send Proactive Message V1
 */
export const teams_send_proactive_message_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses,
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses,
    PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/send-proactive",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Download File V1
 */
export const teams_download_file_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadResponses,
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadResponses,
    PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/files/download",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Get Conversation Member V1
 */
export const teams_get_conversation_member_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses,
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/conversations/members/get",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams List Conversation Members V1
 */
export const teams_list_conversation_members_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses,
    PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/conversations/members/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams List Conversation Activities V1
 */
export const teams_list_conversation_activities_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses,
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses,
    PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/conversations/activities/list",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Get Tenants V1
 */
export const teams_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiTeamsV1TenantsData, ThrowOnError>,
): RequestResult<
  GetApiTeamsV1TenantsResponses,
  GetApiTeamsV1TenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiTeamsV1TenantsResponses,
    GetApiTeamsV1TenantsErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/tenants", ...options });

/**
 * Teams Create Tenant V1
 */
export const teams_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiTeamsV1TenantsData, ThrowOnError>,
): RequestResult<
  PostApiTeamsV1TenantsResponses,
  PostApiTeamsV1TenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsResponses,
    PostApiTeamsV1TenantsErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Get Full Tenants V1
 */
export const teams_get_full_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiTeamsV1FullTenantsData, ThrowOnError>,
): RequestResult<
  GetApiTeamsV1FullTenantsResponses,
  GetApiTeamsV1FullTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiTeamsV1FullTenantsResponses,
    GetApiTeamsV1FullTenantsErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/full-tenants", ...options });

/**
 * Teams Delete Tenant V1
 */
export const teams_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiTeamsV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiTeamsV1TenantsByTenantIdResponses,
  DeleteApiTeamsV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiTeamsV1TenantsByTenantIdResponses,
    DeleteApiTeamsV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/tenants/{tenant_id}", ...options });

/**
 * Teams Get Tenant V1
 */
export const teams_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiTeamsV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiTeamsV1TenantsByTenantIdResponses,
  GetApiTeamsV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiTeamsV1TenantsByTenantIdResponses,
    GetApiTeamsV1TenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/tenants/{tenant_id}", ...options });

/**
 * Teams Patch Tenant V1
 */
export const teams_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiTeamsV1TenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiTeamsV1TenantsByTenantIdResponses,
  PatchApiTeamsV1TenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiTeamsV1TenantsByTenantIdResponses,
    PatchApiTeamsV1TenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Teams Check Connection V1
 */
export const teams_check_connection_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses,
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses,
    PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/teams/v1/tenants/{tenant_id}/actions/check-connection",
    ...options,
  });

/**
 * Teams Get Icon V1
 */
export const teams_get_icon_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiTeamsV1TenantsByTenantIdIconsData, ThrowOnError>,
): RequestResult<
  GetApiTeamsV1TenantsByTenantIdIconsResponses,
  GetApiTeamsV1TenantsByTenantIdIconsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiTeamsV1TenantsByTenantIdIconsResponses,
    GetApiTeamsV1TenantsByTenantIdIconsErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/tenants/{tenant_id}/icons", ...options });

/**
 * Teams Upload Icon V1
 */
export const teams_upload_icon_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiTeamsV1TenantsByTenantIdIconsData, ThrowOnError>,
): RequestResult<
  PostApiTeamsV1TenantsByTenantIdIconsResponses,
  PostApiTeamsV1TenantsByTenantIdIconsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiTeamsV1TenantsByTenantIdIconsResponses,
    PostApiTeamsV1TenantsByTenantIdIconsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/api/teams/v1/tenants/{tenant_id}/icons",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Teams Download Manifest V1
 */
export const teams_download_manifest_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApiTeamsV1TenantsByTenantIdManifestData, ThrowOnError>,
): RequestResult<
  GetApiTeamsV1TenantsByTenantIdManifestResponses,
  GetApiTeamsV1TenantsByTenantIdManifestErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiTeamsV1TenantsByTenantIdManifestResponses,
    GetApiTeamsV1TenantsByTenantIdManifestErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/tenants/{tenant_id}/manifest", ...options });

/**
 * Teams Get Installs V1
 */
export const teams_get_installs_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiTeamsV1TenantsByTenantIdInstallsData, ThrowOnError>,
): RequestResult<
  GetApiTeamsV1TenantsByTenantIdInstallsResponses,
  GetApiTeamsV1TenantsByTenantIdInstallsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiTeamsV1TenantsByTenantIdInstallsResponses,
    GetApiTeamsV1TenantsByTenantIdInstallsErrors,
    ThrowOnError
  >({ url: "/api/teams/v1/tenants/{tenant_id}/installs", ...options });

/**
 * Get Agent Usage Stats V1
 */
export const get_agent_usage_stats_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1UsageStatsAgentsData, ThrowOnError>,
): RequestResult<
  GetApiV1UsageStatsAgentsResponses,
  GetApiV1UsageStatsAgentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1UsageStatsAgentsResponses,
    GetApiV1UsageStatsAgentsErrors,
    ThrowOnError
  >({ url: "/api/v1/usage-stats/agents", ...options });

/**
 * Get Users V1
 */
export const get_users_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1UsersData, ThrowOnError>,
): RequestResult<GetApiV1UsersResponses, GetApiV1UsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1UsersResponses,
    GetApiV1UsersErrors,
    ThrowOnError
  >({ url: "/api/v1/users", ...options });

/**
 * Get Current User V1
 */
export const get_current_user_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1UsersMeData, ThrowOnError>,
): RequestResult<GetApiV1UsersMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetApiV1UsersMeResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/users/me", ...options });

/**
 * Update Current User V1
 */
export const update_current_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1UsersMeData, ThrowOnError>,
): RequestResult<
  PatchApiV1UsersMeResponses,
  PatchApiV1UsersMeErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1UsersMeResponses,
    PatchApiV1UsersMeErrors,
    ThrowOnError
  >({
    url: "/api/v1/users/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete User V1
 */
export const delete_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1UsersByUserIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1UsersByUserIdResponses,
  DeleteApiV1UsersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1UsersByUserIdResponses,
    DeleteApiV1UsersByUserIdErrors,
    ThrowOnError
  >({ url: "/api/v1/users/{user_id}", ...options });

/**
 * Get User V1
 */
export const get_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1UsersByUserIdData, ThrowOnError>,
): RequestResult<
  GetApiV1UsersByUserIdResponses,
  GetApiV1UsersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1UsersByUserIdResponses,
    GetApiV1UsersByUserIdErrors,
    ThrowOnError
  >({ url: "/api/v1/users/{user_id}", ...options });

/**
 * Create Bot User V1
 */
export const create_bot_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1UsersBotData, ThrowOnError>,
): RequestResult<
  PostApiV1UsersBotResponses,
  PostApiV1UsersBotErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1UsersBotResponses,
    PostApiV1UsersBotErrors,
    ThrowOnError
  >({
    url: "/api/v1/users/bot",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upsert External User V1
 */
export const upsert_external_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PutApiV1UsersExternalByExternalIdData, ThrowOnError>,
): RequestResult<
  PutApiV1UsersExternalByExternalIdResponses,
  PutApiV1UsersExternalByExternalIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1UsersExternalByExternalIdResponses,
    PutApiV1UsersExternalByExternalIdErrors,
    ThrowOnError
  >({ url: "/api/v1/users/external/{external_id}", ...options });

/**
 * Restore User V1
 */
export const restore_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1UsersByUserIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV1UsersByUserIdRestoreResponses,
  PostApiV1UsersByUserIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1UsersByUserIdRestoreResponses,
    PostApiV1UsersByUserIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v1/users/{user_id}/restore", ...options });

/**
 * Create Work Claim V1
 */
export const create_work_claim_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1WorkClaimsData, ThrowOnError>,
): RequestResult<
  PostApiV1WorkClaimsResponses,
  PostApiV1WorkClaimsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1WorkClaimsResponses,
    PostApiV1WorkClaimsErrors,
    ThrowOnError
  >({
    url: "/api/v1/work-claims",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Complete Work Claim V1
 */
export const complete_work_claim_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1WorkClaimsByClaimIdCompleteData, ThrowOnError>,
): RequestResult<
  PostApiV1WorkClaimsByClaimIdCompleteResponses,
  PostApiV1WorkClaimsByClaimIdCompleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1WorkClaimsByClaimIdCompleteResponses,
    PostApiV1WorkClaimsByClaimIdCompleteErrors,
    ThrowOnError
  >({ url: "/api/v1/work-claims/{claim_id}/complete", ...options });

/**
 * Delete Work Claim V1
 */
export const delete_work_claim_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1WorkClaimsByClaimIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1WorkClaimsByClaimIdResponses,
  DeleteApiV1WorkClaimsByClaimIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1WorkClaimsByClaimIdResponses,
    DeleteApiV1WorkClaimsByClaimIdErrors,
    ThrowOnError
  >({ url: "/api/v1/work-claims/{claim_id}", ...options });

/**
 * Create Work Event V1
 */
export const create_work_event_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1WorkEventsData, ThrowOnError>,
): RequestResult<
  PostApiV1WorkEventsResponses,
  PostApiV1WorkEventsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1WorkEventsResponses,
    PostApiV1WorkEventsErrors,
    ThrowOnError
  >({
    url: "/api/v1/work-events",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Work Event V1
 */
export const get_work_event_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1WorkEventsByEventIdData, ThrowOnError>,
): RequestResult<
  GetApiV1WorkEventsByEventIdResponses,
  GetApiV1WorkEventsByEventIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1WorkEventsByEventIdResponses,
    GetApiV1WorkEventsByEventIdErrors,
    ThrowOnError
  >({ url: "/api/v1/work-events/{event_id}", ...options });

/**
 * Get Full Work Events V1
 */
export const get_full_work_events_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1FullWorkEventsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullWorkEventsResponses,
  GetApiV1FullWorkEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullWorkEventsResponses,
    GetApiV1FullWorkEventsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-work-events", ...options });

/**
 * Get Workflows V1
 */
export const get_workflows_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1WorkflowsData, ThrowOnError>,
): RequestResult<
  GetApiV1WorkflowsResponses,
  GetApiV1WorkflowsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1WorkflowsResponses,
    GetApiV1WorkflowsErrors,
    ThrowOnError
  >({ url: "/api/v1/workflows", ...options });

/**
 * Get Workflow Runs V1
 */
export const get_workflow_runs_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1FullWorkflowRunsData, ThrowOnError>,
): RequestResult<
  GetApiV1FullWorkflowRunsResponses,
  GetApiV1FullWorkflowRunsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1FullWorkflowRunsResponses,
    GetApiV1FullWorkflowRunsErrors,
    ThrowOnError
  >({ url: "/api/v1/full-workflow-runs", ...options });

/**
 * Get Workflow Run V1
 */
export const get_workflow_run_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1WorkflowRunsByWorkflowRunIdData, ThrowOnError>,
): RequestResult<
  GetApiV1WorkflowRunsByWorkflowRunIdResponses,
  GetApiV1WorkflowRunsByWorkflowRunIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1WorkflowRunsByWorkflowRunIdResponses,
    GetApiV1WorkflowRunsByWorkflowRunIdErrors,
    ThrowOnError
  >({ url: "/api/v1/workflow-runs/{workflow_run_id}", ...options });

/**
 * Update Workflow Run V1
 */
export const update_workflow_run_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1WorkflowRunsByWorkflowRunIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1WorkflowRunsByWorkflowRunIdResponses,
  PatchApiV1WorkflowRunsByWorkflowRunIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1WorkflowRunsByWorkflowRunIdResponses,
    PatchApiV1WorkflowRunsByWorkflowRunIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/workflow-runs/{workflow_run_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Workflow Run Analytics Events V1
 */
export const get_workflow_run_analytics_events_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1WorkflowAnalyticsEventsData, ThrowOnError>,
): RequestResult<
  GetApiV1WorkflowAnalyticsEventsResponses,
  GetApiV1WorkflowAnalyticsEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1WorkflowAnalyticsEventsResponses,
    GetApiV1WorkflowAnalyticsEventsErrors,
    ThrowOnError
  >({ url: "/api/v1/workflow-analytics-events", ...options });

/**
 * Create Workflow Analytics Event V1
 */
export const create_workflow_analytics_event_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1WorkflowAnalyticsEventsData, ThrowOnError>,
): RequestResult<
  PostApiV1WorkflowAnalyticsEventsResponses,
  PostApiV1WorkflowAnalyticsEventsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1WorkflowAnalyticsEventsResponses,
    PostApiV1WorkflowAnalyticsEventsErrors,
    ThrowOnError
  >({
    url: "/api/v1/workflow-analytics-events",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Workspaces V1
 */
export const get_workspaces_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1WorkspacesData, ThrowOnError>,
): RequestResult<
  GetApiV1WorkspacesResponses,
  GetApiV1WorkspacesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1WorkspacesResponses,
    GetApiV1WorkspacesErrors,
    ThrowOnError
  >({ url: "/api/v1/workspaces", ...options });

/**
 * Create Workspace V1
 */
export const create_workspace_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<PostApiV1WorkspacesData, ThrowOnError>,
): RequestResult<PostApiV1WorkspacesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostApiV1WorkspacesResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/workspaces", ...options });

/**
 * Delete Workspace V1
 */
export const delete_workspace_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1WorkspacesByWorkspaceIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1WorkspacesByWorkspaceIdResponses,
  DeleteApiV1WorkspacesByWorkspaceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1WorkspacesByWorkspaceIdResponses,
    DeleteApiV1WorkspacesByWorkspaceIdErrors,
    ThrowOnError
  >({ url: "/api/v1/workspaces/{workspace_id}", ...options });

/**
 * Get Workspace V1
 */
export const get_workspace_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1WorkspacesByWorkspaceIdData, ThrowOnError>,
): RequestResult<
  GetApiV1WorkspacesByWorkspaceIdResponses,
  GetApiV1WorkspacesByWorkspaceIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1WorkspacesByWorkspaceIdResponses,
    GetApiV1WorkspacesByWorkspaceIdErrors,
    ThrowOnError
  >({ url: "/api/v1/workspaces/{workspace_id}", ...options });

/**
 * Restore Workspace V1
 */
export const restore_workspace_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1WorkspacesByWorkspaceIdRestoreData, ThrowOnError>,
): RequestResult<
  PostApiV1WorkspacesByWorkspaceIdRestoreResponses,
  PostApiV1WorkspacesByWorkspaceIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1WorkspacesByWorkspaceIdRestoreResponses,
    PostApiV1WorkspacesByWorkspaceIdRestoreErrors,
    ThrowOnError
  >({ url: "/api/v1/workspaces/{workspace_id}/restore", ...options });

/**
 * Zendesk Reply To Ticket V1
 */
export const zendesk_reply_to_ticket_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiZendeskV1ActionsReplyToTicketData, ThrowOnError>,
): RequestResult<
  PostApiZendeskV1ActionsReplyToTicketResponses,
  PostApiZendeskV1ActionsReplyToTicketErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiZendeskV1ActionsReplyToTicketResponses,
    PostApiZendeskV1ActionsReplyToTicketErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/actions/reply-to-ticket",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Zendesk Update Ticket Tags V1
 */
export const zendesk_update_ticket_tags_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses,
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses,
    PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/update-ticket-tags",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Zendesk Get Ticket Attachment Content V1
 */
export const zendesk_get_ticket_attachment_content_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses,
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses,
    GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/ticket-attachment-content/{attachment_id}",
    ...options,
  });

/**
 * Zendesk Download Ticket Attachment V1
 */
export const zendesk_download_ticket_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdResponses,
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdResponses,
    GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/download-ticket-attachment/{attachment_id}",
    ...options,
  });

/**
 * Zendesk Get Sections V1
 */
export const zendesk_get_sections_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiZendeskV1TenantsByTenantIdActionsSectionsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses,
  GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses,
    GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/sections",
    ...options,
  });

/**
 * Zendesk Get Categories V1
 */
export const zendesk_get_categories_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiZendeskV1TenantsByTenantIdActionsCategoriesData,
    ThrowOnError
  >,
): RequestResult<
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses,
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses,
    GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/categories",
    ...options,
  });

/**
 * Zendesk List Tickets V1
 */
export const zendesk_list_tickets_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ZendeskTenantsByTenantIdTicketsData, ThrowOnError>,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdTicketsResponses,
  GetApiV1ZendeskTenantsByTenantIdTicketsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdTicketsResponses,
    GetApiV1ZendeskTenantsByTenantIdTicketsErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}/tickets", ...options });

/**
 * Zendesk Search Tickets V1
 */
export const zendesk_search_tickets_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses,
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses,
    GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors,
    ThrowOnError
  >({
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/search-tickets",
    ...options,
  });

/**
 * Zendesk Get Ticket V1
 */
export const zendesk_get_ticket_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses,
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses,
    GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/tickets/{ticket_id}",
    ...options,
  });

/**
 * Zendesk Get Users V1
 */
export const zendesk_get_users_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ZendeskTenantsByTenantIdUsersData, ThrowOnError>,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdUsersResponses,
  GetApiV1ZendeskTenantsByTenantIdUsersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdUsersResponses,
    GetApiV1ZendeskTenantsByTenantIdUsersErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}/users", ...options });

/**
 * Zendesk Get User V1
 */
export const zendesk_get_user_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses,
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses,
    GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}/users/{user_id}", ...options });

/**
 * Zendesk List Articles V1
 */
export const zendesk_list_articles_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ZendeskTenantsByTenantIdArticlesData, ThrowOnError>,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdArticlesResponses,
  GetApiV1ZendeskTenantsByTenantIdArticlesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdArticlesResponses,
    GetApiV1ZendeskTenantsByTenantIdArticlesErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}/articles", ...options });

/**
 * Zendesk List Article Attachments V1
 */
export const zendesk_list_article_attachments_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses,
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses,
    GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/articles/{article_id}/attachments",
    ...options,
  });

/**
 * Zendesk Download Article Attachment V1
 */
export const zendesk_download_article_attachment_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentResponses,
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentResponses,
    GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/article-attachments/{attachment_id}/content",
    ...options,
  });

/**
 * Zendesk Get Tenants V1
 */
export const zendesk_get_tenants_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1ZendeskTenantsData, ThrowOnError>,
): RequestResult<
  GetApiV1ZendeskTenantsResponses,
  GetApiV1ZendeskTenantsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ZendeskTenantsResponses,
    GetApiV1ZendeskTenantsErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants", ...options });

/**
 * Zendesk Create Tenant V1
 */
export const zendesk_create_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1ZendeskTenantsData, ThrowOnError>,
): RequestResult<
  PostApiV1ZendeskTenantsResponses,
  PostApiV1ZendeskTenantsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ZendeskTenantsResponses,
    PostApiV1ZendeskTenantsErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Zendesk Get Oauth Redirect Uri V1
 */
export const zendesk_get_oauth_redirect_uri_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1ZendeskOauthRedirectUriData, ThrowOnError>,
): RequestResult<
  GetApiV1ZendeskOauthRedirectUriResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1ZendeskOauthRedirectUriResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/v1/zendesk/oauth-redirect-uri", ...options });

/**
 * Zendesk Delete Tenant V1
 */
export const zendesk_delete_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiV1ZendeskTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  DeleteApiV1ZendeskTenantsByTenantIdResponses,
  DeleteApiV1ZendeskTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ZendeskTenantsByTenantIdResponses,
    DeleteApiV1ZendeskTenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}", ...options });

/**
 * Zendesk Get Tenant V1
 */
export const zendesk_get_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiV1ZendeskTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdResponses,
  GetApiV1ZendeskTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdResponses,
    GetApiV1ZendeskTenantsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}", ...options });

/**
 * Zendesk Patch Tenant V1
 */
export const zendesk_patch_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1ZendeskTenantsByTenantIdData, ThrowOnError>,
): RequestResult<
  PatchApiV1ZendeskTenantsByTenantIdResponses,
  PatchApiV1ZendeskTenantsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1ZendeskTenantsByTenantIdResponses,
    PatchApiV1ZendeskTenantsByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Zendesk Connect Tenant V1
 */
export const zendesk_connect_tenant_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1ZendeskTenantsByTenantIdConnectData, ThrowOnError>,
): RequestResult<
  PostApiV1ZendeskTenantsByTenantIdConnectResponses,
  PostApiV1ZendeskTenantsByTenantIdConnectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ZendeskTenantsByTenantIdConnectResponses,
    PostApiV1ZendeskTenantsByTenantIdConnectErrors,
    ThrowOnError
  >({ url: "/api/v1/zendesk/tenants/{tenant_id}/connect", ...options });

/**
 * Zendesk Callback Tenant V1
 */
export const zendesk_callback_tenant_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1ZendeskTenantsByTenantIdCallbackData, ThrowOnError>,
): RequestResult<
  PostApiV1ZendeskTenantsByTenantIdCallbackResponses,
  PostApiV1ZendeskTenantsByTenantIdCallbackErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ZendeskTenantsByTenantIdCallbackResponses,
    PostApiV1ZendeskTenantsByTenantIdCallbackErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/callback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Zendesk Check Connection V1
 */
export const zendesk_check_connection_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1ZendeskTenantsByTenantIdCheckConnectionData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses,
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses,
    GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/check-connection",
    ...options,
  });

/**
 * Zendesk Deprovision Webhook V1
 */
export const zendesk_deprovision_webhook_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
    DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/webhooks/provision",
    ...options,
  });

/**
 * Zendesk Provision Webhook V1
 */
export const zendesk_provision_webhook_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
    PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
    ThrowOnError
  >({
    url: "/api/v1/zendesk/tenants/{tenant_id}/webhooks/provision",
    ...options,
  });

/**
 * Get Calibration Feedback Inference Datapoints V1
 */
export const get_calibration_feedback_inference_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1CalibrationFeedbackInferenceDatapointsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackInferenceDatapointsResponses,
  GetApiV1CalibrationFeedbackInferenceDatapointsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackInferenceDatapointsResponses,
    GetApiV1CalibrationFeedbackInferenceDatapointsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/inference-datapoints", ...options });

/**
 * Create Calibration Feedback Inference Datapoints V1
 */
export const create_calibration_feedback_inference_datapoints_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1CalibrationFeedbackInferenceDatapointsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1CalibrationFeedbackInferenceDatapointsResponses,
  PostApiV1CalibrationFeedbackInferenceDatapointsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackInferenceDatapointsResponses,
    PostApiV1CalibrationFeedbackInferenceDatapointsErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/inference-datapoints",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Calibration Feedback Inference Datapoint Tags V1
 */
export const get_calibration_feedback_inference_datapoint_tags_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1CalibrationFeedbackInferenceDatapointsTagsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses,
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses,
    GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/inference-datapoints/tags",
    ...options,
  });

/**
 * Delete Calibration Feedback Inference Datapoint V1
 */
export const delete_calibration_feedback_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
    DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/inference-datapoints/{inference_datapoint_id}",
    ...options,
  });

/**
 * Get Calibration Feedback Inference Datapoint V1
 */
export const get_calibration_feedback_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
    GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/inference-datapoints/{inference_datapoint_id}",
    ...options,
  });

/**
 * Restore Calibration Feedback Inference Datapoint V1
 */
export const restore_calibration_feedback_inference_datapoint_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses,
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses,
    PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/inference-datapoints/{inference_datapoint_id}/restore",
    ...options,
  });

/**
 * Get Calibration Feedback Dimensions V1
 */
export const get_calibration_feedback_dimensions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1CalibrationFeedbackDimensionsData, ThrowOnError>,
): RequestResult<
  GetApiV1CalibrationFeedbackDimensionsResponses,
  GetApiV1CalibrationFeedbackDimensionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackDimensionsResponses,
    GetApiV1CalibrationFeedbackDimensionsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/dimensions", ...options });

/**
 * Create Calibration Feedback Dimension V1
 */
export const create_calibration_feedback_dimension_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1CalibrationFeedbackDimensionsData, ThrowOnError>,
): RequestResult<
  PostApiV1CalibrationFeedbackDimensionsResponses,
  PostApiV1CalibrationFeedbackDimensionsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackDimensionsResponses,
    PostApiV1CalibrationFeedbackDimensionsErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/dimensions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Calibration Feedback Dimensions V1
 */
export const get_full_calibration_feedback_dimensions_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1CalibrationFeedbackFullDimensionsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackFullDimensionsResponses,
  GetApiV1CalibrationFeedbackFullDimensionsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackFullDimensionsResponses,
    GetApiV1CalibrationFeedbackFullDimensionsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/full-dimensions", ...options });

/**
 * Delete Calibration Feedback Dimension V1
 */
export const delete_calibration_feedback_dimension_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
    DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/dimensions/{dimension_id}",
    ...options,
  });

/**
 * Get Calibration Feedback Dimension V1
 */
export const get_calibration_feedback_dimension_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1CalibrationFeedbackDimensionsByDimensionIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
    GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/dimensions/{dimension_id}",
    ...options,
  });

/**
 * Restore Calibration Feedback Dimension V1
 */
export const restore_calibration_feedback_dimension_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses,
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses,
    PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/dimensions/{dimension_id}/restore",
    ...options,
  });

/**
 * Get Calibration Feedback Queue Items V1
 */
export const get_calibration_feedback_queue_items_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1CalibrationFeedbackQueueItemsData, ThrowOnError>,
): RequestResult<
  GetApiV1CalibrationFeedbackQueueItemsResponses,
  GetApiV1CalibrationFeedbackQueueItemsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackQueueItemsResponses,
    GetApiV1CalibrationFeedbackQueueItemsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/queue-items", ...options });

/**
 * Create Calibration Feedback Queue Items V1
 */
export const create_calibration_feedback_queue_items_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1CalibrationFeedbackQueueItemsData, ThrowOnError>,
): RequestResult<
  PostApiV1CalibrationFeedbackQueueItemsResponses,
  PostApiV1CalibrationFeedbackQueueItemsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackQueueItemsResponses,
    PostApiV1CalibrationFeedbackQueueItemsErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/queue-items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Calibration Feedback Queue Items V1
 */
export const get_full_calibration_feedback_queue_items_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1CalibrationFeedbackFullQueueItemsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackFullQueueItemsResponses,
  GetApiV1CalibrationFeedbackFullQueueItemsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackFullQueueItemsResponses,
    GetApiV1CalibrationFeedbackFullQueueItemsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/full-queue-items", ...options });

/**
 * Get Calibration Feedback Queue Item Tags V1
 */
export const get_calibration_feedback_queue_item_tags_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiV1CalibrationFeedbackQueueItemsTagsData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackQueueItemsTagsResponses,
  GetApiV1CalibrationFeedbackQueueItemsTagsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackQueueItemsTagsResponses,
    GetApiV1CalibrationFeedbackQueueItemsTagsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/queue-items/tags", ...options });

/**
 * Delete Calibration Feedback Queue Item V1
 */
export const delete_calibration_feedback_queue_item_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
    DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/queue-items/{queue_item_id}",
    ...options,
  });

/**
 * Get Calibration Feedback Queue Item V1
 */
export const get_calibration_feedback_queue_item_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
    GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/queue-items/{queue_item_id}",
    ...options,
  });

/**
 * Restore Calibration Feedback Queue Item V1
 */
export const restore_calibration_feedback_queue_item_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses,
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses,
    PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/queue-items/{queue_item_id}/restore",
    ...options,
  });

/**
 * Get Calibration Feedback Verdicts V1
 */
export const get_calibration_feedback_verdicts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1CalibrationFeedbackVerdictsData, ThrowOnError>,
): RequestResult<
  GetApiV1CalibrationFeedbackVerdictsResponses,
  GetApiV1CalibrationFeedbackVerdictsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackVerdictsResponses,
    GetApiV1CalibrationFeedbackVerdictsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/verdicts", ...options });

/**
 * Create Calibration Feedback Verdict V1
 */
export const create_calibration_feedback_verdict_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiV1CalibrationFeedbackVerdictsData, ThrowOnError>,
): RequestResult<
  PostApiV1CalibrationFeedbackVerdictsResponses,
  PostApiV1CalibrationFeedbackVerdictsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackVerdictsResponses,
    PostApiV1CalibrationFeedbackVerdictsErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/verdicts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Full Calibration Feedback Verdicts V1
 */
export const get_full_calibration_feedback_verdicts_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetApiV1CalibrationFeedbackFullVerdictsData, ThrowOnError>,
): RequestResult<
  GetApiV1CalibrationFeedbackFullVerdictsResponses,
  GetApiV1CalibrationFeedbackFullVerdictsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1CalibrationFeedbackFullVerdictsResponses,
    GetApiV1CalibrationFeedbackFullVerdictsErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/full-verdicts", ...options });

/**
 * Delete Calibration Feedback Verdict V1
 */
export const delete_calibration_feedback_verdict_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData,
    ThrowOnError
  >,
): RequestResult<
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
    DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/verdicts/{verdict_id}", ...options });

/**
 * Get Calibration Feedback Verdict V1
 */
export const get_calibration_feedback_verdict_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiV1CalibrationFeedbackVerdictsByVerdictIdData,
    ThrowOnError
  >,
): RequestResult<
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
    GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
    ThrowOnError
  >({ url: "/api/v1/calibration-feedback/verdicts/{verdict_id}", ...options });

/**
 * Update Calibration Feedback Verdict V1
 */
export const update_calibration_feedback_verdict_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData,
    ThrowOnError
  >,
): RequestResult<
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
    PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/verdicts/{verdict_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Restore Calibration Feedback Verdict V1
 */
export const restore_calibration_feedback_verdict_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData,
    ThrowOnError
  >,
): RequestResult<
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses,
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses,
    PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors,
    ThrowOnError
  >({
    url: "/api/v1/calibration-feedback/verdicts/{verdict_id}/restore",
    ...options,
  });

/**
 * Revoke Edra Access V1
 */
export const revoke_edra_access_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteApiV1SesameEdraAccessData, ThrowOnError>,
): RequestResult<
  DeleteApiV1SesameEdraAccessResponses,
  DeleteApiV1SesameEdraAccessErrors,
  ThrowOnError
> =>
  (options?.client ?? client).delete<
    DeleteApiV1SesameEdraAccessResponses,
    DeleteApiV1SesameEdraAccessErrors,
    ThrowOnError
  >({ url: "/api/v1/sesame/edra-access", ...options });

/**
 * Get Edra Access V1
 */
export const get_edra_access_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiV1SesameEdraAccessData, ThrowOnError>,
): RequestResult<
  GetApiV1SesameEdraAccessResponses,
  GetApiV1SesameEdraAccessErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiV1SesameEdraAccessResponses,
    GetApiV1SesameEdraAccessErrors,
    ThrowOnError
  >({ url: "/api/v1/sesame/edra-access", ...options });

/**
 * Update Edra Access V1
 */
export const update_edra_access_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PatchApiV1SesameEdraAccessData, ThrowOnError>,
): RequestResult<
  PatchApiV1SesameEdraAccessResponses,
  PatchApiV1SesameEdraAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PatchApiV1SesameEdraAccessResponses,
    PatchApiV1SesameEdraAccessErrors,
    ThrowOnError
  >({
    url: "/api/v1/sesame/edra-access",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Grant Edra Access V1
 */
export const grant_edra_access_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiV1SesameEdraAccessData, ThrowOnError>,
): RequestResult<
  PostApiV1SesameEdraAccessResponses,
  PostApiV1SesameEdraAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiV1SesameEdraAccessResponses,
    PostApiV1SesameEdraAccessErrors,
    ThrowOnError
  >({
    url: "/api/v1/sesame/edra-access",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Org Membership V1
 */
export const set_org_membership_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PutApiV1SesameOrgMembershipsData, ThrowOnError>,
): RequestResult<
  PutApiV1SesameOrgMembershipsResponses,
  PutApiV1SesameOrgMembershipsErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1SesameOrgMembershipsResponses,
    PutApiV1SesameOrgMembershipsErrors,
    ThrowOnError
  >({
    url: "/api/v1/sesame/org-memberships",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set Org Member Role V1
 */
export const set_org_member_role_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PutApiV1SesameOrgMemberRolesData, ThrowOnError>,
): RequestResult<
  PutApiV1SesameOrgMemberRolesResponses,
  PutApiV1SesameOrgMemberRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PutApiV1SesameOrgMemberRolesResponses,
    PutApiV1SesameOrgMemberRolesErrors,
    ThrowOnError
  >({
    url: "/api/v1/sesame/org-member-roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get A2A Agent Card V1
 */
export const get_a2a_agent_card_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiPublicV1AgentA2aByAgentKeyAgentData, ThrowOnError>,
): RequestResult<
  GetApiPublicV1AgentA2aByAgentKeyAgentResponses,
  GetApiPublicV1AgentA2aByAgentKeyAgentErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicV1AgentA2aByAgentKeyAgentResponses,
    GetApiPublicV1AgentA2aByAgentKeyAgentErrors,
    ThrowOnError
  >({ url: "/api/public/v1/agent-a2a/{agent_key}/agent", ...options });

/**
 * Freshservice Ingest Webhook V1
 */
export const freshservice_ingest_webhook_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPublicFreshserviceV1WebhooksByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicFreshserviceV1WebhooksByTenantIdResponses,
  PostApiPublicFreshserviceV1WebhooksByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicFreshserviceV1WebhooksByTenantIdResponses,
    PostApiPublicFreshserviceV1WebhooksByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/freshservice/v1/webhooks/{tenant_id}", ...options });

/**
 * Hubspot Ingest Webhook V1
 */
export const hubspot_ingest_webhook_v1 = <ThrowOnError extends boolean = false>(
  options: Options<PostApiPublicHubspotV1EventsByTenantIdData, ThrowOnError>,
): RequestResult<
  PostApiPublicHubspotV1EventsByTenantIdResponses,
  PostApiPublicHubspotV1EventsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicHubspotV1EventsByTenantIdResponses,
    PostApiPublicHubspotV1EventsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/hubspot/v1/events/{tenant_id}", ...options });

/**
 * Sharepoint Notifications V1
 */
export const sharepoint_notifications_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPublicSharepointV1NotificationsByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicSharepointV1NotificationsByTenantIdResponses,
  PostApiPublicSharepointV1NotificationsByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicSharepointV1NotificationsByTenantIdResponses,
    PostApiPublicSharepointV1NotificationsByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/sharepoint/v1/notifications/{tenant_id}", ...options });

/**
 * Sharepoint Lifecycle V1
 */
export const sharepoint_lifecycle_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicSharepointV1LifecycleByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicSharepointV1LifecycleByTenantIdResponses,
  PostApiPublicSharepointV1LifecycleByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicSharepointV1LifecycleByTenantIdResponses,
    PostApiPublicSharepointV1LifecycleByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/sharepoint/v1/lifecycle/{tenant_id}", ...options });

/**
 * Jira Handle Webhook Event V1
 */
export const jira_handle_webhook_event_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostApiPublicJiraV1EventsData, ThrowOnError>,
): RequestResult<PostApiPublicJiraV1EventsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostApiPublicJiraV1EventsResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/public/jira/v1/events", ...options });

/**
 * Notion Ingest Webhook V1
 */
export const notion_ingest_webhook_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicNotionV1WebhooksIngestByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicNotionV1WebhooksIngestByTenantIdResponses,
  PostApiPublicNotionV1WebhooksIngestByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicNotionV1WebhooksIngestByTenantIdResponses,
    PostApiPublicNotionV1WebhooksIngestByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/notion/v1/webhooks/ingest/{tenant_id}", ...options });

/**
 * Oauth Authorization Server Metadata V1
 */
export const oauth_authorization_server_metadata_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiPublicOauthV1WellKnownOauthAuthorizationServerData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses,
    unknown,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/.well-known/oauth-authorization-server",
    ...options,
  });

/**
 * Oauth Openid Configuration V1
 */
export const oauth_openid_configuration_v1 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetApiPublicOauthV1WellKnownOpenidConfigurationData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicOauthV1WellKnownOpenidConfigurationResponses,
  unknown,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    GetApiPublicOauthV1WellKnownOpenidConfigurationResponses,
    unknown,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/.well-known/openid-configuration",
    ...options,
  });

/**
 * Oauth Protected Resource Metadata V1
 */
export const oauth_protected_resource_metadata_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses,
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses,
    GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/.well-known/oauth-protected-resource/mcp/{toolset_key}",
    ...options,
  });

/**
 * Oauth Authorize V1
 */
export const oauth_authorize_v1 = <ThrowOnError extends boolean = false>(
  options: Options<GetApiPublicOauthV1AuthorizeData, ThrowOnError>,
): RequestResult<
  GetApiPublicOauthV1AuthorizeResponses,
  GetApiPublicOauthV1AuthorizeErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicOauthV1AuthorizeResponses,
    GetApiPublicOauthV1AuthorizeErrors,
    ThrowOnError
  >({ url: "/api/public/oauth/v1/authorize", ...options });

/**
 * Proxy Oauth Token V1
 */
export const proxy_oauth_token_v1 = <ThrowOnError extends boolean = false>(
  options?: Options<PostApiPublicOauthV1TokenData, ThrowOnError>,
): RequestResult<PostApiPublicOauthV1TokenResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<
    PostApiPublicOauthV1TokenResponses,
    unknown,
    ThrowOnError
  >({ url: "/api/public/oauth/v1/token", ...options });

/**
 * Proxy Oauth Application Openid Configuration V1
 */
export const proxy_oauth_application_openid_configuration_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationResponses,
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationResponses,
    GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/{oauth_application_id}/.well-known/openid-configuration",
    ...options,
  });

/**
 * Oauth Application Authorize V1
 */
export const oauth_application_authorize_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeResponses,
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicOauthV1ByOauthApplicationIdAuthorizeResponses,
    GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/{oauth_application_id}/authorize",
    ...options,
  });

/**
 * Proxy Oauth Application Token V1
 */
export const proxy_oauth_application_token_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPublicOauthV1ByOauthApplicationIdTokenData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicOauthV1ByOauthApplicationIdTokenResponses,
  PostApiPublicOauthV1ByOauthApplicationIdTokenErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicOauthV1ByOauthApplicationIdTokenResponses,
    PostApiPublicOauthV1ByOauthApplicationIdTokenErrors,
    ThrowOnError
  >({ url: "/api/public/oauth/v1/{oauth_application_id}/token", ...options });

/**
 * Proxy Oauth Application Userinfo V1
 */
export const proxy_oauth_application_userinfo_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPublicOauthV1ByOauthApplicationIdUserinfoData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoResponses,
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicOauthV1ByOauthApplicationIdUserinfoResponses,
    GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/{oauth_application_id}/userinfo",
    ...options,
  });

/**
 * Proxy Oauth Application Introspect V1
 */
export const proxy_oauth_application_introspect_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPublicOauthV1ByOauthApplicationIdIntrospectData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectResponses,
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicOauthV1ByOauthApplicationIdIntrospectResponses,
    PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors,
    ThrowOnError
  >({
    url: "/api/public/oauth/v1/{oauth_application_id}/introspect",
    ...options,
  });

/**
 * Outlook Subscription Event V2
 */
export const outlook_subscription_event_v2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PostApiPublicOutlookV2SubscriptionsEventsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicOutlookV2SubscriptionsEventsResponses,
  PostApiPublicOutlookV2SubscriptionsEventsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostApiPublicOutlookV2SubscriptionsEventsResponses,
    PostApiPublicOutlookV2SubscriptionsEventsErrors,
    ThrowOnError
  >({ url: "/api/public/outlook/v2/subscriptions/events", ...options });

/**
 * Outlook Subscription Lifecycle V2
 */
export const outlook_subscription_lifecycle_v2 = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PostApiPublicOutlookV2SubscriptionsLifecycleData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicOutlookV2SubscriptionsLifecycleResponses,
  PostApiPublicOutlookV2SubscriptionsLifecycleErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    PostApiPublicOutlookV2SubscriptionsLifecycleResponses,
    PostApiPublicOutlookV2SubscriptionsLifecycleErrors,
    ThrowOnError
  >({ url: "/api/public/outlook/v2/subscriptions/lifecycle", ...options });

/**
 * Plain Ingest Webhook V1
 */
export const plain_ingest_webhook_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicPlainV1WebhooksIngestByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicPlainV1WebhooksIngestByTenantIdResponses,
  PostApiPublicPlainV1WebhooksIngestByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicPlainV1WebhooksIngestByTenantIdResponses,
    PostApiPublicPlainV1WebhooksIngestByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/plain/v1/webhooks/ingest/{tenant_id}", ...options });

/**
 * Salesforce Oauth Token V1
 */
export const salesforce_oauth_token_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicV1SalesforceOauthTokenByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicV1SalesforceOauthTokenByTenantIdResponses,
  PostApiPublicV1SalesforceOauthTokenByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicV1SalesforceOauthTokenByTenantIdResponses,
    PostApiPublicV1SalesforceOauthTokenByTenantIdErrors,
    ThrowOnError
  >({
    ...urlSearchParamsBodySerializer,
    url: "/api/public/v1/salesforce/oauth/token/{tenant_id}",
    ...options,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options.headers,
    },
  });

/**
 * Salesforce Ingest Webhook V1
 */
export const salesforce_ingest_webhook_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPublicV1SalesforceWebhooksIngestByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses,
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses,
    PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors,
    ThrowOnError
  >({
    url: "/api/public/v1/salesforce/webhooks/ingest/{tenant_id}",
    ...options,
  });

/**
 * Service Now Handle Webhook V1
 */
export const service_now_handle_webhook_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostApiPublicServiceNowV1WebhooksData, ThrowOnError>,
): RequestResult<
  PostApiPublicServiceNowV1WebhooksResponses,
  PostApiPublicServiceNowV1WebhooksErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicServiceNowV1WebhooksResponses,
    PostApiPublicServiceNowV1WebhooksErrors,
    ThrowOnError
  >({ url: "/api/public/service-now/v1/webhooks", ...options });

/**
 * Slack Receive Event V2
 */
export const slack_receive_event_v2 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicSlackV2TenantsByTenantIdEventsData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicSlackV2TenantsByTenantIdEventsResponses,
  PostApiPublicSlackV2TenantsByTenantIdEventsErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicSlackV2TenantsByTenantIdEventsResponses,
    PostApiPublicSlackV2TenantsByTenantIdEventsErrors,
    ThrowOnError
  >({ url: "/api/public/slack/v2/tenants/{tenant_id}/events", ...options });

/**
 * Slack Receive Interactivity V2
 */
export const slack_receive_interactivity_v2 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostApiPublicSlackV2TenantsByTenantIdInteractivityData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses,
  PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses,
    PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors,
    ThrowOnError
  >({
    url: "/api/public/slack/v2/tenants/{tenant_id}/interactivity",
    ...options,
  });

/**
 * Teams Receive Message V1
 */
export const teams_receive_message_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses,
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses,
    PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors,
    ThrowOnError
  >({
    url: "/api/public/v1/teams/tenants/{tenant_id}/webhooks/messages",
    ...options,
  });

/**
 * Teams Openid Configuration V1
 */
export const teams_openid_configuration_v1 = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses,
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors,
    ThrowOnError
  >({
    url: "/api/public/teams/v1/tenants/{tenant_id}/.well-known/openid-configuration",
    ...options,
  });

/**
 * Teams Jwks V1
 */
export const teams_jwks_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData,
    ThrowOnError
  >,
): RequestResult<
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses,
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses,
    GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors,
    ThrowOnError
  >({
    url: "/api/public/teams/v1/tenants/{tenant_id}/.well-known/jwks.json",
    ...options,
  });

/**
 * Zendesk Ingest Webhook V1
 */
export const zendesk_ingest_webhook_v1 = <ThrowOnError extends boolean = false>(
  options: Options<
    PostApiPublicV1ZendeskWebhooksIngestByTenantIdData,
    ThrowOnError
  >,
): RequestResult<
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses,
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses,
    PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors,
    ThrowOnError
  >({ url: "/api/public/v1/zendesk/webhooks/ingest/{tenant_id}", ...options });

/**
 * Health
 */
export const health = <ThrowOnError extends boolean = false>(
  options?: Options<GetPublicHealthData, ThrowOnError>,
): RequestResult<GetPublicHealthResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetPublicHealthResponses,
    unknown,
    ThrowOnError
  >({ url: "/public/health", ...options });

/**
 * Get Edra Pb Openapi
 */
export const get_edra_pb_openapi = <ThrowOnError extends boolean = false>(
  options?: Options<GetEdraPbOpenapiJsonData, ThrowOnError>,
): RequestResult<GetEdraPbOpenapiJsonResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetEdraPbOpenapiJsonResponses,
    unknown,
    ThrowOnError
  >({ url: "/edra-pb-openapi.json", ...options });

/**
 * Get Sdk Openapi
 */
export const get_sdk_openapi = <ThrowOnError extends boolean = false>(
  options?: Options<GetSdkOpenapiJsonData, ThrowOnError>,
): RequestResult<GetSdkOpenapiJsonResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<
    GetSdkOpenapiJsonResponses,
    unknown,
    ThrowOnError
  >({ url: "/sdk-openapi.json", ...options });
